// Generated from contract/openapi.yaml — do not edit; run `npm run contract:clients`.
// Scope fan: types for the operations of its tag groups and for those frontend/web/src/services/api.js calls outside them (marked @see).
// At runtime (operations, pathOf): the ones frontend/web/src/services/api.js calls; a new call joins when the file is regenerated.

/** Part of the API base URL that the app's axios instance already ends in. */
export const API_PREFIX = '/api';

/**
 * operationId of every operation typed below; `operations` and pathOf hold the ones frontend/web/src/services/api.js calls.
 * @typedef {'analytics_events_create'|'assign_school_create'|'auth_apple_create'|'auth_apply_referral_code_create'|'auth_change_password_create'|'auth_check_email_exists_create'|'auth_check_email_invited_create'|'auth_delete_account_create'|'auth_forgot_password_create'|'auth_google_create'|'auth_login_create'|'auth_logout_create'|'auth_me_retrieve'|'auth_register_create'|'auth_reset_password_create'|'auth_token_refresh_create'|'content_active_retrieve'|'content_by_type_retrieve'|'content_create'|'content_destroy'|'content_featured_retrieve'|'content_images_create'|'content_images_destroy'|'content_images_list'|'content_images_partial_update'|'content_images_retrieve'|'content_images_update'|'content_increment_view_count_create'|'content_list'|'content_page_create'|'content_page_create_form'|'content_page_delete'|'content_page_delete_form'|'content_page_detail'|'content_page_edit'|'content_page_edit_form'|'content_page_image_delete'|'content_page_list'|'content_page_quick_create'|'content_page_quick_create_form'|'content_page_upload_image'|'content_page_upload_video'|'content_page_video_delete'|'content_partial_update'|'content_retrieve'|'content_update'|'content_upload_image_create'|'content_upload_video_create'|'content_videos_create'|'content_videos_destroy'|'content_videos_list'|'content_videos_partial_update'|'content_videos_retrieve'|'content_videos_update'|'embed_v1_rewards_dream_prizes_enter_create'|'embed_v1_rewards_dream_summary_retrieve'|'embed_v1_rewards_first_rewards_redeem_create'|'embed_v1_rewards_first_rewards_retrieve'|'embed_v1_rewards_first_rewards_retrieve_2'|'merchant_featured_offers_create'|'merchant_featured_offers_destroy'|'merchant_featured_offers_list'|'merchant_featured_offers_partial_update'|'merchant_featured_offers_retrieve'|'merchant_featured_offers_update'|'merchant_merchants_create'|'merchant_merchants_destroy'|'merchant_merchants_list'|'merchant_merchants_partial_update'|'merchant_merchants_retrieve'|'merchant_merchants_update'|'merchant_upload_offer_images_create'|'merchant_wildfire_offer_order_retrieve'|'merchant_wildfire_offer_order_update'|'merchants_page_retrieve'|'notifications_events_create'|'notifications_fcm_token_create'|'notifications_fcm_token_partial_update'|'notifications_history_resend_create'|'notifications_history_retrieve'|'notifications_history_retrieve_2'|'notifications_history_stats_retrieve'|'notifications_preview_create'|'notifications_send_mass_create'|'olive_addCardDirect_create'|'olive_addCard_create'|'olive_brands_retrieve'|'olive_checkAndActivateCard_create'|'olive_createMember_create'|'olive_createTestTransaction_create'|'olive_deactivateCard_create'|'olive_getTokenizationFields_create'|'olive_listCards_retrieve'|'olive_listTransactions_retrieve'|'olive_offers_retrieve'|'olive_offers_retrieve_2'|'olive_stores_snapshot_meta_retrieve'|'olive_stores_snapshot_retrieve'|'olive_testOlive_retrieve'|'olive_track_click_retrieve'|'payment_cards_create'|'payment_cards_list'|'payment_cards_partial_update'|'payment_cards_retrieve'|'picks_games_pick_create'|'picks_games_retrieve'|'picks_mine_retrieve'|'rewards_active_retrieve'|'rewards_auctions_bid_create'|'rewards_auctions_bids_retrieve'|'rewards_auctions_end_create'|'rewards_auctions_retrieve'|'rewards_badge_art_retrieve'|'rewards_badges_retrieve'|'rewards_badges_shares_create'|'rewards_card_draw_create'|'rewards_card_draw_retrieve'|'rewards_challenges_active_retrieve'|'rewards_challenges_match_accept_create'|'rewards_challenges_match_create'|'rewards_challenges_match_decline_create'|'rewards_challenges_match_nudge_create'|'rewards_challenges_match_remove_create'|'rewards_challenges_match_retrieve'|'rewards_challenges_retrieve'|'rewards_challenges_retrieve_2'|'rewards_challenges_users_retrieve'|'rewards_daily_entry_claim_create'|'rewards_daily_entry_decline_create'|'rewards_daily_login_create'|'rewards_dream_prizes_create'|'rewards_dream_prizes_destroy'|'rewards_dream_prizes_draw_create'|'rewards_dream_prizes_leaderboard_retrieve'|'rewards_dream_prizes_partial_update'|'rewards_dream_prizes_retrieve'|'rewards_dream_prizes_retrieve_2'|'rewards_dream_rules_retrieve'|'rewards_first_reward_redemptions_retrieve'|'rewards_first_reward_redemptions_status_partial_update'|'rewards_giveaways_active_retrieve'|'rewards_giveaways_retrieve'|'rewards_incentives_actions_create'|'rewards_incentives_analytics_retrieve'|'rewards_incentives_campaigns_create'|'rewards_incentives_campaigns_destroy'|'rewards_incentives_campaigns_retrieve'|'rewards_incentives_campaigns_retrieve_2'|'rewards_incentives_campaigns_update'|'rewards_incentives_history_retrieve'|'rewards_incentives_triggers_create'|'rewards_incentives_triggers_destroy'|'rewards_incentives_triggers_retrieve'|'rewards_incentives_triggers_retrieve_2'|'rewards_incentives_triggers_update'|'rewards_leaderboard_rewards_create'|'rewards_leaderboard_rewards_destroy'|'rewards_leaderboard_rewards_list'|'rewards_leaderboard_rewards_partial_update'|'rewards_leaderboard_rewards_retrieve'|'rewards_leaderboard_rewards_update'|'rewards_overall_prizes_create'|'rewards_overall_prizes_destroy'|'rewards_overall_prizes_leaderboard_retrieve'|'rewards_overall_prizes_partial_update'|'rewards_overall_prizes_retrieve'|'rewards_overall_prizes_retrieve_2'|'rewards_points_history_retrieve'|'rewards_raffle_entries_summary_retrieve'|'rewards_raffle_tickets_available_retrieve'|'rewards_raffle_tickets_list'|'rewards_raffle_tickets_retrieve'|'rewards_raffle_tickets_summary_retrieve'|'rewards_raffles_claim_free_entry_create'|'rewards_raffles_draw_create'|'rewards_raffles_entries_retrieve'|'rewards_raffles_retrieve'|'rewards_raffles_retrieve_2'|'rewards_redemptions_create'|'rewards_redemptions_destroy'|'rewards_redemptions_list'|'rewards_redemptions_partial_update'|'rewards_redemptions_retrieve'|'rewards_redemptions_update'|'rewards_rewards_add_images_create'|'rewards_rewards_create'|'rewards_rewards_destroy'|'rewards_rewards_list'|'rewards_rewards_partial_update'|'rewards_rewards_remove_images_destroy'|'rewards_rewards_retrieve'|'rewards_rewards_update'|'rewards_setup_task_rewards_claim_create'|'rewards_setup_task_rewards_retrieve'|'rewards_setup_task_rewards_sync_create'|'rewards_stripe_cancel_checkout_create'|'rewards_stripe_confirm_checkout_create'|'rewards_stripe_create_checkout_session_create'|'rewards_stripe_email_receipt_create'|'rewards_user_activity_retrieve'|'rewards_weekly_prizes_create'|'rewards_weekly_prizes_destroy'|'rewards_weekly_prizes_leaderboard_retrieve'|'rewards_weekly_prizes_partial_update'|'rewards_weekly_prizes_retrieve'|'rewards_weekly_prizes_retrieve_2'|'school_availability_emails_retrieve'|'school_availability_emails_send_create'|'school_availability_notify_create'|'school_data_portal_retrieve'|'school_data_portal_uploads_create'|'school_data_portal_uploads_destroy'|'school_merchant_interest_create'|'school_merchants_page_config_retrieve'|'school_onboarding_retrieve'|'school_public_schools_retrieve'|'school_reward_selections_retrieve'|'school_schedule_events_check_in_create'|'school_schedule_events_create'|'school_schedule_events_destroy'|'school_schedule_events_list'|'school_schedule_events_partial_update'|'school_schedule_events_photos_create'|'school_schedule_events_photos_retrieve'|'school_schedule_events_photos_winner_create'|'school_schedule_events_predict_create'|'school_schedule_events_predictions_retrieve'|'school_schedule_events_retrieve'|'school_schedule_events_squad_retrieve'|'school_schedule_events_tap_create'|'school_schedule_events_tap_enter_create'|'school_schedule_events_tap_reset_create'|'school_schedule_events_update'|'school_school_pay_mark_sent_create'|'school_school_pay_overview_retrieve'|'school_school_pay_unmark_sent_create'|'school_schools_achievement_badges_retrieve'|'school_schools_achievement_badges_update'|'school_schools_achievement_badges_upload_image_create'|'school_schools_create'|'school_schools_destroy'|'school_schools_embed_api_key_create'|'school_schools_embed_api_key_retrieve'|'school_schools_embed_api_key_rotate_create'|'school_schools_embed_appearance_email_selection_background_create'|'school_schools_embed_appearance_header_logo_create'|'school_schools_embed_appearance_login_background_create'|'school_schools_embed_appearance_partial_update'|'school_schools_embed_appearance_retrieve'|'school_schools_embed_appearance_welcome_screen_image_create'|'school_schools_first_rewards_retrieve'|'school_schools_first_rewards_update'|'school_schools_first_rewards_upload_image_create'|'school_schools_leaderboard_config_partial_update'|'school_schools_leaderboard_config_retrieve'|'school_schools_leaderboard_last_winner_retrieve'|'school_schools_list'|'school_schools_onboarding_checked_partial_update'|'school_schools_onboarding_partial_update'|'school_schools_partial_update'|'school_schools_retrieve'|'school_schools_reward_selections_partial_update'|'school_schools_season_tickets_retrieve'|'school_schools_season_tickets_update'|'school_schools_update'|'school_schools_upload_images_create'|'school_sport_schedules_create'|'school_sport_schedules_destroy'|'school_sport_schedules_list'|'school_sport_schedules_partial_update'|'school_sport_schedules_retrieve'|'school_sport_schedules_update'|'school_upcoming_events_retrieve'|'social_squads_activity_retrieve'|'social_squads_admin_retrieve'|'social_squads_create'|'social_squads_destroy'|'social_squads_game_winners_retrieve'|'social_squads_join_create'|'social_squads_leave_create'|'social_squads_members_destroy'|'social_squads_partial_update'|'social_squads_retrieve'|'social_squads_retrieve_2'|'social_squads_standings_retrieve'|'social_twitter_feed_retrieve'|'token_create'|'token_refresh_create'|'transactions_create'|'transactions_destroy'|'transactions_list'|'transactions_partial_update'|'transactions_retrieve'|'transactions_update'|'travel_embed_retrieve'|'travel_session_create'|'users_check_in_create'|'users_check_in_locations_retrieve'|'users_contact_support_create'|'users_fan_emails_unsubscribe_create'|'users_fan_emails_unsubscribe_retrieve'|'users_leaderboard_retrieve'|'users_managed_docs_embedding_retrieve'|'users_managed_links_retrieve'|'users_public_profile_retrieve'|'users_referral_leaderboard_retrieve'|'users_resend_verification_email_create'|'users_support_thread_read_create'|'users_support_thread_reply_create'|'users_support_thread_retrieve'|'users_upload_receipt_create'|'users_user_schools_create'|'users_user_schools_destroy'|'users_user_schools_list'|'users_user_schools_partial_update'|'users_user_schools_retrieve'|'users_user_schools_update'|'users_users_assign_school_create'|'users_users_create'|'users_users_destroy'|'users_users_invite_friend_create'|'users_users_list'|'users_users_partial_update'|'users_users_points_summary_retrieve'|'users_users_profile_partial_update'|'users_users_profile_retrieve'|'users_users_referral_campaign_retrieve'|'users_users_referral_summary_retrieve'|'users_users_retrieve'|'users_users_update'|'users_verify_email_create'|'wildfire_merchant_retrieve'|'wildfire_offers_retrieve'|'wildfire_redirect_retrieve'|'wildfire_track_click_retrieve'|'wildfire_warm_device_retrieve'} OperationId
 */

export const operations = {
  /** Choose the active school and run school sign-up rewards */
  assign_school_create: { method: 'POST', path: '/api/assign-school/' },
  /** Sign in or sign up with Apple */
  auth_apple_create: { method: 'POST', path: '/api/auth/apple/' },
  /** Change the password */
  auth_change_password_create: { method: 'POST', path: '/api/auth/change-password/' },
  /** Delete the account */
  auth_delete_account_create: { method: 'POST', path: '/api/auth/delete-account/' },
  /** Request a password reset email */
  auth_forgot_password_create: { method: 'POST', path: '/api/auth/forgot-password/' },
  /** Sign in or sign up with Google */
  auth_google_create: { method: 'POST', path: '/api/auth/google/' },
  /** Sign in with email and password */
  auth_login_create: { method: 'POST', path: '/api/auth/login/' },
  /** The signed-in fan */
  auth_me_retrieve: { method: 'GET', path: '/api/auth/me/' },
  /** Create an account */
  auth_register_create: { method: 'POST', path: '/api/auth/register/' },
  /** Set a new password from a reset link */
  auth_reset_password_create: { method: 'POST', path: '/api/auth/reset-password/' },
  /** Enter a bonus drop @see called by this app outside its scope */
  embed_v1_rewards_dream_prizes_enter_create: {
    method: 'POST',
    path: '/api/embed/v1/rewards/dream/prizes/{prize_id}/enter/',
  },
  /** Dream program of the signed-in fan @see called by this app outside its scope */
  embed_v1_rewards_dream_summary_retrieve: {
    method: 'GET',
    path: '/api/embed/v1/rewards/dream/summary/',
  },
  /** Claim a first-reward rung @see called by this app outside its scope */
  embed_v1_rewards_first_rewards_redeem_create: {
    method: 'POST',
    path: '/api/embed/v1/rewards/first-rewards/{reward_id}/redeem/',
  },
  /** First-reward ladder @see called by this app outside its scope */
  embed_v1_rewards_first_rewards_retrieve: {
    method: 'GET',
    path: '/api/embed/v1/rewards/first-rewards/',
  },
  /** One first-reward rung @see called by this app outside its scope */
  embed_v1_rewards_first_rewards_retrieve_2: {
    method: 'GET',
    path: '/api/embed/v1/rewards/first-rewards/{reward_id}/',
  },
  /** Featured offers for the fan's school */
  merchant_featured_offers_list: { method: 'GET', path: '/api/merchant/featured-offers/' },
  /** Enrol a card from raw card details */
  olive_addCardDirect_create: { method: 'POST', path: '/api/olive/addCardDirect' },
  /** Create the fan's payment-provider member */
  olive_createMember_create: { method: 'POST', path: '/api/olive/createMember' },
  /** Deactivate a card */
  olive_deactivateCard_create: { method: 'POST', path: '/api/olive/deactivateCard' },
  /** The fan's purchases for the activity list */
  olive_listTransactions_retrieve: { method: 'GET', path: '/api/olive/listTransactions' },
  /** Olive offers for the shop */
  olive_offers_retrieve: { method: 'GET', path: '/api/olive/offers/' },
  /** One Olive offer */
  olive_offers_retrieve_2: { method: 'GET', path: '/api/olive/offers/{offer_id}/' },
  /** Get the tracked link for an Olive click offer */
  olive_track_click_retrieve: { method: 'GET', path: '/api/olive/track-click/' },
  payment_cards_list: { method: 'GET', path: '/api/payment-cards/' },
  /** Place a bid */
  rewards_auctions_bid_create: { method: 'POST', path: '/api/rewards/auctions/{auction_id}/bid/' },
  /** Badges of the signed-in fan */
  rewards_badges_retrieve: { method: 'GET', path: '/api/rewards/badges/' },
  /** Official rules of a school's Dream program */
  rewards_dream_rules_retrieve: { method: 'GET', path: '/api/rewards/dream/rules/{school_id}/' },
  /** Redeem a reward */
  rewards_redemptions_create: { method: 'POST', path: '/api/rewards/redemptions/' },
  /** Active rewards of the signed-in user's school plus the global test raffle, and inactive ones: raffles whose drawing date is no more than 180 days ago... */
  rewards_rewards_list: { method: 'GET', path: '/api/rewards/rewards/' },
  /** A reward the caller can see: one of their school's, or the global test raffle. Unlike the list, gift cards are not hidden here. */
  rewards_rewards_retrieve: { method: 'GET', path: '/api/rewards/rewards/{id}/' },
  /** Claim a setup task reward */
  rewards_setup_task_rewards_claim_create: {
    method: 'POST',
    path: '/api/rewards/setup-task-rewards/claim/',
  },
  /** Setup task reward amounts */
  rewards_setup_task_rewards_retrieve: { method: 'GET', path: '/api/rewards/setup-task-rewards/' },
  /** Sync setup task rewards */
  rewards_setup_task_rewards_sync_create: {
    method: 'POST',
    path: '/api/rewards/setup-task-rewards/sync/',
  },
  /** Confirm an embedded card payment */
  rewards_stripe_confirm_checkout_create: {
    method: 'POST',
    path: '/api/rewards/stripe/confirm-checkout/',
  },
  /** Start a card checkout */
  rewards_stripe_create_checkout_session_create: {
    method: 'POST',
    path: '/api/rewards/stripe/create-checkout-session/',
  },
  /** Email an experience receipt */
  rewards_stripe_email_receipt_create: {
    method: 'POST',
    path: '/api/rewards/stripe/email-receipt/',
  },
  /** Recent activity */
  rewards_user_activity_retrieve: { method: 'GET', path: '/api/rewards/user/activity/' },
  /** Branding for a school's merchants page */
  school_merchants_page_config_retrieve: {
    method: 'GET',
    path: '/api/school/merchants-page-config/{school_id}/',
  },
  /** Schools to pick from */
  school_public_schools_retrieve: { method: 'GET', path: '/api/school/public-schools/' },
  /** Check in at a game */
  school_schedule_events_check_in_create: {
    method: 'POST',
    path: '/api/school/schedule-events/{id}/check-in/',
  },
  /** Games on a schedule */
  school_schedule_events_list: { method: 'GET', path: '/api/school/schedule-events/' },
  /** Predict a game's score */
  school_schedule_events_predict_create: {
    method: 'POST',
    path: '/api/school/schedule-events/{id}/predict/',
  },
  /** Prediction results of a finished game */
  school_schedule_events_predictions_retrieve: {
    method: 'GET',
    path: '/api/school/schedule-events/{id}/predictions/',
  },
  /** What the fan's squad did on a game */
  school_schedule_events_squad_retrieve: {
    method: 'GET',
    path: '/api/school/schedule-events/{id}/squad/',
  },
  /** Sports on a school's schedule */
  school_sport_schedules_list: { method: 'GET', path: '/api/school/sport-schedules/' },
  /** Recent points earned by a squad */
  social_squads_activity_retrieve: {
    method: 'GET',
    path: '/api/social/squads/{squad_id}/activity/',
  },
  /** Create a squad */
  social_squads_create: { method: 'POST', path: '/api/social/squads/' },
  /** Delete a squad (admin only) */
  social_squads_destroy: { method: 'DELETE', path: '/api/social/squads/{squad_id}/' },
  /** Who in each of the fan's squads came closest on each finished game */
  social_squads_game_winners_retrieve: { method: 'GET', path: '/api/social/squads/game-winners/' },
  /** Join a squad by code */
  social_squads_join_create: { method: 'POST', path: '/api/social/squads/join/' },
  /** Leave a squad */
  social_squads_leave_create: { method: 'POST', path: '/api/social/squads/{squad_id}/leave/' },
  /** Remove a member (admin only) */
  social_squads_members_destroy: {
    method: 'DELETE',
    path: '/api/social/squads/{squad_id}/members/{user_id}/',
  },
  /** Edit a squad (admin only) */
  social_squads_partial_update: { method: 'PATCH', path: '/api/social/squads/{squad_id}/' },
  /** Squads the fan belongs to */
  social_squads_retrieve: { method: 'GET', path: '/api/social/squads/' },
  /** One squad */
  social_squads_retrieve_2: { method: 'GET', path: '/api/social/squads/{squad_id}/' },
  /** Exchange a refresh token for a new token pair */
  token_refresh_create: { method: 'POST', path: '/api/token/refresh/' },
  /** Start a travel booking session */
  travel_session_create: { method: 'POST', path: '/api/travel/session/' },
  /** Weekly leaderboard of the fan's school */
  users_leaderboard_retrieve: { method: 'GET', path: '/api/users/leaderboard/' },
  /** Public profile of a fan */
  users_public_profile_retrieve: { method: 'GET', path: '/api/users/public-profile/{fan_id}/' },
  /** Resend the verification email */
  users_resend_verification_email_create: {
    method: 'POST',
    path: '/api/users/resend-verification-email/',
  },
  /** Mark the support chat as read */
  users_support_thread_read_create: { method: 'POST', path: '/api/users/support-thread/read/' },
  /** Reply in the support chat */
  users_support_thread_reply_create: { method: 'POST', path: '/api/users/support-thread/reply/' },
  /** The fan's support chat */
  users_support_thread_retrieve: { method: 'GET', path: '/api/users/support-thread/' },
  /** Points and recent purchases of a fan */
  users_users_points_summary_retrieve: {
    method: 'GET',
    path: '/api/users/users/{id}/points_summary/',
  },
  /** Update the signed-in fan's profile */
  users_users_profile_partial_update: { method: 'PATCH', path: '/api/users/users/profile/' },
  /** The signed-in fan's profile */
  users_users_profile_retrieve: { method: 'GET', path: '/api/users/users/profile/' },
  /** Referral campaign for the signed-in fan */
  users_users_referral_campaign_retrieve: {
    method: 'GET',
    path: '/api/users/users/referral-campaign/',
  },
  /** Referral code and joined friends of the signed-in fan */
  users_users_referral_summary_retrieve: {
    method: 'GET',
    path: '/api/users/users/referral-summary/',
  },
  /** Verify an email address */
  users_verify_email_create: { method: 'POST', path: '/api/users/verify-email/' },
  /** One Wildfire merchant with its rates */
  wildfire_merchant_retrieve: { method: 'GET', path: '/api/wildfire/merchant/' },
  /** Wildfire online merchants */
  wildfire_offers_retrieve: { method: 'GET', path: '/api/wildfire/offers/' },
  /** Get the affiliate link for a Wildfire merchant */
  wildfire_track_click_retrieve: { method: 'GET', path: '/api/wildfire/track-click/' },
};

/** @type {Object<string, { method: string, path: string }>} */
const operationsById = operations;

/**
 * @param {object} object
 * @param {string} key
 * @returns {boolean}
 */
const hasOwn = (object, key) => Object.prototype.hasOwnProperty.call(object, key);

/**
 * Path of an operation for the app's axios instance, whose base URL ends in API_PREFIX.
 * Path parameters are URL-encoded; a missing one throws, as does an operation this
 * file holds no path for (regenerate it after adding a call: npm hooks do it on start).
 *
 * @param {OperationId} operationId
 * @param {Object<string, string|number>} [params] path parameters by name, e.g. `{ fan_id: id }`
 * @param {{ full?: boolean }} [options] `full`: keep API_PREFIX, for a request made without the
 *   axios base URL (the only way to reach an operation outside API_PREFIX)
 * @returns {string}
 */
export function pathOf(operationId, params = {}, options = {}) {
  if (!hasOwn(operationsById, operationId)) {
    throw new Error(`Unknown API operation: ${operationId}`);
  }
  const path = operationsById[operationId].path.replace(/\{([^}]+)\}/g, (match, name) => {
    const value = params && hasOwn(params, name) ? params[name] : undefined;
    if (value === undefined || value === null || value === '') {
      throw new Error(`${operationId}: missing path parameter ${name}`);
    }
    return encodeURIComponent(String(value));
  });
  if (options.full) {
    return path;
  }
  if (!path.startsWith(`${API_PREFIX}/`)) {
    throw new Error(`${operationId} is outside ${API_PREFIX}: call pathOf with { full: true }`);
  }
  return path.slice(API_PREFIX.length);
}

// Component schemas these operations use.

/**
 * @typedef {Object} AuthAppleRequest
 * @property {string} identity_token
 * @property {string} [first_name]
 * @property {string} [last_name]
 * @property {string} [referral_code]
 * @property {Object<string, *>} [client_context]
 */

/**
 * @typedef {Object} AuthApplyReferralCodeRequest
 * @property {string} referral_code Letters and digits only; case-insensitive.
 */

/**
 * @typedef {Object} AuthApplyReferralCodeResult
 * @property {boolean} success
 * @property {UsersFan} user
 */

/**
 * @typedef {Object} AuthChangePasswordRequest
 * @property {string} [current_password] Required when the fan already has a password.
 * @property {string} new_password
 * @property {string} [school_id] Brands the notification email.
 */

/**
 * Result of the daily login bonus check. The fields after `dream_entries_awarded` appear when a bonus was paid out.
 * @typedef {Object} AuthDailyLoginBonus
 * @property {number} points_awarded
 * @property {boolean} [already_claimed]
 * @property {string} [message]
 * @property {number} [dream_entries_awarded] Always 0, the day's Dream entries are offered in `daily_entry_offer`. Absent while the school's `revamp_v2` is off, as on master; the same as...
 * @property {RewardsDailyEntryOffer|Object<string, *>|null} [daily_entry_offer] The day's Dream entries the fan can claim now; the same as `daily_bonus.daily_entry_offer` of `POST /api/rewards/daily-login/`. Absent while the school's...
 * @property {number} [tickets_awarded]
 * @property {number} [entries_awarded]
 * @property {Array<string>} [raffle_titles]
 * @property {string} [campaign_name]
 * @property {string} [incentive_type] points, raffle_entry or raffle_ticket. Never dream_entries, the Dream entries of the day are claimed (`daily_entry_offer`).
 * @property {Array<UsersClaimableRaffle>} [eligible_raffles] Free school raffles the fan can claim now.
 * @property {Array<DreamBonusDropPrompt>} [bonus_drops] Open bonus drops the fan can enter, the soonest to close first. Empty while the school's `revamp_v2` is off; absent only when recording the visit failed.
 */

/**
 * @typedef {Object} AuthDeleteAccountRequest
 * @property {string} password
 */

/**
 * @typedef {Object} AuthEmailExists
 * @property {boolean} email_exists
 */

/**
 * @typedef {Object} AuthEmailInvited
 * @property {boolean} email_already_invited
 */

/**
 * @typedef {Object} AuthEmailRequest
 * @property {string} [email]
 */

/**
 * @typedef {Object} AuthForgotPasswordRequest
 * @property {string} email
 * @property {string} [school_id]
 * @property {string} [wildfire_app_id]
 * @property {string} [client_surface] `embed` makes the reset link point to the embed.
 */

/**
 * @typedef {Object} AuthGoogleRequest
 * @property {string} id_token
 * @property {boolean} [accepted_terms_and_policies]
 * @property {string} [referral_code]
 * @property {Object<string, *>} [client_context]
 */

/**
 * @typedef {Object} AuthLoginRequest
 * @property {string} email
 * @property {string} password
 * @property {string} [fcm_token] Push token of the device. `token` is accepted as an alias.
 * @property {'ios'|'android'} [platform]
 * @property {string} [device_id]
 * @property {Object<string, *>} [client_context] Optional client details recorded with the login.
 * @property {boolean} [admin_portal] Set by the admin portal; the sign-in then needs a portal role.
 */

/**
 * @typedef {Object} AuthLogoutRequest
 * @property {string} fcm_token `token` is accepted as an alias.
 */

/**
 * @typedef {Object} AuthLogoutResult
 * @property {boolean} success
 * @property {number} deleted Registrations removed.
 */

/**
 * @typedef {Object} AuthMessage
 * @property {string} message
 */

/**
 * @typedef {Object} AuthPasswordChanged
 * @property {string} message
 * @property {UsersFan} user
 * @property {AuthTokens} tokens
 */

/**
 * Optional device fields; the device is registered only with a token and a platform.
 * @typedef {Object} AuthPushDevice
 * @property {string} [fcm_token] Push token of the device; `token` is accepted too.
 * @property {string} [token] Alias of `fcm_token`.
 * @property {'ios'|'android'} [platform]
 * @property {string} [device_id]
 */

/**
 * @typedef {Object} AuthRegisterRequest
 * @property {string} email
 * @property {string} first_name
 * @property {string} last_name
 * @property {string} password
 * @property {string} password_confirm
 * @property {boolean} accepted_terms_and_policies Must be true.
 * @property {string} [school_id] Becomes the active school.
 * @property {string} [school_domain] Legacy; accepted and ignored.
 * @property {string} [referral_code] Letters and digits only.
 * @property {RegistrationSourceEnum} [registration_source]
 * @property {Object<string, *>} [client_context]
 */

/**
 * @typedef {Object} AuthResetPasswordRequest
 * @property {string} uid
 * @property {string} token
 * @property {string} new_password
 * @property {string} [school_id]
 */

/**
 * @typedef {Object} AuthSession
 * @property {UsersFan} user
 * @property {AuthTokens} tokens
 * @property {AuthDailyLoginBonus} [daily_login_bonus]
 */

/**
 * @typedef {Object} AuthTokens
 * @property {string} access
 * @property {string} refresh
 */

/**
 * Who gets the notification. `emails` or `user_ids` win when given; otherwise
 * @typedef {Object} ContentAudience
 * @property {Array<string>} [school_ids]
 * @property {Array<string>} [emails]
 * @property {Array<string>} [user_ids]
 */

/**
 * @typedef {Object} ContentDevice
 * @property {string} id
 * @property {string} user
 * @property {string} fcm_token
 * @property {string|null} device_id
 * @property {'ios'|'android'} platform
 * @property {boolean} notifications_enabled
 * @property {boolean} is_active
 * @property {string} created_at
 * @property {string} updated_at
 */

/**
 * @typedef {Object} ContentDeviceRegistration
 * @property {string} token Firebase token of the device.
 * @property {'ios'|'android'} platform
 * @property {string|null} [device_id] Installation id of the app.
 * @property {string} [old_token] The token this device had before; it is replaced by `token`.
 * @property {boolean} [notifications_enabled]
 */

/**
 * @typedef {Object} ContentImage
 * @property {string} id
 * @property {string} image_path S3 path generated by AWS
 * @property {string} [alt_text] Alternative text for accessibility
 * @property {number} [order] Display order (0 = first image)
 * @property {boolean} [is_primary] Primary/featured image for this content
 * @property {string} [caption] Optional image caption
 */

/**
 * @typedef {Object} ContentImageRequest
 * @property {string} image_path S3 path generated by AWS
 * @property {string} [alt_text] Alternative text for accessibility
 * @property {number} [order] Display order (0 = first image)
 * @property {boolean} [is_primary] Primary/featured image for this content
 * @property {string} [caption] Optional image caption
 */

/**
 * @typedef {Object} ContentItem
 * @property {string} id
 * @property {string} title
 * @property {string} [subtitle] Optional subtitle or tagline
 * @property {string} slug
 * @property {ContentTypeEnum} content_type
 * @property {string} description Content description
 * @property {string} school
 * @property {string} school_name
 * @property {Status11fEnum} [status]
 * @property {boolean} [featured]
 * @property {number} [priority] Higher numbers appear first
 * @property {number} [view_count] Number of times this content has been viewed
 * @property {string|null} [featured_image]
 * @property {string|null} [video_url] Optional video URL (YouTube, Vimeo, etc.)
 * @property {string|null} [publish_date]
 * @property {string|null} [expiration_date] Optional expiration date
 * @property {Array<ContentVideo>} videos
 * @property {Array<ContentImage>} images
 * @property {string|null} [created_by]
 * @property {string} created_by_name
 * @property {string|null} [updated_by]
 * @property {string} updated_by_name
 * @property {string} created_at
 * @property {string} updated_at
 */

/**
 * Serializer for creating content items
 * @typedef {Object} ContentItemCreate
 * @property {string} title
 * @property {string} [subtitle] Optional subtitle or tagline
 * @property {string} slug
 * @property {ContentTypeEnum} content_type
 * @property {string} description Content description
 * @property {string} school
 * @property {Status11fEnum} [status]
 * @property {boolean} [featured]
 * @property {number} [priority] Higher numbers appear first
 * @property {string|null} [featured_image]
 * @property {string|null} [video_url] Optional video URL (YouTube, Vimeo, etc.)
 * @property {string|null} [publish_date]
 * @property {string|null} [expiration_date] Optional expiration date
 */

/**
 * Serializer for creating content items
 * @typedef {Object} ContentItemCreateRequest
 * @property {string} title
 * @property {string} [subtitle] Optional subtitle or tagline
 * @property {string} slug
 * @property {ContentTypeEnum} content_type
 * @property {string} description Content description
 * @property {string} school
 * @property {Status11fEnum} [status]
 * @property {boolean} [featured]
 * @property {number} [priority] Higher numbers appear first
 * @property {string|null} [featured_image]
 * @property {string|null} [video_url] Optional video URL (YouTube, Vimeo, etc.)
 * @property {string|null} [publish_date]
 * @property {string|null} [expiration_date] Optional expiration date
 */

/**
 * @typedef {Object} ContentItemRequest
 * @property {string} title
 * @property {string} [subtitle] Optional subtitle or tagline
 * @property {string} slug
 * @property {ContentTypeEnum} content_type
 * @property {string} description Content description
 * @property {string} school
 * @property {Status11fEnum} [status]
 * @property {boolean} [featured]
 * @property {number} [priority] Higher numbers appear first
 * @property {number} [view_count] Number of times this content has been viewed
 * @property {string|null} [featured_image]
 * @property {string|null} [video_url] Optional video URL (YouTube, Vimeo, etc.)
 * @property {string|null} [publish_date]
 * @property {string|null} [expiration_date] Optional expiration date
 * @property {string|null} [created_by]
 * @property {string|null} [updated_by]
 */

/**
 * @typedef {ContentAudience & {title: string, body: string, data?: Object<string, *>}} ContentNotificationDraft
 */

/**
 * @typedef {Object} ContentNotificationHistory
 * @property {string} id
 * @property {string} sent_at
 * @property {'push'|'email'} notification_type
 * @property {string} title
 * @property {string} body
 * @property {string|null} template_name
 * @property {'all_users'|'school'|'specific_users'} audience_type
 * @property {Object<string, *>} audience_value `school_ids`, `emails` and/or `user_ids`, depending on the audience.
 * @property {string} audience_display
 * @property {'pending'|'sent'|'failed'|'partially_sent'} status
 * @property {number} recipient_count
 * @property {number} success_count
 * @property {number} failure_count
 * @property {number|null} delivered_count
 * @property {number|null} opened_count
 * @property {number} opened_count_computed Distinct fans with an `open` event.
 * @property {Object<string, *>} payload
 * @property {Array<string>} errors
 * @property {Object<string, number>} platform_split
 * @property {Array<*>} recipient_sample
 * @property {Array<*>} delivered_recipients
 * @property {Array<*>} failed_recipients
 * @property {string|null} sent_by
 * @property {string|null} sent_by_email
 */

/**
 * @typedef {ContentNotificationHistory & {recipients_preview: Array<ContentRecipient>, recipients_total: number, recipients_truncated: boolean}} ContentNotificationHistoryDetail
 */

/**
 * @typedef {Object} ContentNotificationStats
 * @property {Array<{day: string, sent_count: number, success_count: number|null, opened_count: number|null}>} by_day
 * @property {{total_sent: number, total_success: number|null, total_failure: number|null, total_opened: number|null}} total
 * @property {Array<{id: string, title: string, sent_at: string, success_count: number, failure_count: number, opened_count: number|null}>} top_by_engagement
 */

/**
 * @typedef {Object} ContentRecipient
 * @property {string} user_id
 * @property {string} full_name Falls back to the email, then the id, when the fan has no name.
 * @property {string} school_name Empty when the fan has no active school.
 */

/**
 * @typedef {Object} ContentSendResult
 * @property {boolean} success
 * @property {string} message
 * @property {string} [history_id] Only when a school-available email was resent.
 * @property {Object<string, *>} result Delivery counts of the send (push: `success`, `failure`, `total_devices`,
 */

/**
 * * `interview` - Interview
 * @typedef {'interview'|'content'|'announcement'} ContentTypeEnum
 */

/**
 * @typedef {Object} ContentVideo
 * @property {string} id
 * @property {string} video_path S3 path generated by AWS
 * @property {string} [title] Video title or description
 * @property {number} [order] Display order (0 = first video)
 * @property {boolean} [is_primary] Primary/featured video for this content
 * @property {string|null} [duration] Video duration
 * @property {string} [thumbnail_path] S3 path to video thumbnail
 */

/**
 * @typedef {Object} ContentVideoRequest
 * @property {string} video_path S3 path generated by AWS
 * @property {string} [title] Video title or description
 * @property {number} [order] Display order (0 = first video)
 * @property {boolean} [is_primary] Primary/featured video for this content
 * @property {string|null} [duration] Video duration
 * @property {string} [thumbnail_path] S3 path to video thumbnail
 */

/**
 * @typedef {Object} CustomTokenObtainPairRequest
 * @property {string} email
 * @property {string} password
 */

/**
 * A bonus drop the fan can enter now, for the prompt shown when the app opens.
 * @typedef {Object} DreamBonusDropPrompt
 * @property {string} prize_id
 * @property {string} title
 * @property {string} description
 * @property {string} cover_image The drop's cover, else its leaderboard reward's; empty when neither has one.
 * @property {string|null} closes_at When the drop closes (`end_at`).
 * @property {string|null} dream_period_id
 */

/**
 * @typedef {Object} DreamBoost
 * @property {string} id
 * @property {2|5|8|10} multiplier Purchases earn their entries times this; `floor(dollars / entry_dollars)` first.
 * @property {string} title First line of the boost banner. Empty keeps the NX entries today line.
 * @property {boolean} show_image Show the prize draw image on the boost banner.
 * @property {'global'|'school'|'merchant'} scope `global`: every school; `school`: the fan's school; `merchant`: purchases
 * @property {DreamBoostMerchant|null} merchant Only on `scope` merchant; null otherwise.
 * @property {string} starts_at Midnight in the school's zone (America/Denver by default) that starts the first day, in UTC.
 * @property {string} ends_at Midnight in the school's zone (America/Denver by default) after the last day, in UTC; "Ends in ..." counts to it.
 */

/**
 * @typedef {Object} DreamBoostMerchant
 * @property {'olive'|'wildfire'|'travel'|'attraction'} source
 * @property {string} merchant_id Keyed as `pointMultiplier` is: the Olive `offerId`, the Wildfire
 * @property {string} merchant_name
 */

/**
 * The triggers a Dream entries campaign runs on.
 * @typedef {'signup'|'daily_login'|'referral_signup'|'survey_complete'} DreamEntryCampaignTriggerEnum
 */

/**
 * @typedef {DreamSummaryPrize & {kind: 'period', entries: number, countdown_target?: string}} DreamFeaturedDraw
 */

/**
 * @typedef {Object} DreamPrizeAdmin
 * @property {string} id
 * @property {string} title
 * @property {string} giveaway_type merchandise, apparel, experience, collectibles, tickets, gift_card or other.
 * @property {string} description
 * @property {string} how_to_win
 * @property {string} location
 * @property {string} terms
 * @property {string} cover_image
 * @property {string|null} cover_image_url
 * @property {string} cover_title
 * @property {string} cover_text
 * @property {Array<DreamPrizeAdminImage>} images The gallery the fan sees.
 * @property {Array<DreamPrizeAdminImage>} gallery Every image, crop variants included.
 * @property {string} school
 * @property {string} school_name
 * @property {string|null} reward The linked leaderboard reward (images and crop live there).
 * @property {string} [reward_title] Present only when a reward is linked.
 * @property {string|null} start_at Opens. Authoritative UTC instant.
 * @property {string|null} end_at Closes. Authoritative UTC instant. A period prize or bonus drop is drawn
 * @property {string} start_date
 * @property {string} end_date
 * @property {string|null} start_time
 * @property {string|null} end_time
 * @property {string|null} winner
 * @property {string|null} winner_name
 * @property {string|null} winner_email
 * @property {number|null} winning_points
 * @property {boolean} is_active False once drawn, or ended without a draw (`is_active=false` sent). An
 * @property {boolean} is_featured
 * @property {Object<string, *>} metadata
 * @property {string} created_at
 * @property {string} updated_at
 * @property {string|null} dream_period The entry pool the prize draws on.
 * @property {'top_points'|'entry_draw'} selection_method top_points is the old season prize; entry_draw is a weighted draw on entries.
 * @property {'period'|'bonus_drop'} draw_kind
 * @property {number} position Client order of prizes in one window.
 * @property {boolean} requires_opt_in Bonus drops only. Only fans who tapped Enter are in the draw.
 * @property {string|null} announce_at Bonus drops only, at or before `start_at`: from this instant until the
 * @property {number|null} winning_entries Entries the winner held at the moment of the draw.
 * @property {number} opt_in_count Fans who tapped Enter.
 * @property {DreamPrizeAdminDraw} draw
 * @property {string} [notice] Only on a save that created a prize draw's pool over past time or moved a
 * @property {string|null} owner Who hands the prize out and gets its reminders, a staff member of its school or a superuser.
 * @property {string} owner_name The owner's full name (or email); empty without an owner.
 * @property {string|null} prize_value What the prize is worth in USD (ARV), two decimals. At $600 or more the won prize needs a W-9 before it is fulfilled.
 * @property {boolean} w9_collected Whether the winner's W-9 is recorded.
 * @property {string|null} w9_collected_at
 * @property {Array<'owner'|'owner_inactive'|'prize_value'|'w9'>} action_required What still needs doing. Before the prize is won, its missing `owner` (`owner_inactive` when the owner is no longer active or staff of the school) and...
 */

/**
 * The draw audit; null until an entry draw picks a winner.
 * @typedef {{id: string, drawn_at: string, drawn_by: string|null, drawn_by_name: string|null, winner: string, winner_name: string, pool_size: number, total_entries: number, winning_index: number, pool_fingerprint: string, rng_source: string}|null} DreamPrizeAdminDraw
 */

/**
 * @typedef {Object} DreamPrizeAdminImage
 * @property {string|null} id Null for the cover of a prize with no linked reward gallery.
 * @property {string} image_path
 * @property {string|null} image_url
 * @property {number} order
 * @property {Object<string, *>} [crop]
 */

/**
 * @typedef {Object} DreamPrizeAdminList
 * @property {Array<DreamPrizeAdmin>} results
 * @property {number} count
 */

/**
 * Writable prize fields; `school` is the caller's active school.
 * @typedef {Object} DreamPrizeAdminRequest
 * @property {string} [title]
 * @property {'merchandise'|'apparel'|'experience'|'collectibles'|'tickets'|'gift_card'|'other'} [giveaway_type]
 * @property {string} [description]
 * @property {string} [how_to_win]
 * @property {string} [location]
 * @property {string} [terms]
 * @property {string} [cover_image]
 * @property {string} [cover_title]
 * @property {string} [cover_text]
 * @property {string|null} [reward] A leaderboard reward of the school; fills title, description, type and cover.
 * @property {string|null} [start_at]
 * @property {string|null} [end_at]
 * @property {string} [start_date]
 * @property {string} [end_date]
 * @property {string|null} [start_time]
 * @property {string|null} [end_time]
 * @property {boolean} [is_active]
 * @property {boolean} [is_featured]
 * @property {string|null} [dream_period] A period of the same school.
 * @property {'top_points'|'entry_draw'} [selection_method]
 * @property {'period'|'bonus_drop'} [draw_kind]
 * @property {number} [position]
 * @property {boolean} [requires_opt_in]
 * @property {string|null} [announce_at] Bonus drops only, at or before `start_at`. Empty (multipart) or null:
 * @property {string|null} [owner] An active staff member of the prize's school or a superuser; null clears it.
 * @property {string|null} [prize_value] USD, 0 or more, two decimals.
 * @property {boolean} [w9_collected] Records (true) or clears (false) the winner's W-9, stamped with who and when. A fulfilled prize worth $600 or more keeps it.
 */

/**
 * @typedef {Object} DreamPrizeCoverUpload
 * @property {Blob} [cover_image_file] Uploaded and stored as `cover_image`.
 */

/**
 * @typedef {Object} DreamPrizeDrawResult
 * @property {string} id
 * @property {string} school_id
 * @property {string|null} reward_id
 * @property {string} title
 * @property {string} cover_title
 * @property {string} start_date
 * @property {string} end_date
 * @property {string} winner_name Empty when nobody held an entry.
 * @property {number|null} winner_points
 * @property {'period'|'bonus_drop'} draw_kind
 * @property {'top_points'|'entry_draw'} selection_method
 * @property {number|null} winning_entries
 * @property {{id: string, name: string, points: number|null, entries: number|null}|null} winner
 */

/**
 * @typedef {Object} DreamPrizeEnterResult
 * @property {string} prize_id
 * @property {true} opted_in
 * @property {boolean} created False when the fan had already entered.
 * @property {number} entries The fan's entries in the prize's period right now.
 * @property {string|null} closes_at
 */

/**
 * @typedef {Object} DreamPrizeLeaderboard
 * @property {{id: string, title: string, is_active: boolean, type: 'overall'}} prize
 * @property {{starts_at: string, ends_at: string}} period
 * @property {Array<DreamPrizeLeaderboardRow>} leaderboard
 * @property {DreamPrizeLeaderboardParticipant} participant
 */

/**
 * The `user_id` fan's breakdown; null without `user_id`.
 * @typedef {{id: string, name: string, email: string, fan_id: string|null, points: number, rank: number, source_breakdown: Array<{source: string, points: number, entries: number}>, entries: Array<{id: string, created_at: string, points: number, earning_source: string, description: string, merchant_name: string}>}|null} DreamPrizeLeaderboardParticipant
 */

/**
 * @typedef {Object} DreamPrizeLeaderboardRow
 * @property {string} id
 * @property {number} rank
 * @property {string} name
 * @property {string} email
 * @property {string|null} fan_id
 * @property {number} points
 */

/**
 * @typedef {Object} DreamRecentWinner
 * @property {string} prize_id
 * @property {string} title
 * @property {'period'|'bonus_drop'} draw_kind
 * @property {string} winner_name First and last name.
 * @property {number|null} winning_entries
 * @property {string|null} drawn_at When the prize was drawn (Draw pressed). For a winner with no draw
 * @property {boolean} is_you
 */

/**
 * @typedef {Object} DreamRules
 * @property {string} school_name
 * @property {string} program_name The rewardsTitle of GET /api/school/merchants-page-config/{school_id}/.
 * @property {DreamRulesPeriod|null} period The period the rules describe: the open one, else the last ended one whose prizes are not all drawn yet, else the next upcoming one; with prize_id, that...
 * @property {Array<DreamRulesPrize>} prizes The running period prizes by position; empty without a period. With prize_id: the prizes of that prize's period, and empty for a bonus drop.
 * @property {DreamRulesDocument|null} document The official rules to print: the Sponsor's sweepstakes document filled in for the period's prize draws, running or drawn, or with the prize_id of a bonus...
 * @property {Array<DreamRulesStreakMilestone>} streak_milestones Purchase streak milestones, fewest days first, as the summary's streak.milestones; empty when none are set, and then the page leaves the streak line out of...
 * @property {Array<DreamRulesEntryCampaign>} entry_campaigns What the running Dream entries campaigns of the school and the global ones pay one fan, one item per trigger in this order: signup, daily_login...
 */

/**
 * @typedef {Object} DreamRulesDocument
 * @property {string} title
 * @property {string} notice The "NO PURCHASE ... NECESSARY" line, printed in bold under the title.
 * @property {Array<string>} intro Paragraphs before section 1.
 * @property {Array<DreamRulesSection>} sections
 */

/**
 * @typedef {Object} DreamRulesEntryCampaign
 * @property {DreamEntryCampaignTriggerEnum} trigger_type What the fan does: sign up, visit the app (once a day), refer a friend, complete a survey.
 * @property {number} entries Entries one fan gets for it: a daily visit pays the school's campaign, else a global one; a sign-up or a survey pays every campaign of its trigger, the...
 */

/**
 * @typedef {Object} DreamRulesPeriod
 * @property {string} name
 * @property {string} starts_at
 * @property {string} ends_at When the pool closes and period prizes are drawn.
 * @property {string} entry_dollars
 * @property {number} entry_cap The most entries one fan can hold in this period (24000), purchases and free entries together.
 */

/**
 * @typedef {Object} DreamRulesPrize
 * @property {string} title
 * @property {string} description
 * @property {string} terms The prize's own terms; "" when it has none.
 * @property {string} draw_kind Always "period": bonus drops are not listed in the rules.
 */

/**
 * @typedef {Object} DreamRulesSection
 * @property {string} heading "1. Promotion Period" and so on, numbered as printed.
 * @property {Array<string>} paragraphs Paragraphs in order, plain text.
 * @property {Array<string>} list Lines printed as a list after the paragraphs (the Amplify Day dates); empty for most sections.
 */

/**
 * @typedef {Object} DreamRulesStreakMilestone
 * @property {number} days Qualifying purchase days in a row.
 * @property {number} bonus_entries Entries the milestone adds, once per run.
 */

/**
 * @typedef {Object} DreamStreakMilestone
 * @property {number} days Qualifying purchase days in a row.
 * @property {number} bonus_entries Entries the milestone adds, once per run.
 */

/**
 * @typedef {Object} DreamSummary
 * @property {boolean} enabled The school's `revamp_v2`. When false everything else is empty.
 * @property {DreamSummaryPeriod} period
 * @property {number} entries The fan's entries in `period`: purchases (times the boost of their
 * @property {boolean} at_entry_cap The fan's entries have reached `period.entry_cap`: nothing more counts
 * @property {string} qualifying_spend The fan's net dollars that counted in `period`.
 * @property {Array<DreamSummaryPrize>} prizes Period prizes, by `position`.
 * @property {Array<DreamSummaryPrize>} bonus_drops Bonus drops whose window is open now and that have no winner yet.
 * @property {Array<DreamSummaryPrize>} upcoming_bonus_drops Bonus drops of `period` shown ahead of opening: active, no winner, and
 * @property {DreamFeaturedDraw|null} featured_draw The prize the Home card shows: the first active prize draw of the pool
 * @property {Array<DreamFeaturedDraw>} featured_draws Every active prize draw of the pool, by `position`, whether or not staff
 * @property {Array<DreamRecentWinner>} recent_winners The school's ten latest entry-draw winners, the latest draw first.
 * @property {string} rules_url The school's public official rules page on the fan web app:
 * @property {DreamSummaryBoosts} boosts
 * @property {DreamSummaryStreak|null} streak The fan's purchase streak at the school; null when `enabled` is false.
 */

/**
 * Entry boost days for the fan's school: network-wide, the school's own and
 * @typedef {Object} DreamSummaryBoosts
 * @property {Array<DreamBoost>} active Boosts whose window covers now, largest `multiplier` first. The banner is
 * @property {Array<DreamBoost>} upcoming Boosts that start after now and inside `period` (they start before its
 */

/**
 * The current period; null when the school has none open or upcoming.
 * @typedef {{id: string, name: string, status: 'upcoming'|'active', starts_at: string, ends_at: string, entry_dollars: string, entry_cap: number, drawn_at: string|null}|null} DreamSummaryPeriod
 */

/**
 * @typedef {Object} DreamSummaryPrize
 * @property {string} id
 * @property {string|null} reward_id
 * @property {string} school_id
 * @property {string} title
 * @property {string} description
 * @property {string} [how_to_win]
 * @property {string} [location]
 * @property {string} [terms]
 * @property {string} giveaway_type
 * @property {string} [cover_title]
 * @property {string} [cover_text]
 * @property {string|null} [cover_image]
 * @property {string|null} cover_image_url
 * @property {Array<string>} image_urls
 * @property {Array<Object<string, *>>} image_crops Crop of each image in `image_urls`, same order; `{}` when none.
 * @property {string} start_date
 * @property {string} end_date
 * @property {string|null} [start_time]
 * @property {string|null} [end_time]
 * @property {string} [overall_starts_at]
 * @property {string} [overall_ends_at]
 * @property {string} dream_starts_at When the prize opens; for an announced bonus drop, the "Opens" moment.
 * @property {string} dream_ends_at When entries close; the prize is drawn after it, from the Draw button.
 * @property {string} winner_name Empty until drawn.
 * @property {number|null} [winning_points]
 * @property {number|null} winning_entries
 * @property {boolean} is_finalized
 * @property {'top_points'|'entry_draw'} selection_method
 * @property {'period'|'bonus_drop'} draw_kind
 * @property {number} position
 * @property {boolean} requires_opt_in Only fans who tapped Enter are in this draw.
 * @property {string|null} dream_period_id
 * @property {boolean} opted_in The fan has tapped Enter on this prize.
 * @property {boolean} is_open Active, not drawn, and now is inside the prize's window.
 * @property {string|null} countdown_target
 */

/**
 * Qualifying purchases on consecutive days earn fixed bonus entries at
 * @typedef {Object} DreamSummaryStreak
 * @property {number} current_days The live run in days (its last day is today or yesterday), else 0. Also 0 once the fan holds the period's entry cap, as there is no streak after the cap.
 * @property {number} longest_days The fan's longest run at the school.
 * @property {boolean} today_counts Today already has a qualifying purchase.
 * @property {string} day_ends_at When today ends as a streak day (midnight in the school's zone, America/Denver by default), in UTC.
 * @property {string} min_purchase The smallest single purchase that makes a day count.
 * @property {number|null} days_to_next `next_milestone.days - current_days`; null past the last milestone.
 * @property {DreamStreakMilestone|null} next_milestone The first milestone past `current_days`; null past the last one (the run goes on).
 * @property {Array<DreamStreakMilestone>} milestones Every milestone, fewest days first; empty when none are set.
 */

/**
 * @typedef {Object} EmbedFirstReward
 * @property {string} id
 * @property {string} title
 * @property {string} description
 * @property {string} whatsIncluded
 * @property {number} pointsCost
 * @property {string} imageUrl
 * @property {string} confirmationImageUrl
 * @property {Array<string>} images Gallery images; the single `imageUrl` when there is no gallery.
 * @property {string} location
 * @property {boolean} unlocked
 * @property {boolean} redeemed
 * @property {'reward'} [kind] Only at a school with Revamp v2 on - the three cheapest rewards; the item is a regular reward.
 */

/**
 * @typedef {Object} EmbedFirstRewardDetail
 * @property {number} earnedPoints
 * @property {number} availablePoints
 * @property {EmbedFirstReward} milestone
 */

/**
 * @typedef {Object} EmbedFirstRewardRedeemRequest
 * @property {'sms'|'email'} contactMethod
 * @property {string} contactValue An email address for `email`; 10 to 15 digits for `sms`.
 */

/**
 * @typedef {Object} EmbedFirstRewardRedemption
 * @property {string} id
 * @property {string} rewardId
 * @property {string} title
 * @property {string} confirmationImageUrl
 * @property {string} location
 * @property {'sms'|'email'} contactMethod
 * @property {string} contactValue
 * @property {'pending'|'fulfilled'|'cancelled'} status
 * @property {string} createdAt
 */

/**
 * @typedef {Object} EmbedFirstRewards
 * @property {number} earnedPoints
 * @property {Array<EmbedFirstReward>} milestones
 */

/**
 * * `none` - No extension
 * @typedef {'none'|'homecrowd'|'built_in'|'separate_app'} ExtensionModeEnum
 */

/**
 * @typedef {Object} FanBadge
 * @property {string} slug
 * @property {string} title
 * @property {string} description
 * @property {string} image_url Badge art URL.
 * @property {boolean} earned
 * @property {string|null} granted_at When the badge was earned; null until then.
 */

/**
 * @typedef {Object} FanBadges
 * @property {Array<FanBadge>} badges
 * @property {string} badge_background_color Hex colour; empty when the fan has no active school.
 * @property {string} badge_accent_color Hex colour; empty when the fan has no active school.
 */

/**
 * @typedef {Object} FeaturedOfferRequest
 * @property {string} name
 * @property {string|null} [small_logo_url]
 * @property {string|null} [large_logo_url]
 * @property {string|null} [summary]
 * @property {boolean} [top_featured]
 * @property {boolean} [bottom_featured]
 * @property {string|null} [offer_id] Olive or Wildfire offer ID
 * @property {OfferTypeEnum} [offer_type] Type of offer - card_linked requires card connection, click redirects to merchant
 * @property {string|null} [school] School this offer is featured for
 * @property {number} [top_order] Display order for top featured (higher numbers appear first)
 * @property {number} [bottom_order] Display order for bottom featured (higher numbers appear first)
 * @property {boolean} [is_preferred_partner] Show in Preferred Partners carousel (separate from top/bottom featured)
 * @property {number} [preferred_order] Display order for preferred partners (higher numbers appear first)
 * @property {boolean} [is_active]
 */

/**
 * * `merchandise` - Merchandise
 * @typedef {'merchandise'|'apparel'|'experience'|'collectibles'|'tickets'|'gift_card'|'other'} GiveawayTypeEnum
 */

/**
 * @typedef {Object} LeaderboardReward
 * @property {string} id
 * @property {string} title
 * @property {GiveawayTypeEnum} giveaway_type
 * @property {string} reward_type
 * @property {string} description
 * @property {string} [terms]
 * @property {string} [cover_image]
 * @property {string|null} cover_image_url
 * @property {string} [cover_title]
 * @property {string} [cover_text]
 * @property {Array<LeaderboardRewardImage>} images
 * @property {Array<LeaderboardRewardImage>} gallery
 * @property {string|null} school
 * @property {string} [school_name]
 * @property {boolean} [is_active]
 * @property {string} created_at
 * @property {string} updated_at
 */

/**
 * @typedef {Object} LeaderboardRewardImage
 * @property {string} id
 * @property {string} image_path S3 URL for the image.
 * @property {string} image_url
 * @property {number} order 0 is shown first.
 * @property {*} crop
 */

/**
 * @typedef {Object} LeaderboardRewardRequest
 * @property {string} title
 * @property {GiveawayTypeEnum} giveaway_type
 * @property {string} description
 * @property {string} [terms]
 * @property {string} [cover_image]
 * @property {string} [cover_title]
 * @property {string} [cover_text]
 * @property {boolean} [is_active]
 */

/**
 * @typedef {Object} Merchant
 * @property {string} id
 * @property {string} name
 * @property {string} category
 * @property {string} [website]
 * @property {boolean} [is_active]
 * @property {string} created_at
 */

/**
 * @typedef {Object} MerchantFeaturedOffer
 * @property {string} id
 * @property {string} name
 * @property {string|null} [small_logo_url]
 * @property {string|null} [large_logo_url]
 * @property {string|null} [summary]
 * @property {boolean} top_featured
 * @property {boolean} bottom_featured
 * @property {string|null} [offer_id]
 * @property {OfferTypeEnum} offer_type
 * @property {string|null} school Null for an offer shown at every school.
 * @property {string} [school_name] Absent for a global offer.
 * @property {number} top_order
 * @property {number} bottom_order
 * @property {boolean} is_preferred_partner
 * @property {number} preferred_order
 * @property {boolean} is_active
 * @property {number|null} pointMultiplier Active points multiplier of the offer's merchant; null when the offer has no
 * @property {2|5|8|10} [entryMultiplier] Dream entry multiplier of a boost day at this merchant for the signed-in fan.
 * @property {string} created_at
 * @property {string} updated_at
 */

/**
 * @typedef {Object} MerchantFeedFailure
 * @property {'cardlinked'|'click'} type
 * @property {string} error
 */

/**
 * One store of an Olive offer, as the shop shows it.
 * @typedef {Object} MerchantOliveOffer
 * @property {string|null} id Store id.
 * @property {string|null} name
 * @property {string} category
 * @property {string|null} [logoUrl]
 * @property {Array<string>} tags
 * @property {string} points
 * @property {string|null} [storeId]
 * @property {string|null} [storeName]
 * @property {string|null} [address]
 * @property {string|null} [city]
 * @property {string|null} [state]
 * @property {string|null} [postcode]
 * @property {*} [phone]
 * @property {string|null} [website]
 * @property {boolean} isOnline
 * @property {number|null} [latitude]
 * @property {number|null} [longitude]
 * @property {number|null} [distance]
 * @property {string} offerId
 * @property {'cardlinked'|'click'} offerType
 * @property {string|null} [description]
 * @property {string|null} [title]
 * @property {number} cashback
 * @property {string} rewardType
 * @property {string|null} [brandId]
 * @property {string|null} [corporateId]
 * @property {string|null} [campaignId]
 * @property {string|null} [startDate]
 * @property {string|null} [endDate]
 * @property {Array<*>} [daysAvailability]
 * @property {*} [redemptionTrigger]
 * @property {*} [purchaseAmount]
 * @property {number|null} [redeemLimitPerUser]
 * @property {string|null} [redeemLimitPerUserInterval]
 * @property {number|null} [redeemLimitPerUserIntervalCount]
 * @property {*} [budget]
 * @property {Array<string>} supportedSchemes
 * @property {string|null} [shopCategory]
 * @property {Array<string>} shopCategories
 * @property {string|null} [shopCategoryLabel]
 * @property {number} [pointMultiplier] Only on offers whose merchant has an active multiplier.
 * @property {2|5|8|10} [entryMultiplier] Dream entry multiplier of a boost day at this merchant for the signed-in fan.
 */

/**
 * @typedef {Object} MerchantOliveOfferDetail
 * @property {string} id
 * @property {string} offerId
 * @property {string|null} name
 * @property {string|null} [website]
 * @property {string|null} [logoUrl]
 * @property {string|null} [bannerUrl]
 * @property {string|null} [category]
 * @property {Array<string>} [tags]
 * @property {string} [description]
 * @property {string|null} [title]
 * @property {*} [qualifier]
 * @property {*} [tile]
 * @property {number} [cashback]
 * @property {string} [rewardType]
 * @property {*} [maxValue]
 * @property {string|null} [startDate]
 * @property {string|null} [endDate]
 * @property {string|null} [offerType]
 * @property {*} [redemptionTrigger]
 * @property {*} [purchaseAmount]
 * @property {*} [maximumPurchaseAmount]
 * @property {*} [purchaseFrequency]
 * @property {*} [budget]
 * @property {*} [totalRedeemLimit]
 * @property {*} [redeemLimitPerUser]
 * @property {*} [redeemLimitPerUserInterval]
 * @property {*} [redeemLimitPerUserIntervalCount]
 * @property {Array<*>} [daysAvailability]
 * @property {string} [currency]
 * @property {Array<{id?: string|null, name?: string|null, phone?: *, address?: string|null, city?: string|null, state?: string|null, postCode?: *, website?: string|null, isOnline?: boolean, latitude?: number|null, longitude?: number|null, distance?: number|null, supportedSchemes?: Array<string>}>} stores
 * @property {*} [campaignId]
 * @property {*} [campaign]
 * @property {*} [extOfferId]
 * @property {*} [offerState]
 * @property {*} [availability]
 * @property {*} [reach]
 * @property {*} [redemptionInstructionUrl]
 * @property {*} [offerPublisherAffiliateLinkUrl]
 */

/**
 * @typedef {Object} MerchantOliveOffers
 * @property {boolean} [success]
 * @property {Array<MerchantOliveOffer>} cardlinked
 * @property {Array<MerchantOliveOffer>} click
 * @property {Array<MerchantOliveOffer>} stores Same rows as `cardlinked`, kept for older clients.
 * @property {number} [totalOffers]
 * @property {number} [totalCardlinked]
 * @property {number} [totalClick]
 * @property {number} [totalStores]
 * @property {boolean} sortedByProximity
 * @property {boolean} hasLocationFilter
 * @property {{currentPage: number, pageSize: number, totalCardlinkedAvailable: number, totalClickAvailable: number, hasMoreCardlinked: boolean, hasMoreClick: boolean}} pagination
 * @property {Array<MerchantFeedFailure>} [warnings] Feeds that failed while the rest answered.
 */

/**
 * A store joined with its brand, as the merchant list shows it.
 * @typedef {Object} MerchantOliveStore
 * @property {string} storeId
 * @property {string} storeName
 * @property {string|null} [address]
 * @property {string|null} [city]
 * @property {string|null} [state]
 * @property {*} [postcode]
 * @property {string|null} [countryCode]
 * @property {string|null} [phone]
 * @property {*} [timeZone]
 * @property {boolean} [isOnline]
 * @property {number|null} [latitude]
 * @property {number|null} [longitude]
 * @property {string|null} [alias]
 * @property {Array<string>} [supportedSchemes]
 * @property {string|null} brandId
 * @property {string|null} id Same as `brandId`.
 * @property {string} name
 * @property {string} category
 * @property {*} [mcc]
 * @property {string|null} [logoUrl]
 * @property {string|null} [logoUrlSm]
 * @property {string|null} [bannerUrl]
 * @property {Array<string>} tags
 * @property {*} [externalBrandId]
 * @property {string} description
 * @property {string} points
 * @property {number|null} distance Miles from the given coordinates; null without them.
 */

/**
 * @typedef {Object} MerchantRequest
 * @property {string} name
 * @property {string} category
 * @property {string} [website]
 * @property {boolean} [is_active]
 */

/**
 * @typedef {Object} MerchantTrackClick
 * @property {boolean} success
 * @property {string} [tracking_url]
 * @property {string} [offer_id]
 * @property {string} [error] Only when `success` is false.
 * @property {string} [details]
 */

/**
 * @typedef {Object} MerchantWarmDevice
 * @property {boolean} success
 * @property {boolean} device_ready
 * @property {Object<string, *>} [timing_ms]
 */

/**
 * @typedef {Object} MerchantWildfireMerchant
 * @property {string} id
 * @property {*} [wildfireMerchantId]
 * @property {string} merchantName
 * @property {string} name
 * @property {string|null} [logoUrl]
 * @property {string|null} [website]
 * @property {boolean} isOnline
 * @property {'click'} offerType
 * @property {'wildfire'} offerSource
 * @property {string|null} [category]
 * @property {Array<string>} [categories]
 * @property {string|null} [shopCategory]
 * @property {Array<string>} [shopCategories]
 * @property {string|null} [shopCategoryLabel]
 * @property {number} [pointMultiplier] Only when the merchant has an active multiplier.
 * @property {2|5|8|10} [entryMultiplier] Dream entry multiplier of a boost day at this merchant for the signed-in fan.
 */

/**
 * * `card_linked` - Card-Linked
 * @typedef {'card_linked'|'click'} OfferTypeEnum
 */

/**
 * @typedef {Object} OliveCard
 * @property {string} id
 * @property {string} olive_card_id
 * @property {string} user
 * @property {string} [cardholder_name]
 * @property {string} [billing_zip]
 * @property {string} network
 * @property {string} last4
 * @property {number} exp_month
 * @property {number} exp_year
 * @property {string} status
 * @property {string} added_at
 * @property {boolean} [is_default]
 * @property {string|null} [nickname]
 * @property {string|null} [environment_key]
 * @property {string|null} [certificate_token]
 */

/**
 * @typedef {Object} OliveCardRequest
 * @property {string} olive_card_id
 * @property {string} [cardholder_name]
 * @property {string} [billing_zip]
 * @property {string} network
 * @property {string} last4
 * @property {number} exp_month
 * @property {number} exp_year
 * @property {boolean} [is_default]
 * @property {string|null} [nickname]
 * @property {string} card_token
 * @property {string|null} [environment_key]
 * @property {string|null} [certificate_token]
 */

/**
 * @typedef {Object} PaginatedMerchantList
 * @property {number} count
 * @property {string|null} [next]
 * @property {string|null} [previous]
 * @property {Array<Merchant>} results
 */

/**
 * @typedef {Object} PaginatedOliveCardList
 * @property {number} count
 * @property {string|null} [next]
 * @property {string|null} [previous]
 * @property {Array<OliveCard>} results
 */

/**
 * @typedef {Object} PaginatedSchoolList
 * @property {number} count
 * @property {string|null} [next]
 * @property {string|null} [previous]
 * @property {Array<School>} results
 */

/**
 * @typedef {Object} PatchedContentImageRequest
 * @property {string} [image_path] S3 path generated by AWS
 * @property {string} [alt_text] Alternative text for accessibility
 * @property {number} [order] Display order (0 = first image)
 * @property {boolean} [is_primary] Primary/featured image for this content
 * @property {string} [caption] Optional image caption
 */

/**
 * @typedef {Object} PatchedContentItemRequest
 * @property {string} [title]
 * @property {string} [subtitle] Optional subtitle or tagline
 * @property {string} [slug]
 * @property {ContentTypeEnum} [content_type]
 * @property {string} [description] Content description
 * @property {string} [school]
 * @property {Status11fEnum} [status]
 * @property {boolean} [featured]
 * @property {number} [priority] Higher numbers appear first
 * @property {number} [view_count] Number of times this content has been viewed
 * @property {string|null} [featured_image]
 * @property {string|null} [video_url] Optional video URL (YouTube, Vimeo, etc.)
 * @property {string|null} [publish_date]
 * @property {string|null} [expiration_date] Optional expiration date
 * @property {string|null} [created_by]
 * @property {string|null} [updated_by]
 */

/**
 * @typedef {Object} PatchedContentVideoRequest
 * @property {string} [video_path] S3 path generated by AWS
 * @property {string} [title] Video title or description
 * @property {number} [order] Display order (0 = first video)
 * @property {boolean} [is_primary] Primary/featured video for this content
 * @property {string|null} [duration] Video duration
 * @property {string} [thumbnail_path] S3 path to video thumbnail
 */

/**
 * @typedef {Object} PatchedFeaturedOfferRequest
 * @property {string} [name]
 * @property {string|null} [small_logo_url]
 * @property {string|null} [large_logo_url]
 * @property {string|null} [summary]
 * @property {boolean} [top_featured]
 * @property {boolean} [bottom_featured]
 * @property {string|null} [offer_id] Olive or Wildfire offer ID
 * @property {OfferTypeEnum} [offer_type] Type of offer - card_linked requires card connection, click redirects to merchant
 * @property {string|null} [school] School this offer is featured for
 * @property {number} [top_order] Display order for top featured (higher numbers appear first)
 * @property {number} [bottom_order] Display order for bottom featured (higher numbers appear first)
 * @property {boolean} [is_preferred_partner] Show in Preferred Partners carousel (separate from top/bottom featured)
 * @property {number} [preferred_order] Display order for preferred partners (higher numbers appear first)
 * @property {boolean} [is_active]
 */

/**
 * @typedef {Object} PatchedLeaderboardRewardRequest
 * @property {string} [title]
 * @property {GiveawayTypeEnum} [giveaway_type]
 * @property {string} [description]
 * @property {string} [terms]
 * @property {string} [cover_image]
 * @property {string} [cover_title]
 * @property {string} [cover_text]
 * @property {boolean} [is_active]
 */

/**
 * @typedef {Object} PatchedMerchantRequest
 * @property {string} [name]
 * @property {string} [category]
 * @property {string} [website]
 * @property {boolean} [is_active]
 */

/**
 * @typedef {Object} PatchedRedemptionRequest
 * @property {string} [reward]
 * @property {number} [points_spent]
 * @property {RedemptionStatusEnum} [status]
 * @property {string} [fulfillment_channel]
 * @property {boolean} [w9_collected]
 */

/**
 * @typedef {Object} PatchedRewardRequest
 * @property {string} [title]
 * @property {string} [description]
 * @property {number} [points_cost]
 * @property {number|null} [cash_price_cents] USD price in cents for card-type rewards; legacy first-come may still use this for Stripe. Checkout uses points only.
 * @property {boolean} [include_stripe_fee] When on, the fan's card charge includes the Stripe fee so the school keeps cash_price_cents.
 * @property {RewardTypeEnum} [reward_type]
 * @property {RedemptionTypeEnum} [redemption_type] Type of redemption process for this reward
 * @property {boolean} [has_inventory] Whether this reward has limited inventory
 * @property {number|null} [inventory_count] Number of items remaining (null = unlimited)
 * @property {boolean} [is_active]
 * @property {boolean} [is_featured] Pin this reward to the top of the rewards page instead of the main list.
 * @property {string|null} [merchant]
 * @property {string|null} [school]
 * @property {*} [gift_card_codes] List of redeemable codes for gift-card rewards.
 * @property {string|null} [owner]
 * @property {string|null} [retail_value]
 * @property {string|null} [event_at] When the experience or the ticketed event takes place; reminders count down to it.
 */

/**
 * @typedef {Object} PatchedScheduleEventRequest
 * @property {string} [schedule]
 * @property {string} [opponent_name]
 * @property {string|null} [opponent_school] Set when the opponent is a school we already have; its logo is used.
 * @property {string} [opponent_logo_url] Uploaded logo, used only when the opponent is not a school in our system.
 * @property {string} [location_name]
 * @property {string|null} [latitude]
 * @property {string|null} [longitude]
 * @property {boolean} [check_in_enabled] Whether fans can check in at this event.
 * @property {number} [check_in_radius_m] Metres from the pin within which a fan can check in. Kept when check-in is switched off, so turning it back on restores the radius.
 * @property {number} [check_in_points] Points awarded for a successful check-in. Kept when check-in is switched off, so turning it back on restores the amount.
 * @property {boolean} [is_home] Home game for this school. Away games count toward Road Warrior.
 * @property {boolean} [is_championship] Championship / playoff game for Playoff Pilgrim.
 * @property {string} [date]
 * @property {string|null} [time] Blank means TBD.
 * @property {number|null} [home_score] Final score for the home school. Blank until the game is over.
 * @property {number|null} [away_score] Final score for the opponent. Blank until the game is over.
 * @property {number|null} [tap_target] Tap game: the shared tap count that wins. Blank means no tap game on this game.
 */

/**
 * @typedef {Object} PatchedSchoolRequest
 * @property {string} [name]
 * @property {string|null} [abbreviation]
 * @property {string} [type]
 * @property {string} [city]
 * @property {string} [state]
 * @property {string|null} [image]
 * @property {string|null} [banner_image]
 * @property {string|null} [primary_color]
 * @property {string|null} [secondary_color]
 * @property {string|null} [badge_background_color] Badge body fill. Empty keeps the template color.
 * @property {string|null} [badge_accent_color] Badge strokes and icons. Empty keeps the template color.
 * @property {boolean} [badge_accent_follows_school_color] When set, badge accent uses the Embed Appearance school color.
 * @property {string|null} [rewards_title]
 * @property {string|null} [mascot]
 * @property {boolean} [is_active]
 * @property {boolean} [content_active]
 * @property {boolean} [travel_active] When enabled, show the Travel tab in navigation for this school.
 * @property {boolean} [games_active] When enabled, show the Games tab in navigation for this school.
 * @property {boolean} [tap_game_active] When enabled, fans can play the tap game on games that have a target number.
 * @property {boolean} [revamp_v2] Turns the V2 program on for the school's fans and lets superusers publish bonus drops. Only a superuser changes it; staff of the school get a 403 for a...
 * @property {string} [commission_split] Percentage of commission that goes to the school (0-100). Default is 70%
 * @property {Array<string>} [twitter_accounts] List of Twitter account usernames (without \@) to display in social feed
 * @property {string} [sweepstakes_name] The name the official rules give the sweepstakes. Empty: the program name and "Sweepstakes".
 * @property {string} [official_rules_text] The official rules of the prize draws, pasted in full and printed word for word. Empty: built from the program data. Bonus drops always get the built rules....
 * @property {boolean} [early_release]
 * @property {boolean} [is_stripe_feature_enabled] When enabled, users see card-priced rewards and can pay with Stripe.
 * @property {ExtensionModeEnum} [extension_mode]
 * @property {string|null} [extension_app_url]
 * @property {string|null} [extension_app_url_android] Google Play page for the app the extension ships in; the Apple one is extension_app_url.
 * @property {*} [onboarding] Onboarding timeline: sections, updates, and action completion state
 * @property {*} [reward_selections] Reward/experience voting selections: votes, notes, catalog items
 */

/**
 * UserSerializer for non-superusers: roles, account state and points are read-only.
 * @typedef {Object} PatchedScopedUserRequest
 * @property {string} [email]
 * @property {string} [first_name]
 * @property {string} [last_name]
 * @property {string|null} [city]
 * @property {string|null} [state]
 * @property {string|null} [phone_number]
 * @property {boolean} [is_instruction_complete]
 */

/**
 * @typedef {Object} PatchedSportScheduleRequest
 * @property {string} [school]
 * @property {string} [sport]
 */

/**
 * @typedef {Object} PatchedTransactionRequest
 * @property {string|null} [user]
 * @property {string|null} [olive_card]
 * @property {string} [amount]
 * @property {string|null} [commission_amount] Commission amount from transaction
 * @property {number} [points_earned]
 * @property {string} [currency]
 * @property {TransactionStatusEnum} [status]
 * @property {string} [external_txn_id]
 * @property {string} [raw_descriptor]
 * @property {number|null} [wildfire_merchant_id] Wildfire merchant ID
 * @property {string|null} [wildfire_merchant_name] Wildfire merchant name
 * @property {string|null} [olive_merchant_id] Olive merchant ID
 * @property {string|null} [olive_merchant_name] Olive merchant name
 */

/**
 * @typedef {Object} PatchedUserSchoolRequest
 * @property {boolean} [is_primary]
 */

/**
 * * `points` - Points
 * @typedef {'points'|'stripe'} PaymentMethodEnum
 */

/**
 * One game card. The parts about the fan are null without a JWT.
 * @typedef {Object} PicksCard
 * @property {PicksGame} event
 * @property {'pregame'|'live'|'final'} phase `final` once the final score is set, or, without one, once the check-in window
 * @property {null} live Always null while the live score feed is off.
 * @property {PicksPick|null} my_pick The fan's pick; null without one or without a JWT.
 * @property {boolean|null} already_checked_in Null without a JWT.
 * @property {boolean|null} can_play Whether the fan may pick this game: it is at their active school, or they are a
 */

/**
 * @typedef {Object} PicksGame
 * @property {string} id
 * @property {string} sport
 * @property {string} date Game day (UTC).
 * @property {string|null} time Kick-off time in UTC; null means TBD.
 * @property {boolean} time_tbd True when `time` is null.
 * @property {string} starts_at Kick-off in UTC; midnight of `date` when there is no `time`.
 * @property {string} locks_at Picks lock at kick-off (23:59:59 UTC of `date` for a TBD game).
 * @property {{enabled: boolean, opens_at: string, closes_at: string}} check_in
 * @property {boolean} is_home
 * @property {boolean} is_championship
 * @property {string} location_name
 * @property {{id: string, name: string, abbreviation: string, mascot: string, image: string, primary_color: string}} school The school that owns the schedule; empty strings where a value is not set.
 * @property {{id: string|null, name: string, abbreviation: string, mascot: string, image: string}} opponent
 * @property {{home_score: number, away_score: number}|null} final The final score; null until a superuser enters it.
 */

/**
 * @typedef {Object} PicksPick
 * @property {string} user_id
 * @property {string} display_name
 * @property {boolean} is_you
 * @property {number} home_score
 * @property {number} away_score
 * @property {'school'|'opponent'|null} winner Who the scores make the winner; null for a tie saved as an app prediction.
 * @property {string|null} created_at
 * @property {boolean|null} correct Whether the winner was right; null until the final score is set.
 * @property {number|null} points_off The sum of the two score differences from the final score; null until it is set.
 */

/**
 * The Django form of a content item. A `slug` left empty fails the form, as the field is required; the form only adds a number to a slug that is already taken.
 * @typedef {Object} PlainContentForm
 * @property {string} title
 * @property {string} [subtitle]
 * @property {string} slug Letters, numbers, hyphens and underscores.
 * @property {string} content_type
 * @property {string} description
 * @property {string} school Limited to the user's active school when there is one.
 * @property {string} [status]
 * @property {string} [featured] Checkbox; present means on.
 * @property {number} [priority]
 * @property {string} [featured_image]
 * @property {string} [video_url]
 * @property {string} [publish_date]
 * @property {string} [expiration_date]
 */

/**
 * @typedef {Object} RedemptionRequest
 * @property {string} reward
 * @property {number} points_spent
 * @property {RedemptionStatusEnum} [status]
 * @property {string} [fulfillment_channel]
 * @property {boolean} [w9_collected]
 */

/**
 * * `pending` - Pending
 * @typedef {'pending'|'contacted'|'fulfilled'|'cancelled'} RedemptionStatusEnum
 */

/**
 * * `checkout` - Checkout
 * @typedef {'checkout'|'card'|'raffle'|'auction'|'first'} RedemptionTypeEnum
 */

/**
 * * `homecrowd_app` - Homecrowd app
 * @typedef {'homecrowd_app'|'homecrowd_embedded'} RegistrationSourceEnum
 */

/**
 * @typedef {Object} RewardRequest
 * @property {string} title
 * @property {string} description
 * @property {number} points_cost
 * @property {number|null} [cash_price_cents] USD price in cents for card-type rewards; legacy first-come may still use this for Stripe. Checkout uses points only.
 * @property {boolean} [include_stripe_fee] When on, the fan's card charge includes the Stripe fee so the school keeps cash_price_cents.
 * @property {RewardTypeEnum} reward_type
 * @property {RedemptionTypeEnum} [redemption_type] Type of redemption process for this reward
 * @property {boolean} [has_inventory] Whether this reward has limited inventory
 * @property {number|null} [inventory_count] Number of items remaining (null = unlimited)
 * @property {boolean} [is_active]
 * @property {boolean} [is_featured] Pin this reward to the top of the rewards page instead of the main list.
 * @property {string|null} [merchant]
 * @property {string|null} [school]
 * @property {*} [gift_card_codes] List of redeemable codes for gift-card rewards.
 * @property {string|null} [owner]
 * @property {string|null} [retail_value]
 * @property {string|null} [event_at] When the experience or the ticketed event takes place; reminders count down to it.
 */

/**
 * * `merchandise` - Merchandise
 * @typedef {'merchandise'|'apparel'|'experience'|'collectibles'|'gift_card'} RewardTypeEnum
 */

/**
 * @typedef {Object} RewardsActivityEntry
 * @property {string} id
 * @property {string} transaction_type
 * @property {number} points
 * @property {number} balance_after Recomputed over the visible rows, anchored to the current balance.
 * @property {string} description
 * @property {string} date When it happened: the purchase date for purchases, otherwise the ledger time.
 * @property {string|null} spending_source
 * @property {string|null} earning_source
 * @property {string|null} merchant_name
 * @property {string|null} external_transaction_id
 * @property {Object<string, *>} metadata
 * @property {string} [source] Transaction source: olive, wildfire or travel. Only on purchase rows.
 * @property {string|null} [merchant_logo_url]
 * @property {number} [entries_earned] On purchase rows, Dream entries the purchase added, negative when a refund took them back; 0 when it added none, and always 0 while the school's `revamp_v2`...
 * @property {string} [activity_kind] Row kind: stripe_card_purchase, raffle_ticket_redemption, points_redemption, card_draw, setup_task_reward, incentive_campaign or dream_entries (entries...
 * @property {'free_entry'|'streak_bonus'|'campaign'|'daily_login'|'referral'|'conversion'} [entries_source] Only on dream_entries rows. free_entry - granted by a superuser from a Support request; streak_bonus - a purchase streak milestone (`streak_days`); campaign...
 * @property {number} [streak_days] Only on streak_bonus rows. The milestone the bonus is for, in days in a row.
 * @property {string} [issuer] `homecrowd` for bonuses issued by the platform.
 * @property {string} [display_title]
 * @property {string|null} [setup_task]
 * @property {string|null} [trigger_type]
 * @property {{id: string, reward_title: string, bid_amount: number}} [auction] Auction bid rows.
 * @property {{id: string, reward_title: string, redemption_type: RedemptionTypeEnum, points_spent: number, used_ticket: boolean, ticket_count: number, payment_method: string, amount_paid_cents: number|null}} [redemption] Redemption rows.
 */

/**
 * @typedef {Object} RewardsAuction
 * @property {string} id
 * @property {{id: string, title: string, description: string}} reward
 * @property {string} start_date
 * @property {string} end_date
 * @property {number} starting_bid
 * @property {number} minimum_increment
 * @property {number|null} current_highest_bid
 * @property {number} minimum_next_bid
 * @property {RewardsPerson|null} current_winner
 * @property {'draft'|'active'|'completed'|'cancelled'} status
 * @property {boolean} is_active
 * @property {number} total_bids
 * @property {string} created_at
 */

/**
 * @typedef {Object} RewardsAuctionInfo
 * @property {string} id
 * @property {string} start_date
 * @property {string} end_date
 * @property {number} starting_bid
 * @property {number} minimum_increment
 * @property {number|null} current_highest_bid
 * @property {'draft'|'active'|'completed'|'cancelled'} status
 * @property {number} total_bids
 * @property {string|null} current_winner Current leader user id.
 * @property {string|null} final_winner Winner user id once ended.
 * @property {string|null} ended_at
 * @property {number|null} user_current_bid The signed-in fan's latest bid.
 */

/**
 * @typedef {Object} RewardsCardDraw
 * @property {boolean} success
 * @property {boolean} already_drawn True when the fan has already drawn today.
 * @property {boolean} disabled True when the school has not turned the daily draw on.
 * @property {number} points_awarded POST: points granted by this call, 0 on a repeat or when the draw is off. GET: points of today's draw, 0 if none.
 * @property {number} new_balance
 */

/**
 * @typedef {Object} RewardsChallenge
 * @property {string} id
 * @property {string} school
 * @property {string} school_name
 * @property {string|null} preset
 * @property {string} [preset_title] Absent when the challenge has no preset.
 * @property {string} challenge_type
 * @property {string} challenge_type_label
 * @property {string} title
 * @property {string} subtitle
 * @property {string} description
 * @property {string} reward_label
 * @property {string} start_at
 * @property {string} end_at
 * @property {boolean} is_active
 * @property {number} reward_points
 * @property {string} reward_distribution
 * @property {string} party_size
 * @property {string} match_mode
 * @property {number|null} max_participants
 * @property {number|null} target_points
 * @property {number|null} required_purchases
 * @property {number|null} required_count
 * @property {number|null} target_spend_cents
 * @property {string} icon_key
 * @property {string} icon
 * @property {string|null} icon_url
 * @property {number} progress The signed-in fan's progress toward the goal.
 * @property {boolean} invite_pending True when the fan has a pending invite to this challenge.
 * @property {'inactive'|'upcoming'|'ended'|'live'} status
 * @property {string} created_at
 * @property {string} updated_at
 */

/**
 * @typedef {Object} RewardsChallengeList
 * @property {Array<RewardsChallenge>} results
 * @property {number} count
 */

/**
 * The fan's match in a challenge. With no match yet `match` is null and `id`/`status` are absent.
 * @typedef {Object} RewardsChallengeMatch
 * @property {string} [id] Match id; absent when the fan has no match yet.
 * @property {'pending'|'active'|'completed'} [status] Absent when the fan has no match yet.
 * @property {{id: string, status: string}|null} match Null when the fan has no match yet.
 * @property {RewardsChallengePlayer} you
 * @property {RewardsChallengePlayer|null} opponent
 * @property {Array<RewardsChallengePlayer>} participants
 * @property {boolean} finished True once the challenge end time has passed.
 * @property {boolean|null} you_won Set only when finished and the points differ.
 * @property {'pending'|'accepted'|'declined'|null} your_status
 * @property {boolean} is_host
 * @property {boolean} team_ready
 * @property {number} slots_filled
 * @property {number} slots_total
 * @property {string} slots_label
 * @property {boolean} can_invite
 */

/**
 * @typedef {Object} RewardsChallengePlayer
 * @property {string} id
 * @property {string} first_name
 * @property {string} last_name
 * @property {string} display_name
 * @property {string} handle Local part of the email.
 * @property {string|null} avatar_url
 * @property {number} points Points earned inside the challenge window.
 * @property {number} visits Restaurant visits inside the challenge window.
 * @property {'pending'|'accepted'|'declined'|null} status Invite status; null when not in the match.
 * @property {boolean} [can_remove] Only on match participants: the host can remove a pending invitee.
 */

/**
 * A raffle the fan can enter for free.
 * @typedef {Object} RewardsClaimableRaffle
 * @property {string} raffle_id
 * @property {string} reward_id
 * @property {string} id Same as reward_id.
 * @property {string} title
 * @property {string} description
 * @property {number} points_cost
 * @property {'raffle'} redemption_type
 * @property {boolean} force_prompt True when the fan must be prompted even if they already saw the prompt today.
 * @property {string|null} image_url
 * @property {Array<{id: string, image_path: string, order: number, is_primary: boolean, caption: string}>} images
 * @property {string|null} drawing_date
 * @property {RewardsRaffleInfo} raffle_info
 */

/**
 * Result of the daily bonus. `already_claimed`, `message` and `eligible_raffles` are present in every response; `dream_entries_awarded` only for a school with...
 * @typedef {Object} RewardsDailyBonus
 * @property {number} points_awarded
 * @property {number} [tickets_awarded] Absent when no campaign ran or the bonus was already claimed today.
 * @property {number} [entries_awarded] Absent when no campaign ran or the bonus was already claimed today.
 * @property {Array<string>} [raffle_titles] Absent when no campaign ran or the bonus was already claimed today.
 * @property {boolean} [already_claimed]
 * @property {string} [message] "Your free daily entry is ready" ("Your free daily entries are ready" when `daily_entry_offer.entries` is above 1) when the visit paid nothing and offers...
 * @property {number} [dream_entries_awarded] Always 0. The visit adds no Dream entries; the day's entries, a Dream daily-login campaign's or the built-in one, are offered in `daily_entry_offer` and...
 * @property {RewardsDailyEntryOffer|Object<string, *>|null} [daily_entry_offer] The day's Dream entries the fan can claim now (`POST /api/rewards/daily-entry/claim/`) or decline (`POST /api/rewards/daily-entry/decline/`). Null when...
 * @property {string} [campaign_name] Absent when no campaign ran or the bonus was already claimed today.
 * @property {string} [incentive_type] points, raffle_entry or raffle_ticket. Never dream_entries, the Dream entries of the day are claimed (`daily_entry_offer`). Absent when no campaign ran or...
 * @property {Array<RewardsClaimableRaffle>} [eligible_raffles] Open raffles the fan has not entered yet.
 * @property {Array<DreamBonusDropPrompt>} [bonus_drops] Open bonus drops the fan can enter, the soonest to close first. Empty while the school's `revamp_v2` is off; absent only when recording the visit failed.
 */

/**
 * Outcome of claiming the daily entry. The period fields come with `claimed` or `already_claimed`.
 * @typedef {Object} RewardsDailyEntryClaim
 * @property {boolean} claimed True when this call wrote the entry.
 * @property {boolean} already_claimed True when the entry of this school day was already claimed.
 * @property {'not_found'|'not_available'} [error]
 * @property {number} [entries_awarded] Entries this call added, as they counted under the cap; 0 on a repeat.
 * @property {number} [user_entries] Entries the fan holds in the period after the call.
 * @property {DreamSummaryPeriod} [period]
 * @property {DreamSummaryPrize|Object<string, *>|null} [prize]
 */

/**
 * @typedef {Object} RewardsDailyEntryDecline
 * @property {boolean} declined True when the day is recorded as declined.
 * @property {boolean} already_claimed True when the day's entry was already claimed; nothing is declined then.
 * @property {'not_found'} [error]
 */

/**
 * The day's Dream entries waiting for the fan's Claim, with what the claim screens show.
 * @typedef {Object} RewardsDailyEntryOffer
 * @property {number} entries Entries a claim grants, the Dream daily-login campaign's or the built-in 1; near the cap fewer count.
 * @property {number} user_entries Entries the fan holds in the period now.
 * @property {DreamSummaryPeriod} period
 * @property {DreamSummaryPrize|Object<string, *>|null} prize The period's first prize draw, the one the Dream Home card shows; null when it has none.
 */

/**
 * @typedef {Object} RewardsFirstRewardClaim
 * @property {string} id
 * @property {string} user_name Full name, or the email when the fan has no name.
 * @property {string} user_email
 * @property {string} reward_title
 * @property {number} reward_points_cost
 * @property {'sms'|'email'} contact_method
 * @property {string} contact_value
 * @property {'pending'|'fulfilled'|'cancelled'} status
 * @property {string} created_at
 */

/**
 * Outcome of claiming the free raffle entry. Fields beyond claimed/already_claimed depend on the outcome.
 * @typedef {Object} RewardsFreeEntryClaim
 * @property {boolean} claimed True when this call created the entry.
 * @property {boolean} already_claimed True when the fan already had an entry.
 * @property {'not_found'|'permission_denied'|'not_eligible'} [error]
 * @property {string} [raffle_id]
 * @property {string} [reward_id]
 * @property {string} [title]
 * @property {RewardsClaimableRaffle} [raffle]
 */

/**
 * @typedef {Object} RewardsGiveaway
 * @property {string} id
 * @property {string} title
 * @property {GiveawayTypeEnum} giveaway_type
 * @property {string} description
 * @property {string} terms
 * @property {string} cover_image
 * @property {string|null} cover_image_url
 * @property {string} cover_title
 * @property {string} cover_text
 * @property {string|null} school
 * @property {string|null} start_date
 * @property {string|null} end_date
 * @property {boolean} is_active
 * @property {boolean} is_featured
 * @property {Object<string, *>} metadata
 * @property {string} created_at
 * @property {string} updated_at
 * @property {Array<{id: string, image_path: string, order: number, is_primary: boolean, caption: string}>} images
 */

/**
 * @typedef {Object} RewardsImage
 * @property {string} id
 * @property {string} image_path Image URL.
 * @property {number} order
 * @property {boolean} is_primary
 * @property {string} caption
 * @property {string} [alt_text] Only in the image-management responses.
 * @property {Object<string, *>} crop Crop frames per orientation, as saved by the admin editor.
 */

/**
 * @typedef {Object} RewardsIncentiveCampaign
 * @property {string} id
 * @property {string} name
 * @property {string} description
 * @property {'points'|'raffle_entry'|'raffle_ticket'|'dream_entries'} incentive_type dream_entries grants Dream entries in the current prize draw of the fan's school, as a ledger row of the fan's entries; nothing is granted (and no grant...
 * @property {number} incentive_value Points, number of raffle entries, or Dream entries (at least 1) in the current prize draw.
 * @property {Object<string, *>} incentive_metadata
 * @property {'specific'|'all_school'|''} raffle_scope
 * @property {Array<string>} raffles Raffle ids for raffle_entry campaigns with scope `specific`.
 * @property {Array<{id: string, title: string, status: string}>} raffles_detail
 * @property {string} trigger
 * @property {string} trigger_name
 * @property {string|null} school
 * @property {string} [school_name] Absent for campaigns of all schools.
 * @property {Object<string, *>} user_segment
 * @property {number|null} total_limit
 * @property {number} per_user_limit
 * @property {string} start_date
 * @property {string|null} end_date
 * @property {boolean} is_active
 * @property {string} created_at
 * @property {string} updated_at
 * @property {number} grants_count
 * @property {number|null} grants_remaining Null when there is no total limit.
 */

/**
 * @typedef {Object} RewardsIncentiveCampaignRequest
 * @property {string} name
 * @property {string} [description]
 * @property {'points'|'raffle_entry'|'dream_entries'} incentive_type `raffle_ticket` is refused. `dream_entries` only from a superuser (staff get 403), on a `signup`, `daily_login`, `referral_signup` or `survey_complete`...
 * @property {number} incentive_value Points, number of raffle entries, or Dream entries in the current prize draw; a `dream_entries` campaign takes at least 1 (400 `{"incentive_value": ["A...
 * @property {Object<string, *>} [incentive_metadata]
 * @property {'specific'|'all_school'} [raffle_scope]
 * @property {Array<string>} [raffles]
 * @property {string} trigger
 * @property {string|null} [school] Limit the campaign to one school; omit for all schools.
 * @property {Object<string, *>} [user_segment]
 * @property {number|null} [total_limit]
 * @property {number} [per_user_limit]
 * @property {string} start_date
 * @property {string|null} [end_date]
 * @property {boolean} [is_active]
 */

/**
 * @typedef {Object} RewardsIncentiveTrigger
 * @property {string} id
 * @property {string} name
 * @property {string} description
 * @property {''|'signup'|'daily_login'|'profile_completion'|'referral_signup'|'verification_complete'|'first_transaction'|'social_connect'|'survey_complete'|'custom_event'} trigger_type Empty on the triggers created by the initial data migration.
 * @property {Object<string, *>} trigger_metadata
 * @property {string} created_at
 */

/**
 * @typedef {Object} RewardsIncentiveTriggerRequest
 * @property {string} name
 * @property {string} [description]
 * @property {'signup'|'daily_login'|'profile_completion'|'referral_signup'|'verification_complete'|'first_transaction'|'social_connect'|'survey_complete'|'custom_event'} trigger_type
 * @property {Object<string, *>} [trigger_metadata]
 */

/**
 * @typedef {Object} RewardsLeaderboardParticipant
 * @property {string} id
 * @property {string} name
 * @property {string} email
 * @property {string|null} fan_id
 * @property {number} points
 * @property {number} rank
 * @property {Array<{source: string, points: number, entries: number}>} source_breakdown
 * @property {Array<{id: string, created_at: string, points: number, earning_source: string, description: string, merchant_name: string}>} entries Up to 150 latest ledger rows.
 */

/**
 * @typedef {Object} RewardsLeaderboardRow
 * @property {string} id
 * @property {number} rank
 * @property {string} name Full name, or the email when the fan has no name.
 * @property {string} email
 * @property {string|null} fan_id
 * @property {number} points
 */

/**
 * Partial update body. `school` is ignored.
 * @typedef {Object} RewardsPatchedWeeklyPrizeRequest
 * @property {string} [reward] Leaderboard reward of the same school; fills title, description, type, terms and cover.
 * @property {string} [title]
 * @property {string} [description]
 * @property {GiveawayTypeEnum} [giveaway_type]
 * @property {string} [how_to_win]
 * @property {string} [location]
 * @property {string} [terms]
 * @property {string} [cover_title]
 * @property {string} [cover_text]
 * @property {string} [cover_image] Cover image URL.
 * @property {Blob} [cover_image_file] Cover image upload.
 * @property {string|null} [winner]
 * @property {number|null} [winning_points]
 * @property {boolean} [is_active]
 * @property {boolean} [is_featured]
 * @property {Object<string, *>} [metadata]
 * @property {string|null} [week_start_at]
 * @property {string|null} [week_end_at]
 * @property {string} [week_start_date]
 * @property {string} [week_end_date]
 * @property {string|null} [week_start_time]
 * @property {string|null} [week_end_time]
 */

/**
 * @typedef {Object} RewardsPerson
 * @property {string} id
 * @property {string} first_name
 * @property {string} last_name
 * @property {string} [email] Only for staff and superusers.
 */

/**
 * @typedef {Object} RewardsPointsHistoryEntry
 * @property {string} id
 * @property {string} transaction_type
 * @property {number} points Positive when earned, negative when spent.
 * @property {number} balance_after
 * @property {string} description
 * @property {string} created_at
 * @property {string|null} earning_source
 * @property {string|null} spending_source
 * @property {string|null} external_transaction_id
 * @property {Object<string, *>} metadata
 * @property {{id: string, name: string}|null} merchant
 * @property {string|null} merchant_name
 * @property {{id: string, reward: {id: string, title: string, points_cost: number}, status: RedemptionStatusEnum, requested_at: string}|null} redemption
 */

/**
 * @typedef {Object} RewardsPrizeImage
 * @property {string|null} id
 * @property {string} image_path
 * @property {string|null} image_url
 * @property {number} order
 * @property {Object<string, *>} [crop] Crop frames; absent on the cover fallback.
 */

/**
 * @typedef {Object} RewardsRaffle
 * @property {string} id
 * @property {string} title
 * @property {string} description
 * @property {number} points_cost
 * @property {string|null} drawing_date
 * @property {'draft'|'active'|'completed'|'cancelled'} status
 * @property {string|null} start_date
 * @property {number} max_entries_per_user
 * @property {number|null} max_total_entries
 * @property {number} total_entries
 * @property {RewardsPerson|null} winner
 */

/**
 * @typedef {Object} RewardsRaffleInfo
 * @property {string} id
 * @property {string|null} start_date
 * @property {string|null} unlock_date Same instant as start_date.
 * @property {string|null} drawing_date
 * @property {'draft'|'active'|'completed'|'cancelled'} status
 * @property {number} max_entries_per_user
 * @property {number|null} max_total_entries
 * @property {number} total_entries
 * @property {number} user_entries The signed-in fan's entries.
 * @property {string|null} winner Winner user id.
 * @property {string|null} drawn_at
 */

/**
 * @typedef {Object} RewardsRaffleListItem
 * @property {string} id
 * @property {string} title
 * @property {string|null} school School name.
 * @property {string|null} school_id
 * @property {'draft'|'active'|'completed'|'cancelled'} status
 * @property {string|null} drawing_date
 */

/**
 * @typedef {Object} RewardsRaffleTicket
 * @property {string} id
 * @property {string} user
 * @property {string|null} raffle Null for a universal ticket, valid in any raffle.
 * @property {string} raffle_title `Universal Ticket` for a universal one.
 * @property {boolean} is_universal
 * @property {boolean} is_available Not used and not expired.
 * @property {string} granted_at
 * @property {string|null} granted_by_campaign
 * @property {string|null} used_at
 * @property {string|null} used_for_entry
 * @property {string|null} expires_at
 * @property {Object<string, *>} metadata
 */

/**
 * @typedef {Object} RewardsRedemption
 * @property {string} id
 * @property {string} reward
 * @property {string} reward_title
 * @property {string|null} size The size the fan chose; null for rewards without sizes, or once the size is removed
 * @property {string} size_label Label of the chosen size at redemption time, kept after the size is renamed or removed
 * @property {number} points_spent
 * @property {PaymentMethodEnum} payment_method
 * @property {number|null} amount_paid_cents
 * @property {RedemptionStatusEnum} [status]
 * @property {string} [fulfillment_channel]
 * @property {string} requested_at
 * @property {string|null} fulfilled_at
 * @property {boolean} [w9_collected]
 * @property {string|null} w9_collected_at When staff confirmed the fan's W-9; needed before a redemption worth $600 or more is fulfilled.
 * @property {''|'sms'|'email'} contact_method How the fan asked to be reached at checkout (Revamp v2); empty when no contact was asked.
 * @property {string} contact_value The email address (lowercase) or the phone number (digits, a leading + kept) for `contact_method`; empty without one.
 */

/**
 * @typedef {Object} RewardsRedemptionRequest
 * @property {string} reward
 * @property {number} points_spent Must equal the reward's points price unless a raffle ticket pays.
 * @property {RedemptionStatusEnum} [status]
 * @property {string} [fulfillment_channel]
 * @property {boolean} [use_raffle_ticket] Pay a raffle entry with an unused ticket (this raffle's first, then a universal one).
 * @property {string} [raffle_ticket_id] The ticket to use with `use_raffle_ticket`.
 * @property {boolean} [age_confirmed] The 18+ confirmation; the server stamps the time.
 * @property {string} [size_id] The size to redeem, one of the reward's `sizes`. Required when `sizes` is not empty; leave it out for a reward without sizes.
 * @property {'sms'|'email'} [contact_method] How to reach the fan about the reward (Revamp v2 checkout step). Required with `contact_value` for a checkout reward of a school with Revamp v2 on; ignored...
 * @property {string} [contact_value] The email address or the phone number for `contact_method`; stored lowercase for an email and as digits (a leading + kept) for a phone.
 */

/**
 * @typedef {Object} RewardsReward
 * @property {string} id
 * @property {string} title
 * @property {string} description
 * @property {number} points_cost
 * @property {number|null} cash_price_cents USD price in cents; hidden (null) when card purchases are off for the viewer.
 * @property {number} points_required Same as points_cost.
 * @property {RewardTypeEnum} reward_type
 * @property {RedemptionTypeEnum} redemption_type
 * @property {boolean} has_inventory
 * @property {number|null} inventory_count Items left; null means unlimited. With sizes, the sum of the sizes' stock.
 * @property {boolean} is_sold_out Stock is tracked and nothing is left to redeem: `has_inventory` with `inventory_count` 0 or null, or every size at 0. Clients keep the reward on screen and...
 * @property {Array<RewardsRewardSize>} sizes Sizes to pick from, in picker order (`position`); empty for a reward without sizes.
 * @property {boolean} is_active
 * @property {boolean} is_featured
 * @property {string} created_at
 * @property {string|null} merchant
 * @property {string|null} school
 * @property {Array<RewardsImage>} images Images shown on the reward screen (portrait).
 * @property {Array<RewardsImage>} gallery Every image, untouched, for the admin.
 * @property {RewardsImage|null} cover_image The image on the list card; null when none is shown in landscape.
 * @property {string|null} image_url Cover image URL for older clients.
 * @property {RewardsRaffleInfo|null} raffle_info Set only on raffle rewards.
 * @property {RewardsAuctionInfo|null} auction_info Set only on auction rewards.
 * @property {boolean} [is_locked] True for non-raffle rewards in early-release schools. Left out of the answer to a partial update.
 * @property {Array<string>} [gift_card_codes] Redeemable codes of gift-card rewards. Only for staff and superusers.
 * @property {string|null} [owner] Who hands the reward out and gets its reminders, a staff member of its school or a superuser. Only for staff and superusers, like the four fields below.
 * @property {string} [owner_name] The owner's full name (or email); empty without an owner.
 * @property {string|null} [retail_value] What one redemption is worth in USD (ARV), two decimals. At $600 or more a redemption needs a W-9 before it is fulfilled.
 * @property {string|null} [event_at] When the experience or ticketed event takes place; the owner's reminders count down to it.
 * @property {Array<'owner'|'owner_inactive'|'retail_value'|'event_at'>} [action_required] What the reward still lacks; `owner_inactive` when the owner is no longer active or no longer staff of the school, `event_at` only for experiences. Empty...
 */

/**
 * @typedef {Object} RewardsRewardList
 * @property {Array<RewardsReward>} results
 * @property {number} count
 */

/**
 * One size of a reward, with its own stock.
 * @typedef {Object} RewardsRewardSize
 * @property {string} id
 * @property {string} label
 * @property {number} position Order in the picker, 0 first.
 * @property {number} inventory_count Items of this size left.
 * @property {boolean} is_available True while `inventory_count` is above 0.
 */

/**
 * @typedef {Object} RewardsRewardSizeWrite
 * @property {string} [id] An existing size of this reward; leave it out for a new size.
 * @property {string} label Trimmed; unique within the reward, ignoring case.
 * @property {number} inventory_count
 * @property {number} [position] Optional; the list order is used without it. Positions are renumbered from 0.
 * @property {number} [stock_seen] Existing sizes: the stock the form was opened with. The change from `stock_seen` to `inventory_count` is applied to the stock left now (never below 0), so...
 */

/**
 * Fields the reward views read besides the serializer fields.
 * @typedef {Object} RewardsRewardWriteExtras
 * @property {string} [drawing_date] Raffle rewards. Creates the raffle, or moves its drawing date on update.
 * @property {string} [start_date] Raffle rewards: when entries open, a week before `drawing_date` by default. Auction rewards: when bidding starts.
 * @property {string} [end_date] Auction rewards. The auction is created or changed only when `start_date`, `end_date` and `starting_bid` are all sent.
 * @property {string} [starting_bid] Auction rewards.
 * @property {string} [minimum_increment] Auction rewards.
 * @property {string} [copy_images_from] Create only, when no files are sent. Copies the pictures and crops of another reward of the same school.
 * @property {string} [image_crops] JSON with the crop frames, `new` for the uploaded files (create) and `existing` keyed by image id (update).
 * @property {string} [image_order] JSON list with the final order of the images.
 * @property {Array<RewardsRewardSizeWrite>|string} [sizes] The full list of sizes after the save: sizes left out are removed (refused while a size has redemptions), the others are renamed, restocked and reordered as...
 * @property {number} [inventory_count_seen] Update of a reward without sizes: the count the form was opened with. The change from it to `inventory_count` is applied to the count left now (never below...
 */

/**
 * @typedef {Object} RewardsSetupTaskConfig
 * @property {number} profile Points for creating the profile.
 * @property {number} link_card Points for linking a card.
 * @property {number} safari_extension Points for activating the Safari extension.
 * @property {string|null} updated_at
 */

/**
 * @typedef {Object} RewardsSetupTaskResult
 * @property {boolean} awarded
 * @property {boolean} already_claimed
 * @property {boolean} eligible
 * @property {number} points
 * @property {'profile'|'link_card'|'safari_extension'} task
 * @property {RewardsSetupTaskConfig} [rewards]
 * @property {string} [awarded_at] Only when points were awarded by this call.
 * @property {boolean} [skipped] Only when the school does not need the Safari extension.
 * @property {boolean} [error] Only when evaluating the task failed.
 */

/**
 * Reward as the image-management endpoints return it (lighter than RewardsReward).
 * @typedef {Object} RewardsStaffReward
 * @property {string} id
 * @property {string} title
 * @property {string} description
 * @property {number} points_cost
 * @property {number|null} cash_price_cents
 * @property {RewardTypeEnum} reward_type
 * @property {RedemptionTypeEnum} redemption_type
 * @property {string|null} merchant
 * @property {string} [merchant_name] Only when the reward has a merchant.
 * @property {string|null} school
 * @property {string} [school_name] Only when the reward has a school.
 * @property {boolean} is_active
 * @property {string} created_at
 * @property {Array<RewardsImage>} images
 * @property {{id?: string, drawing_date?: string|null, status?: string, start_date?: string|null, unlock_date?: string|null, max_entries_per_user?: number, max_total_entries?: number|null, total_entries?: number}|null} raffle_info Set only on raffle rewards.
 * @property {{id?: string, start_date?: string|null, end_date?: string|null, status?: string, starting_bid?: number|null, current_highest_bid?: number|null, minimum_increment?: number|null, total_bids?: number, is_active?: boolean}|null} auction_info Set only on auction rewards.
 */

/**
 * A weekly school prize.
 * @typedef {Object} RewardsWeeklyPrize
 * @property {string} id
 * @property {string} title
 * @property {GiveawayTypeEnum} giveaway_type
 * @property {string} description
 * @property {string} how_to_win
 * @property {string} location
 * @property {string} terms
 * @property {string} cover_image
 * @property {string|null} cover_image_url
 * @property {string} cover_title
 * @property {string} cover_text
 * @property {Array<RewardsPrizeImage>} images
 * @property {Array<RewardsPrizeImage>} gallery
 * @property {string} school
 * @property {string} school_name
 * @property {string|null} reward Leaderboard reward this prize shows.
 * @property {string} [reward_title] Absent when no leaderboard reward is linked.
 * @property {string|null} week_start_at
 * @property {string|null} week_end_at
 * @property {string} week_start_date
 * @property {string} week_end_date
 * @property {string|null} week_start_time
 * @property {string|null} week_end_time
 * @property {string|null} winner
 * @property {string|null} winner_name
 * @property {string|null} winner_email
 * @property {number|null} winning_points
 * @property {boolean} is_active
 * @property {boolean} is_featured
 * @property {Object<string, *>} metadata
 * @property {string} created_at
 * @property {string} updated_at
 */

/**
 * Create body. Without `reward`, title, description and giveaway_type are also required.
 * @typedef {Object} RewardsWeeklyPrizeRequest
 * @property {string} [reward] Leaderboard reward of the same school; fills title, description, type, terms and cover.
 * @property {string} [title]
 * @property {string} [description]
 * @property {GiveawayTypeEnum} [giveaway_type]
 * @property {string} [how_to_win]
 * @property {string} [location]
 * @property {string} [terms]
 * @property {string} [cover_title]
 * @property {string} [cover_text]
 * @property {string} [cover_image] Cover image URL.
 * @property {Blob} [cover_image_file] Cover image upload.
 * @property {string|null} [winner]
 * @property {number|null} [winning_points]
 * @property {boolean} [is_active]
 * @property {boolean} [is_featured]
 * @property {Object<string, *>} [metadata]
 * @property {string|null} [week_start_at]
 * @property {string|null} [week_end_at]
 * @property {string} week_start_date
 * @property {string} week_end_date
 * @property {string|null} [week_start_time]
 * @property {string|null} [week_end_time]
 */

/**
 * @typedef {Object} ScheduleEventRequest
 * @property {string} schedule
 * @property {string} opponent_name
 * @property {string|null} [opponent_school] Set when the opponent is a school we already have; its logo is used.
 * @property {string} [opponent_logo_url] Uploaded logo, used only when the opponent is not a school in our system.
 * @property {string} [location_name]
 * @property {string|null} [latitude]
 * @property {string|null} [longitude]
 * @property {boolean} [check_in_enabled] Whether fans can check in at this event.
 * @property {number} [check_in_radius_m] Metres from the pin within which a fan can check in. Kept when check-in is switched off, so turning it back on restores the radius.
 * @property {number} [check_in_points] Points awarded for a successful check-in. Kept when check-in is switched off, so turning it back on restores the amount.
 * @property {boolean} [is_home] Home game for this school. Away games count toward Road Warrior.
 * @property {boolean} [is_championship] Championship / playoff game for Playoff Pilgrim.
 * @property {string} date
 * @property {string|null} [time] Blank means TBD.
 * @property {number|null} [home_score] Final score for the home school. Blank until the game is over.
 * @property {number|null} [away_score] Final score for the opponent. Blank until the game is over.
 * @property {number|null} [tap_target] Tap game: the shared tap count that wins. Blank means no tap game on this game.
 */

/**
 * @typedef {Object} School
 * @property {string} id
 * @property {string} name
 * @property {string|null} [abbreviation]
 * @property {string} type
 * @property {string} city
 * @property {string} state
 * @property {string|null} [image]
 * @property {string|null} [banner_image]
 * @property {string|null} [primary_color]
 * @property {string|null} [secondary_color]
 * @property {string|null} [badge_background_color] Badge body fill. Empty keeps the template color.
 * @property {string|null} [badge_accent_color] Badge strokes and icons. Empty keeps the template color.
 * @property {boolean} [badge_accent_follows_school_color] When set, badge accent uses the Embed Appearance school color.
 * @property {string|null} [rewards_title]
 * @property {string|null} [mascot]
 * @property {boolean} [is_active]
 * @property {boolean} [content_active]
 * @property {boolean} [travel_active] When enabled, show the Travel tab in navigation for this school.
 * @property {boolean} [games_active] When enabled, show the Games tab in navigation for this school.
 * @property {boolean} [tap_game_active] When enabled, fans can play the tap game on games that have a target number.
 * @property {boolean} [revamp_v2] Turns the V2 program on for the school's fans and lets superusers publish bonus drops. Only a superuser changes it; staff of the school get a 403 for a...
 * @property {string} [commission_split] Percentage of commission that goes to the school (0-100). Default is 70%
 * @property {Array<string>} [twitter_accounts] List of Twitter account usernames (without \@) to display in social feed
 * @property {string} [sweepstakes_name] The name the official rules give the sweepstakes. Empty: the program name and "Sweepstakes".
 * @property {string} [official_rules_text] The official rules of the prize draws, pasted in full and printed word for word. Empty: built from the program data. Bonus drops always get the built rules....
 * @property {boolean} [early_release]
 * @property {boolean} [is_stripe_feature_enabled] When enabled, users see card-priced rewards and can pay with Stripe.
 * @property {ExtensionModeEnum} [extension_mode]
 * @property {string|null} [extension_app_url]
 * @property {string|null} [extension_app_url_android] Google Play page for the app the extension ships in; the Apple one is extension_app_url.
 * @property {*} [onboarding] Onboarding timeline: sections, updates, and action completion state
 * @property {*} [reward_selections] Reward/experience voting selections: votes, notes, catalog items
 */

/**
 * @typedef {Object} SchoolBackgroundUpload
 * @property {Blob} [background]
 * @property {Blob} [image] Alternative name for `background`.
 */

/**
 * @typedef {Object} SchoolBadgeCatalog
 * @property {Array<{slug: string, title: string, description: string, image_url: string, image_url_locked: string, selected: boolean}>} badges
 * @property {string} badge_background_color
 * @property {string} badge_accent_color
 * @property {string} school_color
 */

/**
 * @typedef {Object} SchoolBrandStub
 * @property {string} id
 * @property {string} name
 * @property {string} image
 * @property {string} primary_color
 */

/**
 * @typedef {Object} SchoolConversionWarnings
 * @property {Array<string>} [conversion_warnings] Only in the answer to a save that changed `revamp_v2`, and only when something was left
 */

/**
 * @typedef {Object} SchoolCreatedId
 * @property {boolean} success
 * @property {string} id
 */

/**
 * @typedef {Object} SchoolDataPortal
 * @property {{id: string, name: string, mascot: string, image: string, primary_color: string}} school
 * @property {Array<{key: string, label: string, value: number, target: number}>} signals
 * @property {Array<{key: string, title: string, summary: string, confidence: number, confidence_label: string, insights: Array<{key: string, text: string, score: number, score_label: string, needs: Array<SchoolDataPortalNeed>, suggestions: Array<{kind: string, key: string, action: string, gain: number}>}>, datasets: Array<{key: string, label: string, description: string, priority: number, provided: boolean, upload_count: number, latest_upload: SchoolDataUpload|null}>, datasets_provided: number, datasets_total: number}>} initiatives
 * @property {string} computed_at
 */

/**
 * What an insight needs. `kind: school` is a dataset the school provides (with
 * @typedef {Object} SchoolDataPortalNeed
 * @property {'school'|'homecrowd'} kind
 * @property {string} key
 * @property {string} label
 * @property {string} [description]
 * @property {number} weight
 * @property {number} coverage
 * @property {boolean} [provided]
 * @property {SchoolDataUpload|null} [latest_upload]
 * @property {number} [value]
 * @property {number} [target]
 */

/**
 * @typedef {Object} SchoolDataUpload
 * @property {string} id
 * @property {string} dataset_key
 * @property {string} initiative
 * @property {string} original_filename
 * @property {string} content_type
 * @property {number} size_bytes
 * @property {boolean} stored
 * @property {number|null} row_count Only counted for CSV and spreadsheet files.
 * @property {Array<string>} columns
 * @property {string} notes
 * @property {string} uploaded_by Email of the uploader; empty if gone.
 * @property {string|null} created_at
 */

/**
 * @typedef {Object} SchoolEmbedApiKey
 * @property {string} schoolId
 * @property {boolean} hasKey
 * @property {string} [prefix]
 * @property {boolean} [is_active]
 * @property {string} [createdAt]
 * @property {string|null} [rotatedAt]
 * @property {string|null} [revokedAt]
 * @property {string|null} [lastUsedAt]
 * @property {string} [rawKey] The secret. Only in the answers that create or rotate the key.
 */

/**
 * Hex colours, `*Opacity` percentages (0 to 100), blur radii, icon types, image URLs
 * @typedef {Object} SchoolEmbedAppearance
 * @property {string} schoolId
 * @property {string} headerLogoUrl
 * @property {string} loginBackgroundUrl
 * @property {string} emailSelectionBackgroundUrl
 * @property {string} welcomeScreenImageUrl
 * @property {number} headerLogoSize
 * @property {string} buttonPrimaryIconType
 * @property {string} buttonSecondaryIconType
 * @property {number} cardBlur
 * @property {string} pageBackground
 * @property {string} cardBackground
 * @property {string} containerBorder
 * @property {string} headingText
 * @property {string} bodyText
 * @property {string} link
 * @property {string} chrome
 * @property {string} button
 * @property {string} buttonPrimaryText
 * @property {string} buttonPrimaryBorder
 * @property {string} buttonPrimaryIcon
 * @property {string} buttonSecondary
 * @property {string} buttonSecondaryText
 * @property {string} buttonSecondaryBorder
 * @property {string} buttonSecondaryIcon
 * @property {string} loginButton
 * @property {string} loginButtonText
 * @property {string} loginTitle
 * @property {string} loginText
 * @property {string} loginSignup
 * @property {string} loginCardBackground
 * @property {string} subheaderText
 * @property {string} checkboxBorder
 * @property {string} checkboxCheck
 * @property {string} emailInputTitle
 * @property {string} emailInputBorder
 * @property {string} emailInputText
 * @property {string} passwordInputTitle
 * @property {string} passwordInputBorder
 * @property {string} passwordInputText
 * @property {string} loginButtonBorder
 * @property {string} inApp
 * @property {string} inAppAccent
 * @property {number} pageBackgroundOpacity
 * @property {number} cardBackgroundOpacity
 * @property {number} containerBorderOpacity
 * @property {number} headingTextOpacity
 * @property {number} bodyTextOpacity
 * @property {number} linkOpacity
 * @property {number} chromeOpacity
 * @property {number} buttonOpacity
 * @property {number} buttonPrimaryTextOpacity
 * @property {number} buttonPrimaryBorderOpacity
 * @property {number} buttonPrimaryIconOpacity
 * @property {number} buttonSecondaryOpacity
 * @property {number} buttonSecondaryTextOpacity
 * @property {number} buttonSecondaryBorderOpacity
 * @property {number} buttonSecondaryIconOpacity
 * @property {number} loginButtonOpacity
 * @property {number} loginButtonTextOpacity
 * @property {number} loginTitleOpacity
 * @property {number} loginTextOpacity
 * @property {number} loginSignupOpacity
 * @property {number} loginCardBackgroundOpacity
 * @property {number} subheaderTextOpacity
 * @property {number} checkboxBorderOpacity
 * @property {number} checkboxCheckOpacity
 * @property {number} emailInputTitleOpacity
 * @property {number} emailInputBorderOpacity
 * @property {number} emailInputTextOpacity
 * @property {number} passwordInputTitleOpacity
 * @property {number} passwordInputBorderOpacity
 * @property {number} passwordInputTextOpacity
 * @property {number} loginButtonBorderOpacity
 * @property {number} inAppOpacity
 * @property {number} inAppAccentOpacity
 * @property {number} emailSelectionCardBlur
 * @property {number} loginCardBlur
 */

/**
 * The same fields as the appearance, each optional (without `schoolId`).
 * @typedef {Object} SchoolEmbedAppearanceChange
 * @property {string} [headerLogoUrl]
 * @property {string} [loginBackgroundUrl]
 * @property {string} [emailSelectionBackgroundUrl]
 * @property {string} [welcomeScreenImageUrl]
 * @property {number} [headerLogoSize]
 * @property {string} [buttonPrimaryIconType]
 * @property {string} [buttonSecondaryIconType]
 * @property {number} [cardBlur]
 * @property {string} [pageBackground]
 * @property {string} [cardBackground]
 * @property {string} [containerBorder]
 * @property {string} [headingText]
 * @property {string} [bodyText]
 * @property {string} [link]
 * @property {string} [chrome]
 * @property {string} [button]
 * @property {string} [buttonPrimaryText]
 * @property {string} [buttonPrimaryBorder]
 * @property {string} [buttonPrimaryIcon]
 * @property {string} [buttonSecondary]
 * @property {string} [buttonSecondaryText]
 * @property {string} [buttonSecondaryBorder]
 * @property {string} [buttonSecondaryIcon]
 * @property {string} [loginButton]
 * @property {string} [loginButtonText]
 * @property {string} [loginTitle]
 * @property {string} [loginText]
 * @property {string} [loginSignup]
 * @property {string} [loginCardBackground]
 * @property {string} [subheaderText]
 * @property {string} [checkboxBorder]
 * @property {string} [checkboxCheck]
 * @property {string} [emailInputTitle]
 * @property {string} [emailInputBorder]
 * @property {string} [emailInputText]
 * @property {string} [passwordInputTitle]
 * @property {string} [passwordInputBorder]
 * @property {string} [passwordInputText]
 * @property {string} [loginButtonBorder]
 * @property {string} [inApp]
 * @property {string} [inAppAccent]
 * @property {number} [pageBackgroundOpacity]
 * @property {number} [cardBackgroundOpacity]
 * @property {number} [containerBorderOpacity]
 * @property {number} [headingTextOpacity]
 * @property {number} [bodyTextOpacity]
 * @property {number} [linkOpacity]
 * @property {number} [chromeOpacity]
 * @property {number} [buttonOpacity]
 * @property {number} [buttonPrimaryTextOpacity]
 * @property {number} [buttonPrimaryBorderOpacity]
 * @property {number} [buttonPrimaryIconOpacity]
 * @property {number} [buttonSecondaryOpacity]
 * @property {number} [buttonSecondaryTextOpacity]
 * @property {number} [buttonSecondaryBorderOpacity]
 * @property {number} [buttonSecondaryIconOpacity]
 * @property {number} [loginButtonOpacity]
 * @property {number} [loginButtonTextOpacity]
 * @property {number} [loginTitleOpacity]
 * @property {number} [loginTextOpacity]
 * @property {number} [loginSignupOpacity]
 * @property {number} [loginCardBackgroundOpacity]
 * @property {number} [subheaderTextOpacity]
 * @property {number} [checkboxBorderOpacity]
 * @property {number} [checkboxCheckOpacity]
 * @property {number} [emailInputTitleOpacity]
 * @property {number} [emailInputBorderOpacity]
 * @property {number} [emailInputTextOpacity]
 * @property {number} [passwordInputTitleOpacity]
 * @property {number} [passwordInputBorderOpacity]
 * @property {number} [passwordInputTextOpacity]
 * @property {number} [loginButtonBorderOpacity]
 * @property {number} [inAppOpacity]
 * @property {number} [inAppAccentOpacity]
 * @property {number} [emailSelectionCardBlur]
 * @property {number} [loginCardBlur]
 */

/**
 * @typedef {Object} SchoolFirstReward
 * @property {string} id
 * @property {string} title
 * @property {string} description
 * @property {string} whats_included
 * @property {number} points_cost
 * @property {string} reward_type
 * @property {string} image_url
 * @property {string} confirmation_image_url
 * @property {string} location
 * @property {number} order Position on the ladder, from 0.
 * @property {boolean} is_active
 * @property {Array<string>} images
 * @property {Array<{id: string, image_path: string, image_url: string, order: number, crop: Object<string, *>}>} image_details
 */

/**
 * @typedef {Object} SchoolFirstRewardWrite
 * @property {string} [id] Present to update a rung in place.
 * @property {string} title
 * @property {string} [description]
 * @property {string} [whats_included]
 * @property {number} points_cost
 * @property {RewardTypeEnum} [reward_type]
 * @property {string} [image_url]
 * @property {string} [confirmation_image_url]
 * @property {string} [location]
 * @property {boolean} [is_active]
 * @property {Array<string>} [images] Ordered http(s) URLs; replaces the gallery.
 * @property {Array<Object<string, *>>} [image_crops] Crop for each image, in the same order.
 */

/**
 * @typedef {Object} SchoolGamePhoto
 * @property {string} id
 * @property {string} image_url
 * @property {boolean} is_winner
 */

/**
 * @typedef {Object} SchoolGamePhotoUpload
 * @property {Blob} [image] Image file (multipart only).
 * @property {string} [image_url] http(s) URL of an image already hosted.
 */

/**
 * @typedef {Object} SchoolGameSquad
 * @property {Array<{id: string, name: string, cover_url: string, checked_in: number, predicted: number}>} squads The fan's squads at the school, oldest membership first, for the switcher.
 * @property {{id: string, name: string, member_count: number}|null} squad The squad the lists are for; null when the fan has no squad.
 * @property {{home_score: number, away_score: number}|null} final The final score; null until it is set.
 * @property {Array<SchoolGameSquadPerson>} members The whole roster of the squad, the fan first, then by name.
 * @property {{ranked: boolean, rows: Array<SchoolGameSquadPerson & {home_score: number|null, away_score: number|null, hidden: boolean, error: number|null, rank: number|null}>}} predictions
 * @property {{visible: boolean, rows: Array<SchoolGameSquadPerson>}} check_ins
 */

/**
 * @typedef {Object} SchoolGameSquadPerson
 * @property {string} user_id
 * @property {string} display_name First and last name, or "Fan" without either.
 * @property {boolean} is_you
 */

/**
 * @typedef {Object} SchoolImageUpload
 * @property {Blob} image
 */

/**
 * @typedef {Object} SchoolImageUrl
 * @property {string} image_url
 */

/**
 * @typedef {Object} SchoolLeaderboardConfig
 * @property {boolean} has_saved_config
 * @property {boolean} leaderboard_active
 * @property {boolean} enabled
 * @property {string} timezone
 * @property {number} week_boundary_weekday 0 is Monday.
 * @property {number} week_boundary_hour
 * @property {number} week_boundary_minute
 * @property {number} scoring_period_days
 * @property {number} top_rank_count
 * @property {string} included_earning_sources Comma separated earning sources; empty means all.
 * @property {boolean} include_null_earning_source
 */

/**
 * @typedef {Object} SchoolLeaderboardConfigChange
 * @property {boolean} [leaderboard_active]
 * @property {boolean} [enabled]
 * @property {string} [timezone]
 * @property {number} [week_boundary_weekday]
 * @property {number} [week_boundary_hour]
 * @property {number} [week_boundary_minute]
 * @property {number} [scoring_period_days]
 * @property {number} [top_rank_count]
 * @property {string} [included_earning_sources]
 * @property {boolean} [include_null_earning_source]
 */

/**
 * @typedef {Object} SchoolMerchantsPageConfig
 * @property {string} schoolName
 * @property {boolean} revampV2 Whether the school has Revamp v2 on; a client that has no signed-in fan yet reads the flag here.
 * @property {string} schoolShort
 * @property {string} abbreviation
 * @property {string} mascotName
 * @property {string} rewardsTitle
 * @property {string} logoUrl
 * @property {string} headerLogoUrl
 * @property {string} schoolImageUrl
 * @property {string} primaryColor
 * @property {string} inApp
 * @property {string} inAppColor
 * @property {string} inAppAccent
 * @property {string} inAppAccentColor
 * @property {string} darkColor
 * @property {string} accentColor
 * @property {string} backgroundColor
 * @property {string} secondaryColor
 * @property {string} containerBorderColor
 * @property {string} chromeColor
 * @property {string} headingTextColor
 * @property {string} bodyTextColor
 * @property {string} linkColor
 * @property {string} buttonColor
 * @property {string} buttonFillColor
 * @property {string} buttonBorderColor
 * @property {string} buttonPrimaryTextColor
 * @property {string} buttonPrimaryBorder
 * @property {string} buttonPrimaryBorderColor
 * @property {string} buttonPrimaryIcon
 * @property {string} buttonPrimaryIconColor
 * @property {string} buttonPrimaryIconType
 * @property {string} buttonSecondaryColor
 * @property {string} buttonSecondaryTextColor
 * @property {string} buttonSecondaryBorder
 * @property {string} buttonSecondaryBorderColor
 * @property {string} buttonSecondaryIcon
 * @property {string} buttonSecondaryIconColor
 * @property {string} buttonSecondaryIconType
 * @property {string} loginBackgroundUrl
 * @property {string} emailSelectionBackgroundUrl
 * @property {string} welcomeScreenImageUrl
 * @property {string} loginButtonColor
 * @property {string} loginButtonTextColor
 * @property {string} loginTitleColor
 * @property {string} loginTextColor
 * @property {string} loginSignupColor
 * @property {string} loginCardBackground
 * @property {string} emailInputTitleColor
 * @property {string} emailInputBorderColor
 * @property {string} emailInputTextColor
 * @property {string} loginInputTitleColor
 * @property {string} loginInputBorderColor
 * @property {string} loginInputTextColor
 * @property {string} passwordInputTitleColor
 * @property {string} passwordInputBorderColor
 * @property {string} passwordInputTextColor
 * @property {string} loginButtonBorderColor
 * @property {number} loginCardBackgroundOpacity
 * @property {number} pageBackgroundOpacity
 * @property {number} cardBackgroundOpacity
 * @property {number} containerBorderOpacity
 * @property {number} headingTextOpacity
 * @property {number} bodyTextOpacity
 * @property {number} linkOpacity
 * @property {number} chromeOpacity
 * @property {number} buttonOpacity
 * @property {number} inAppOpacity
 * @property {number} inAppAccentOpacity
 * @property {number} buttonPrimaryTextOpacity
 * @property {number} buttonPrimaryBorderOpacity
 * @property {number} buttonPrimaryIconOpacity
 * @property {number} buttonSecondaryOpacity
 * @property {number} buttonSecondaryTextOpacity
 * @property {number} buttonSecondaryBorderOpacity
 * @property {number} buttonSecondaryIconOpacity
 * @property {number} loginButtonOpacity
 * @property {number} loginButtonTextOpacity
 * @property {number} loginTitleOpacity
 * @property {number} loginTextOpacity
 * @property {number} loginSignupOpacity
 * @property {number} emailInputTitleOpacity
 * @property {number} emailInputBorderOpacity
 * @property {number} emailInputTextOpacity
 * @property {number} loginInputTitleOpacity
 * @property {number} loginInputBorderOpacity
 * @property {number} loginInputTextOpacity
 * @property {number} passwordInputTitleOpacity
 * @property {number} passwordInputBorderOpacity
 * @property {number} passwordInputTextOpacity
 * @property {number} loginButtonBorderOpacity
 * @property {number} emailSelectionCardBlur
 * @property {number} loginCardBlur
 * @property {number} cardBlur
 * @property {number} headerLogoSize
 * @property {string} extension_mode
 * @property {string} extensionMode
 * @property {string} extension_app_url
 * @property {string} extensionAppUrl
 * @property {string} [extension_app_url_android]
 * @property {string} [extensionAppUrlAndroid]
 */

/**
 * @typedef {Object} SchoolOnboardingTimeline
 * @property {Array<Object<string, *>>} sections
 * @property {Object<string, *>} [updates]
 * @property {Object<string, boolean>} [checked]
 */

/**
 * @typedef {Object} SchoolPaymentStatement
 * @property {string} id
 * @property {string} school
 * @property {string} school_name
 * @property {string} period
 * @property {number} amount_cents
 * @property {number} transaction_count
 * @property {Array<Object<string, *>>} line_items
 * @property {string|null} sent_at
 * @property {boolean} is_sent
 * @property {string} notes
 * @property {string} created_at
 * @property {string} updated_at
 */

/**
 * A game as anybody may see it.
 * @typedef {Object} SchoolPublicGame
 * @property {string} id
 * @property {string} sport
 * @property {string} opponent_name
 * @property {string} logo_url The logo to show; the linked school's logo wins over an uploaded one.
 * @property {string} opponent_logo_url Uploaded logo, used only when the opponent is not one of our schools.
 * @property {string} location_name
 * @property {boolean} is_home
 * @property {boolean} is_championship
 * @property {string} date Game day (UTC).
 * @property {string|null} time Kick-off time in UTC; null means TBD.
 * @property {boolean} time_tbd True when `time` is null; show "TBD" rather than midnight.
 * @property {string} starts_at Kick-off in UTC; midnight of `date` when there is no `time`.
 * @property {boolean} check_in_enabled
 * @property {string} check_in_opens_at 15 minutes before `starts_at`.
 * @property {string} check_in_closes_at 12 hours after kick-off; for a TBD game, 12:00 UTC the day after `date`.
 */

/**
 * @typedef {Object} SchoolRequest
 * @property {string} name
 * @property {string|null} [abbreviation]
 * @property {string} type
 * @property {string} city
 * @property {string} state
 * @property {string|null} [image]
 * @property {string|null} [banner_image]
 * @property {string|null} [primary_color]
 * @property {string|null} [secondary_color]
 * @property {string|null} [badge_background_color] Badge body fill. Empty keeps the template color.
 * @property {string|null} [badge_accent_color] Badge strokes and icons. Empty keeps the template color.
 * @property {boolean} [badge_accent_follows_school_color] When set, badge accent uses the Embed Appearance school color.
 * @property {string|null} [rewards_title]
 * @property {string|null} [mascot]
 * @property {boolean} [is_active]
 * @property {boolean} [content_active]
 * @property {boolean} [travel_active] When enabled, show the Travel tab in navigation for this school.
 * @property {boolean} [games_active] When enabled, show the Games tab in navigation for this school.
 * @property {boolean} [tap_game_active] When enabled, fans can play the tap game on games that have a target number.
 * @property {boolean} [revamp_v2] Turns the V2 program on for the school's fans and lets superusers publish bonus drops. Only a superuser changes it; staff of the school get a 403 for a...
 * @property {string} [commission_split] Percentage of commission that goes to the school (0-100). Default is 70%
 * @property {Array<string>} [twitter_accounts] List of Twitter account usernames (without \@) to display in social feed
 * @property {string} [sweepstakes_name] The name the official rules give the sweepstakes. Empty: the program name and "Sweepstakes".
 * @property {string} [official_rules_text] The official rules of the prize draws, pasted in full and printed word for word. Empty: built from the program data. Bonus drops always get the built rules....
 * @property {boolean} [early_release]
 * @property {boolean} [is_stripe_feature_enabled] When enabled, users see card-priced rewards and can pay with Stripe.
 * @property {ExtensionModeEnum} [extension_mode]
 * @property {string|null} [extension_app_url]
 * @property {string|null} [extension_app_url_android] Google Play page for the app the extension ships in; the Apple one is extension_app_url.
 * @property {*} [onboarding] Onboarding timeline: sections, updates, and action completion state
 * @property {*} [reward_selections] Reward/experience voting selections: votes, notes, catalog items
 */

/**
 * @typedef {Object} SchoolRewardSelections
 * @property {Object<string, *>} [votes]
 * @property {Object<string, *>} [notes]
 * @property {Array<Object<string, *>>} [sections]
 * @property {Array<Object<string, *>>} [catalog]
 */

/**
 * @typedef {Object} SchoolScheduleEvent
 * @property {string} id
 * @property {string} schedule
 * @property {string} opponent_name
 * @property {string|null} [opponent_school] Set when the opponent is a school we have; its logo is then used.
 * @property {string} [opponent_school_name] Empty when the opponent is not a school we have.
 * @property {string} [opponent_logo_url] Uploaded logo, used only when the opponent is not one of our schools.
 * @property {string} logo_url The logo to show; the linked school's logo wins over an uploaded one.
 * @property {string} [location_name]
 * @property {string|null} [latitude] Decimal degrees as a string.
 * @property {string|null} [longitude]
 * @property {boolean} [check_in_enabled]
 * @property {number} [check_in_radius_m]
 * @property {number} [check_in_points]
 * @property {boolean} [is_home]
 * @property {boolean} [is_championship]
 * @property {boolean} already_checked_in Whether the signed-in fan has checked in.
 * @property {boolean} already_predicted Whether the signed-in fan has predicted the score.
 * @property {{home_score: number, away_score: number}|null} my_prediction The fan's prediction; null if none.
 * @property {string} date Game day (UTC), as entered for a TBD game.
 * @property {string|null} [time] Kick-off time in UTC; null means TBD.
 * @property {string} starts_at Kick-off in UTC; midnight of `date` when there is no `time`.
 * @property {string} prediction_locks_at Predictions lock at kick-off (23:59:59 UTC of `date` for a TBD game).
 * @property {string} check_in_opens_at 15 minutes before `starts_at`.
 * @property {string} check_in_closes_at 12 hours after kick-off; for a TBD game, 12:00 UTC the day after `date`.
 * @property {number|null} [home_score] Final score; null until the game is over.
 * @property {number|null} [away_score]
 * @property {number|null} [tap_target] Tap game: the shared tap count that wins; null means no tap game on this game.
 * @property {SchoolTapGame} tap_game
 * @property {string} created_at
 * @property {string} updated_at
 */

/**
 * @typedef {Object} SchoolSeasonTicketHold
 * @property {string} user_id
 * @property {string} email
 * @property {string} started_on
 * @property {number} years_held
 */

/**
 * A game's tap game as the caller sees it. `status` is `live` until the winning tap,
 * @typedef {Object} SchoolTapGame
 * @property {boolean} enabled The school has `tap_game_active` on and the game has a target.
 * @property {boolean} entered The caller has answered the entry question in this round.
 * @property {number} count Taps so far in this round.
 * @property {number} round Starts at 1 and goes up each time a superuser starts the game over.
 * @property {'live'|'finished'} status
 * @property {{user_id: string, display_name: string, is_you: boolean}|null} winner The fan whose tap hit the target; null until then.
 */

/**
 * @typedef {Object} SchoolWaitlistEntry
 * @property {boolean} success
 * @property {string} id
 * @property {boolean} created
 */

/**
 * UserSerializer for non-superusers: roles, account state and points are read-only.
 * @typedef {Object} ScopedUserRequest
 * @property {string} email
 * @property {string} first_name
 * @property {string} last_name
 * @property {string|null} [city]
 * @property {string|null} [state]
 * @property {string|null} [phone_number]
 * @property {boolean} [is_instruction_complete]
 */

/**
 * @typedef {Object} SocialOk
 * @property {boolean} ok
 */

/**
 * @typedef {Object} SocialSquadActivity
 * @property {string} id
 * @property {string} member_id
 * @property {string} display_name
 * @property {boolean} is_you
 * @property {number} points
 * @property {string} created_at
 * @property {'Travel'|'Online'|'In-network'|'Daily login'|'Card draw'|'Referral'|'Signup'|'Bonus'|'Points'} source Where the points came from.
 */

/**
 * @typedef {Object} SocialSquadAdminRow
 * @property {string} id
 * @property {string} name
 * @property {{id: string, name: string, image: string}|null} school
 * @property {string} cover_url
 * @property {string} join_code
 * @property {string|null} created_at
 * @property {string|null} last_joined_at
 * @property {{id: string|null, display_name: string, email: string}} created_by
 * @property {number} member_count
 * @property {number} lifetime_points
 * @property {number} games_attended
 * @property {number} predictions_made
 * @property {Array<{id: string, display_name: string, email: string, role: 'admin'|'member', is_owner: boolean, lifetime_points: number, joined_at: string|null}>} members
 */

/**
 * @typedef {SocialSquadCover & {id: string, name: string, member_count: number}} SocialSquadCard
 */

/**
 * @typedef {Object} SocialSquadCover
 * @property {string} cover_url Empty when the squad has no cover.
 * @property {number} cover_scale
 * @property {number} cover_x
 * @property {number} cover_y
 */

/**
 * @typedef {SocialSquadCard & {lifetime_points: number, games_attended: number, is_admin: boolean, is_member: boolean, join_code: string, members: Array<SocialSquadMember>}} SocialSquadDetail
 */

/**
 * @typedef {Object} SocialSquadGameWinners
 * @property {string} id
 * @property {string} name
 * @property {string} cover_url Empty when the squad has no cover.
 * @property {Object<string, {user_id: string, display_name: string, is_you: boolean}>} winners Keyed by the id of a finished game.
 */

/**
 * @typedef {Object} SocialSquadJoin
 * @property {string} code The squad's 8 character join code.
 */

/**
 * @typedef {Object} SocialSquadMember
 * @property {string} id
 * @property {string} first_name
 * @property {string} last_name
 * @property {string} display_name First and last name, or "Fan" when both are empty.
 * @property {string} fan_id
 * @property {number} lifetime_points
 * @property {'admin'|'member'} role
 * @property {boolean} is_owner True for the fan who created the squad.
 * @property {number} rank Position by lifetime points inside the squad, from 1.
 * @property {boolean} is_you
 */

/**
 * @typedef {SocialSquadCard & {lifetime_points: number, rank: number, is_member: boolean}} SocialSquadStanding
 */

/**
 * @typedef {Object} SocialSquadWrite
 * @property {string} [name] Required to create; optional on edit.
 * @property {Blob} [cover] Cover image file (multipart only).
 * @property {number} [cover_scale] 1 to 4; values outside are clamped.
 * @property {number} [cover_x] -100 to 100; values outside are clamped.
 * @property {number} [cover_y] -100 to 100; values outside are clamped.
 */

/**
 * @typedef {Object} SocialTweet
 * @property {string} [id]
 * @property {string} [text]
 * @property {{name?: string, username?: string, profile_image_url?: string|null}} [author]
 * @property {string} [created_at]
 * @property {{like_count?: number, retweet_count?: number, reply_count?: number, quote_count?: number}} [public_metrics]
 * @property {Array<{type?: string, url?: string|null, width?: number|null, height?: number|null}>} [media]
 */

/**
 * @typedef {Object} SocialTwitterFeed
 * @property {Array<SocialTweet>} tweets
 * @property {string} handle
 * @property {'api'|'static'} source
 * @property {string|null} note Why the list is empty; null for live posts.
 * @property {{name?: string|null, username?: string|null, profile_image_url?: string|null, description?: string|null, followers_count?: number}} [user_info] Only present when `source` is `api`.
 */

/**
 * @typedef {Object} SportSchedule
 * @property {string} id
 * @property {string} school
 * @property {string} sport
 * @property {number} event_count
 * @property {string} created_at
 * @property {string} updated_at
 */

/**
 * @typedef {Object} SportScheduleRequest
 * @property {string} school
 * @property {string} sport
 */

/**
 * @typedef {Object} StaffAnalyticsIngestRequest
 * @property {Array<{event_type: 'screen_visit'|'search'|'offer_detail_view'|'offer_link_click'|'reward_detail_view'|'reward_click'|'reward_redeem', payload?: *, client_surface?: 'app'|'embed'|null}>} events One to 50 events.
 * @property {'app'|'embed'} [client_surface] Client that sent the batch.
 */

/**
 * @typedef {Object} StaffAnalyticsIngestResult
 * @property {number} accepted Events stored.
 */

/**
 * * `draft` - Draft
 * @typedef {'draft'|'active'|'deactivated'} Status11fEnum
 */

/**
 * @typedef {Object} TokenRefresh
 * @property {string} access
 * @property {string} refresh
 */

/**
 * @typedef {Object} TokenRefreshRequest
 * @property {string} refresh
 */

/**
 * @typedef {Object} TransactionRequest
 * @property {string|null} [user]
 * @property {string|null} [olive_card]
 * @property {string} [amount]
 * @property {string|null} [commission_amount] Commission amount from transaction
 * @property {number} [points_earned]
 * @property {string} [currency]
 * @property {TransactionStatusEnum} status
 * @property {string} external_txn_id
 * @property {string} raw_descriptor
 * @property {number|null} [wildfire_merchant_id] Wildfire merchant ID
 * @property {string|null} [wildfire_merchant_name] Wildfire merchant name
 * @property {string|null} [olive_merchant_id] Olive merchant ID
 * @property {string|null} [olive_merchant_name] Olive merchant name
 */

/**
 * * `auth` - Authorized
 * @typedef {'auth'|'captured'|'refunded'|'voided'|'failed'} TransactionStatusEnum
 */

/**
 * One purchase as the activity list shows it.
 * @typedef {Object} TransactionsActivityRow
 * @property {string} id
 * @property {number} amount
 * @property {string} currency
 * @property {string} description
 * @property {string|null} merchant_name
 * @property {string|null} merchant_logo_url
 * @property {'olive'|'wildfire'|''} source Which network the purchase came from; empty for others.
 * @property {string|null} date
 * @property {string|null} created_at
 * @property {string} status auth, captured, refunded, voided or failed.
 * @property {'card'|'stripe'} type
 * @property {string|null} card_id
 * @property {string|null} card_nickname
 * @property {string|null} last4
 * @property {string|null} card_scheme
 * @property {number} points_earned
 * @property {number} entries_earned Dream entries this purchase added, negative when a refund took them back; 0 when it added none. Counted per purchase, so a merged row sums its purchases....
 * @property {string|null} category
 * @property {string} transaction_id External transaction id.
 * @property {Array<string>} [merged_transaction_ids] Present only on a merged row ("N items"); the `transaction_id` of every merged purchase in order, the first one included. Lets a client pair a Stripe...
 * @property {number} round_up_amount
 * @property {number} rounded_amount
 * @property {number} original_amount
 * @property {boolean} settled
 * @property {string|null} reward_status
 * @property {number} available_offer_count
 * @property {number|null} wildfire_merchant_id
 * @property {string|null} wildfire_merchant_name
 * @property {string|null} olive_merchant_id
 * @property {string|null} olive_merchant_name
 * @property {string|null} travel_merchant_name
 * @property {number} commission_amount
 * @property {number} school_commission_split Share of the commission that goes to the school, 0 to 1.
 * @property {string|null} merchant_order_id
 * @property {number} matching_amount
 * @property {string|null} store_id
 * @property {string|null} brand_id
 * @property {string|null} member_id
 */

/**
 * @typedef {Object} TransactionsCardCheck
 * @property {boolean} exists
 * @property {boolean} activated
 * @property {string} [card_id]
 * @property {string} [last4]
 * @property {string} [message]
 * @property {string} [error] Only when reactivation failed.
 */

/**
 * @typedef {Object} TransactionsCardEnrolled
 * @property {boolean} success
 * @property {string} message
 * @property {string} user_id
 * @property {string} card_id
 * @property {string} last4
 * @property {string} scheme
 * @property {boolean} active
 * @property {boolean} default
 * @property {string|null} [nickname] Not returned by the token endpoint.
 * @property {boolean} [reactivated] Only when an inactive card was switched back on.
 * @property {boolean} [test_mode]
 * @property {TransactionsSetupReward} [setup_reward]
 */

/**
 * One transaction. `amount` and `commission_amount` are decimal strings;
 * @typedef {Object} TransactionsEntry
 * @property {string} id
 * @property {string|null} user Owner id; null when the user was deleted.
 * @property {string} user_name Full name, else the email; `Unknown User` when the owner is gone.
 * @property {string} user_email Empty when the owner is gone.
 * @property {{id: string, name: string, image: string|null}|null} school
 * @property {string|null} olive_card
 * @property {string|null} merchant_name
 * @property {string} amount Decimal string, 2 places.
 * @property {number} dollar_amount
 * @property {number} amount_dollars
 * @property {string|null} commission_amount Decimal string, 6 places.
 * @property {number} points_earned
 * @property {number} points_amount
 * @property {string} currency
 * @property {string} status auth, captured, pending, refunded, voided or failed.
 * @property {string} auth_at
 * @property {string|null} captured_at
 * @property {string} created_at Same moment as `auth_at`.
 * @property {string} external_txn_id
 * @property {string} raw_descriptor
 * @property {string} description
 * @property {'purchase'|'refund'|'failed'|'earn'} transaction_type
 * @property {number|null} wildfire_merchant_id
 * @property {string|null} wildfire_merchant_name
 * @property {string|null} olive_merchant_id
 * @property {string|null} olive_merchant_name
 * @property {string|null} reward_name
 * @property {number} school_commission_split Share of the commission that goes to the school, 0 to 1 (0.7 when no school is known).
 * @property {string|null} merchant_order_id
 * @property {number|null} wildfire_application_id
 * @property {number} [consolidated_count] Only on a row that merges several purchases.
 * @property {string|null} [vendor_status] Latest status the vendor reported.
 * @property {'pending'|'received'|'distributed'|'refunded'|'failed'} [funnel_status]
 * @property {string|null} [received_at]
 * @property {string|null} [current_commission] Decimal string.
 * @property {string|null} [current_amount] Decimal string.
 * @property {string|null} [full_commission] Decimal string.
 * @property {string|null} [full_amount] Decimal string.
 * @property {boolean} [ever_nonzero]
 */

/**
 * @typedef {Object} TransactionsMember
 * @property {boolean} success
 * @property {string} message
 * @property {string} user_id
 * @property {string} olive_member_id
 * @property {string} [external_id]
 * @property {boolean} [active]
 * @property {boolean} [existing_member] True when the member was already on file.
 * @property {boolean} [test_mode]
 */

/**
 * @typedef {Object} TransactionsOliveCard
 * @property {string} id
 * @property {string} last4
 * @property {string} scheme
 * @property {boolean} active
 * @property {boolean} default
 * @property {string|null} nickname
 * @property {string|null} created
 * @property {number} expiry_month
 * @property {number} expiry_year
 * @property {string|null} integration_status
 * @property {number} transaction_count
 */

/**
 * The "link card" setup reward, as awarded or already claimed.
 * @typedef {Object} TransactionsSetupReward
 * @property {string} [task]
 * @property {boolean} [eligible]
 * @property {boolean} [awarded]
 * @property {boolean} [already_claimed]
 * @property {number} [points]
 * @property {string|null} [awarded_at]
 * @property {Object<string, *>} [rewards]
 */

/**
 * A transaction as school staff and superusers see it: TransactionsEntry with the
 * @typedef {TransactionsEntry & Object<string, *>} TransactionsStaffEntry
 */

/**
 * @typedef {Object} TravelSession
 * @property {string} session_token
 * @property {string} sdk_url Script that hosts the booking client.
 * @property {string} embed_path Path of `GET /api/travel/embed/` with the token filled in.
 */

/**
 * @typedef {Object} UserSchoolRequest
 * @property {boolean} [is_primary]
 */

/**
 * The school settings the app and the embed read.
 * @typedef {Object} UsersActiveSchool
 * @property {string} id
 * @property {string} name
 * @property {string} type
 * @property {string} city
 * @property {string} state
 * @property {string|null} primary_color
 * @property {string|null} secondary_color
 * @property {string|null} image
 * @property {string|null} banner_image
 * @property {boolean} content_active
 * @property {boolean} travel_active
 * @property {boolean} games_active
 * @property {boolean} tap_game_active
 * @property {boolean} revamp_v2 The school's V2 program (entries, prizes, bonus drops). Off by default; only a superuser turns it on or off.
 * @property {Array<string>} twitter_accounts
 * @property {boolean} early_release
 * @property {boolean} is_stripe_feature_enabled
 * @property {ExtensionModeEnum} extension_mode
 * @property {string|null} extension_app_url
 * @property {Object<string, *>} tier_config Tier configuration for the school.
 */

/**
 * @typedef {Object} UsersAssignSchoolRequest
 * @property {string} school_id
 */

/**
 * @typedef {Object} UsersAssignSchoolResult
 * @property {boolean} success
 * @property {string} message
 * @property {UsersFan} user
 * @property {number} auto_raffle_entries Always 0; free entries are claimed by the fan, not granted here.
 * @property {Array<string>} raffle_titles Always empty.
 * @property {Array<UsersClaimableRaffle>} eligible_raffles
 */

/**
 * @typedef {Object} UsersAssignSchoolUserResult
 * @property {boolean} success
 * @property {string} message
 * @property {UsersFan} user
 */

/**
 * @typedef {Object} UsersCheckIn
 * @property {string} id
 * @property {string} location_id
 * @property {string|null} location_name
 * @property {{id: string, email: string, first_name: string, last_name: string, display_name: string, active_school: {id: string, name: string}|null}} user
 * @property {number} latitude
 * @property {number} longitude
 * @property {number} distance_meters
 * @property {boolean} success
 * @property {string|null} created_at
 */

/**
 * @typedef {Object} UsersCheckInLocation
 * @property {string} id
 * @property {string} name
 * @property {string} address
 * @property {number} latitude
 * @property {number} longitude
 * @property {number} radius_meters
 * @property {boolean} is_active
 * @property {string|null} created_at
 * @property {string|null} updated_at
 * @property {number|null} check_in_count
 * @property {boolean} already_checked_in
 * @property {{id: string, distance_meters: number, created_at: string|null}|null} my_check_in
 */

/**
 * @typedef {Object} UsersCheckInLocations
 * @property {boolean} success
 * @property {Array<UsersCheckInLocation>} locations
 */

/**
 * @typedef {Object} UsersCheckInRequest
 * @property {string} location_id
 * @property {number} latitude
 * @property {number} longitude
 */

/**
 * @typedef {Object} UsersCheckInResult
 * @property {boolean} success
 * @property {string} message
 * @property {UsersCheckIn} check_in
 * @property {UsersCheckInLocation} location
 */

/**
 * A school raffle the fan can claim a free entry in.
 * @typedef {Object} UsersClaimableRaffle
 * @property {string} raffle_id
 * @property {string} reward_id
 * @property {string} id Same as `reward_id`.
 * @property {string} title
 * @property {string} description
 * @property {number} points_cost
 * @property {string} redemption_type
 * @property {boolean} force_prompt
 * @property {string|null} image_url
 * @property {Array<{id?: string, image_path?: string, order?: number, is_primary?: boolean, caption?: string|null}>} images
 * @property {string|null} drawing_date
 * @property {{id?: string, start_date?: string|null, unlock_date?: string|null, drawing_date?: string|null, status?: string, max_entries_per_user?: number, max_total_entries?: number|null, total_entries?: number, user_entries?: number, winner?: string|null, drawn_at?: string|null}} raffle_info
 */

/**
 * @typedef {Object} UsersContactSupportRequest
 * @property {string} message
 * @property {string} [platform]
 * @property {string} [device_model]
 * @property {string} [os_version]
 * @property {string} [app_version]
 * @property {string} [environment]
 * @property {string} [timezone]
 * @property {string} [screen]
 * @property {string} [build_type]
 * @property {string} [push_token]
 */

/**
 * The fan, as the app reads them.
 * @typedef {Object} UsersFan
 * @property {string} id
 * @property {string} email
 * @property {string} first_name
 * @property {string} last_name
 * @property {string|null} fan_id
 * @property {UsersActiveSchool|null} active_school Null until the fan chooses a school.
 * @property {boolean} is_staff
 * @property {boolean} is_superuser
 * @property {boolean} is_embed_tester
 * @property {boolean} is_merchant_specialist
 * @property {boolean} is_active
 * @property {string} date_joined
 * @property {string} created_at
 * @property {number} current_points
 * @property {number} lifetime_points
 * @property {number} referral_count
 * @property {string|null} city
 * @property {string|null} state
 * @property {string|null} phone_number
 * @property {boolean} email_verified
 * @property {string|null} email_verified_at
 * @property {string|null} olive_member_id
 * @property {boolean} has_password False for fans who signed up with Google or Apple and never set a password.
 * @property {string|null} referral_code
 * @property {RegistrationSourceEnum} registration_source
 * @property {boolean} is_extension_enabled
 * @property {boolean} is_instruction_complete
 * @property {UsersTier} current_tier
 */

/**
 * One page of fans.
 * @typedef {Object} UsersFanPage
 * @property {number} count
 * @property {string|null} next
 * @property {string|null} previous
 * @property {Array<UsersFan>} results
 */

/**
 * @typedef {Object} UsersInviteFriendRequest
 * @property {string} email
 * @property {string} [school_id] Brands the invite email.
 */

/**
 * @typedef {Object} UsersInviteSent
 * @property {boolean} success
 * @property {string} message
 */

/**
 * @typedef {Object} UsersLeaderboardDisplay
 * @property {string} top_left Name shortened to first name and last initial.
 * @property {string} bottom_left
 * @property {string} top_right
 */

/**
 * @typedef {Object} UsersLeaderboardDisplayRow
 * @property {string} id
 * @property {string} top_left
 * @property {string} bottom_left
 * @property {string} top_right
 */

/**
 * @typedef {Object} UsersLeaderboardRow
 * @property {string} id
 * @property {number} rank
 * @property {string|null} fan_id
 * @property {string} name
 * @property {number} points
 * @property {UsersLeaderboardDisplay} display
 */

/**
 * The school's leaderboard configuration. A school with none shows only the first three fields.
 * @typedef {Object} UsersLeaderboardSettings
 * @property {boolean} custom_config_present
 * @property {boolean} enabled
 * @property {boolean} leaderboard_active
 * @property {string} [timezone]
 * @property {number} [week_boundary_weekday]
 * @property {number} [week_boundary_hour]
 * @property {number} [week_boundary_minute]
 * @property {number} [scoring_period_days]
 * @property {number} [top_rank_count]
 * @property {string|null} [included_earning_sources]
 * @property {boolean} [include_null_earning_source]
 */

/**
 * @typedef {Object} UsersLeaderboardStats
 * @property {number} points
 * @property {number|null} rank Null when the fan has no points in the period.
 */

/**
 * @typedef {Object} UsersManagedDocument
 * @property {boolean} success
 * @property {Object<string, *>|null} document
 */

/**
 * @typedef {Object} UsersManagedLinks
 * @property {boolean} success
 * @property {{referral_app_url: string}} links
 */

/**
 * @typedef {Object} UsersOverallPrize
 * @property {string} id
 * @property {string|null} reward_id
 * @property {string} school_id
 * @property {string} title
 * @property {string} description
 * @property {string} how_to_win
 * @property {string} terms
 * @property {string} giveaway_type
 * @property {string} cover_title
 * @property {string} cover_text
 * @property {string|null} cover_image
 * @property {string|null} cover_image_url
 * @property {Array<string>} image_urls
 * @property {Array<Object<string, *>>} image_crops
 * @property {string} start_date
 * @property {string} end_date
 * @property {string|null} start_time
 * @property {string|null} end_time
 * @property {string} overall_starts_at
 * @property {string} overall_ends_at
 * @property {string} winner_name
 * @property {number|null} winning_points
 * @property {boolean} is_finalized
 */

/**
 * @typedef {Object} UsersOverallWinner
 * @property {string} id
 * @property {string|null} fan_id
 * @property {string} name
 * @property {string} display_name
 * @property {number} points
 * @property {string} start_date
 * @property {string} end_date
 * @property {string} prize_id
 * @property {string} prize_title
 * @property {string} cover_title
 * @property {string} [email] Only for superusers.
 */

/**
 * @typedef {Object} UsersPointsSummary
 * @property {string} user_id
 * @property {number} total_points_earned
 * @property {number} total_points_redeemed
 * @property {number} available_points
 * @property {number} current_balance
 * @property {number} transaction_count
 * @property {Array<{id: string, amount: number, points_earned: number, date: string|null, merchant_name: string, status: string}>} recent_transactions
 */

/**
 * The profile fields a fan can edit.
 * @typedef {Object} UsersProfile
 * @property {string} first_name
 * @property {string} last_name
 * @property {string} email
 * @property {string|null} city
 * @property {string|null} state
 * @property {string|null} phone_number
 * @property {boolean} is_extension_enabled
 * @property {boolean} is_instruction_complete
 */

/**
 * Any subset of the profile fields.
 * @typedef {Object} UsersProfileUpdateRequest
 * @property {string} [first_name]
 * @property {string} [last_name]
 * @property {string} [email]
 * @property {string|null} [city]
 * @property {string|null} [state]
 * @property {string|null} [phone_number] Ten digits once formatting is removed.
 * @property {boolean} [is_extension_enabled]
 * @property {boolean} [is_instruction_complete]
 */

/**
 * @typedef {Object} UsersPublicProfile
 * @property {string} fan_id
 * @property {string} first_name
 * @property {string} last_name
 * @property {string} date_joined
 * @property {number} lifetime_points
 * @property {number} transaction_count
 * @property {{id: string, name: string, image: string|null, primary_color: string|null}|null} active_school
 * @property {Array<FanBadge>} badges Earned badges only.
 */

/**
 * @typedef {Object} UsersReceiptUploaded
 * @property {boolean} success
 * @property {string} message
 * @property {string} receipt_id
 * @property {string} status
 * @property {boolean} auto_approved
 */

/**
 * @typedef {Object} UsersReferralCampaign
 * @property {string|null} id Null for a fan whose school has Revamp v2 on, whose reward is the referral's own entries and no campaign.
 * @property {string|null} name
 * @property {string} incentive_type `points` or `raffle_entry` (a campaign), or `dream_entries` (entries in the current prize draw of the fan's school) for a fan whose school has Revamp v2 on.
 * @property {number} incentive_value
 * @property {string} reward_text What the fan gets for a referral: "50 points", "2 entries to Spring Giveaway raffle", "2 entries in the Fall 2026 prize draw" ("... in the prize draw" while...
 * @property {{id: string, title: string, drawing_date: string|null}|null} raffle The raffle the reward enters the fan into, when the campaign names exactly one.
 * @property {'global'|'school'} scope
 * @property {{id: string, name: string|null}|null} school
 * @property {string|null} start_date
 * @property {string|null} end_date
 */

/**
 * @typedef {Object} UsersReferralCampaignResult
 * @property {boolean} success
 * @property {UsersReferralCampaign|null} campaign
 */

/**
 * @typedef {Object} UsersReferralLeaderboard
 * @property {boolean} success
 * @property {Array<UsersReferralLeaderboardRow>} leaderboard
 * @property {Array<UsersLeaderboardDisplayRow>} leaderboard_rows
 * @property {{referral_count: number, rank: number|null}} user_stats
 */

/**
 * @typedef {Object} UsersReferralLeaderboardRow
 * @property {string} id
 * @property {number} rank
 * @property {string|null} fan_id
 * @property {string} name
 * @property {number} referrals
 * @property {UsersLeaderboardDisplay} display
 */

/**
 * @typedef {Object} UsersReferralSummary
 * @property {boolean} success
 * @property {string} referral_code
 * @property {string} share_url
 * @property {string} share_text
 * @property {number} invited_count
 */

/**
 * @typedef {Object} UsersResendVerificationRequest
 * @property {string} [school_id] Brands the email.
 */

/**
 * @typedef {Object} UsersSuccessMessage
 * @property {boolean} success
 * @property {string} message
 */

/**
 * @typedef {Object} UsersSupportAttachment
 * @property {string} id
 * @property {string} url
 * @property {string} content_type
 * @property {string} filename
 * @property {number|null} file_size
 */

/**
 * @typedef {Object} UsersSupportMessage
 * @property {string} id
 * @property {string} body
 * @property {boolean} from_admin
 * @property {string} created_at
 * @property {string|null} sender_id Null for support messages.
 * @property {string} sender_name
 * @property {Array<UsersSupportAttachment>} attachments
 */

/**
 * @typedef {Object} UsersSupportRead
 * @property {boolean} success
 * @property {number} unread_count Always 0.
 */

/**
 * @typedef {Object} UsersSupportReplyRequest
 * @property {string} [body] `message` is accepted as an alias.
 * @property {Array<Blob>} [attachments]
 */

/**
 * @typedef {Object} UsersSupportThread
 * @property {boolean} exists
 * @property {boolean} closed
 * @property {number} unread_count
 * @property {Array<UsersSupportMessage>} messages
 */

/**
 * Progress of the fan through the school's tiers.
 * @typedef {Object} UsersTier
 * @property {number} level
 * @property {string} name
 * @property {string} type `onboarding` or `points`.
 * @property {number} progress Percent towards the next tier.
 * @property {string} badge_url
 * @property {string} [next_tier]
 * @property {number} [next_tier_target]
 * @property {number} [current]
 * @property {number} [target]
 * @property {boolean} [is_max]
 * @property {Object<string, boolean>} [onboarding_status]
 */

/**
 * @typedef {Object} UsersUploadReceiptRequest
 * @property {Blob} receipt JPEG, PNG, HEIC or PDF, up to 10 MB.
 * @property {number} [transaction_amount]
 * @property {string} [transaction_date]
 * @property {string} [notes]
 * @property {string} [platform]
 * @property {string} [device_model]
 * @property {string} [os_version]
 * @property {string} [app_version]
 * @property {string} [environment]
 * @property {string} [timezone]
 * @property {string} [screen]
 * @property {string} [build_type]
 * @property {string} [push_token]
 */

/**
 * A school the fan belongs to.
 * @typedef {Object} UsersUserSchool
 * @property {UsersActiveSchool} school
 * @property {boolean} is_primary
 * @property {string} joined_at
 */

/**
 * One page of school memberships.
 * @typedef {Object} UsersUserSchoolPage
 * @property {number} count
 * @property {string|null} next
 * @property {string|null} previous
 * @property {Array<UsersUserSchool>} results
 */

/**
 * @typedef {Object} UsersVerifyEmailRequest
 * @property {string} token
 */

/**
 * @typedef {Object} UsersWeeklyLeaderboard
 * @property {boolean} success
 * @property {string|null} school_id Null when the fan has no active school.
 * @property {boolean} leaderboard_active False when the school switched its leaderboard off.
 * @property {Array<UsersLeaderboardRow>} leaderboard
 * @property {Array<UsersLeaderboardDisplayRow>} leaderboard_rows
 * @property {string|null} week_start
 * @property {string|null} week_ends_at
 * @property {UsersWeeklyWinner|null} last_week_prize_winner
 * @property {UsersOverallWinner|null} last_overall_prize_winner
 * @property {UsersWeeklyPrize|null} weekly_prize
 * @property {UsersOverallPrize|null} overall_prize
 * @property {Array<UsersLeaderboardRow>} overall_leaderboard
 * @property {Array<UsersLeaderboardDisplayRow>} overall_leaderboard_rows
 * @property {string|null} [next_overall_prize_starts_at] Only when no overall prize is running.
 * @property {UsersLeaderboardSettings|null} leaderboard_settings
 * @property {UsersLeaderboardStats} user_stats
 * @property {UsersLeaderboardStats} overall_user_stats
 */

/**
 * The school's weekly prize. A school with none gets a placeholder (null `id`, title
 * @typedef {Object} UsersWeeklyPrize
 * @property {string|null} id
 * @property {string|null} reward_id
 * @property {string} school_id
 * @property {string} title
 * @property {string} description
 * @property {string} how_to_win
 * @property {string} terms
 * @property {string} giveaway_type
 * @property {string} cover_title
 * @property {string} cover_text
 * @property {string|null} cover_image
 * @property {string|null} cover_image_url
 * @property {Array<string>} image_urls
 * @property {Array<Object<string, *>>} image_crops
 * @property {string} week_start_date
 * @property {string} week_end_date
 * @property {string|null} [week_start_time] Time of day (HH:MM:SS); not on the placeholder.
 * @property {string|null} [week_end_time] Time of day (HH:MM:SS); not on the placeholder.
 * @property {string} [winner_name] Empty until a winner is drawn; not on the placeholder.
 * @property {number|null} [winning_points] Not on the placeholder.
 * @property {boolean} [is_finalized] Not on the placeholder.
 */

/**
 * Winner of the last weekly period. Finalized prizes add the prize fields; otherwise it is the top scorer of the previous week.
 * @typedef {Object} UsersWeeklyWinner
 * @property {string} id
 * @property {string|null} fan_id
 * @property {string} name
 * @property {string} display_name
 * @property {number} points
 * @property {string} week_started_at
 * @property {string} week_ended_at
 * @property {string} [week_end_date] Only for a finalized prize.
 * @property {string} [prize_id] Only for a finalized prize.
 * @property {string} [prize_title] Only for a finalized prize.
 * @property {string} [cover_title] Only for a finalized prize.
 * @property {string} [email] Only for superusers.
 */

// Request bodies and 2xx responses by operation.

/**
 * Request body of POST /api/analytics/events/.
 * @typedef {StaffAnalyticsIngestRequest} AnalyticsEventsCreateRequest
 */

/**
 * 201 response of POST /api/analytics/events/.
 * @typedef {StaffAnalyticsIngestResult} AnalyticsEventsCreateResponse
 */

/**
 * Request body of POST /api/assign-school/.
 * @typedef {UsersAssignSchoolRequest} AssignSchoolCreateRequest
 */

/**
 * 200 response of POST /api/assign-school/.
 * @typedef {UsersAssignSchoolResult} AssignSchoolCreateResponse
 */

/**
 * Request body of POST /api/auth/apple/.
 * @typedef {AuthAppleRequest} AuthAppleCreateRequest
 */

/**
 * 200, 201 response of POST /api/auth/apple/.
 * @typedef {AuthSession} AuthAppleCreateResponse
 */

/**
 * Request body of POST /api/auth/apply-referral-code/.
 * @typedef {AuthApplyReferralCodeRequest} AuthApplyReferralCodeCreateRequest
 */

/**
 * 200 response of POST /api/auth/apply-referral-code/.
 * @typedef {AuthApplyReferralCodeResult} AuthApplyReferralCodeCreateResponse
 */

/**
 * Request body of POST /api/auth/change-password/.
 * @typedef {AuthChangePasswordRequest} AuthChangePasswordCreateRequest
 */

/**
 * 200 response of POST /api/auth/change-password/.
 * @typedef {AuthPasswordChanged} AuthChangePasswordCreateResponse
 */

/**
 * Request body of POST /api/auth/check-email-exists/.
 * @typedef {AuthEmailRequest} AuthCheckEmailExistsCreateRequest
 */

/**
 * 200 response of POST /api/auth/check-email-exists/.
 * @typedef {AuthEmailExists} AuthCheckEmailExistsCreateResponse
 */

/**
 * Request body of POST /api/auth/check-email-invited/.
 * @typedef {AuthEmailRequest} AuthCheckEmailInvitedCreateRequest
 */

/**
 * 200 response of POST /api/auth/check-email-invited/.
 * @typedef {AuthEmailInvited} AuthCheckEmailInvitedCreateResponse
 */

/**
 * Request body of POST /api/auth/delete-account/.
 * @typedef {AuthDeleteAccountRequest} AuthDeleteAccountCreateRequest
 */

/**
 * 200 response of POST /api/auth/delete-account/.
 * @typedef {AuthMessage} AuthDeleteAccountCreateResponse
 */

/**
 * Request body of POST /api/auth/forgot-password/.
 * @typedef {AuthForgotPasswordRequest} AuthForgotPasswordCreateRequest
 */

/**
 * 200 response of POST /api/auth/forgot-password/.
 * @typedef {AuthMessage} AuthForgotPasswordCreateResponse
 */

/**
 * Request body of POST /api/auth/google/.
 * @typedef {AuthGoogleRequest} AuthGoogleCreateRequest
 */

/**
 * 200, 201 response of POST /api/auth/google/.
 * @typedef {AuthSession} AuthGoogleCreateResponse
 */

/**
 * Request body of POST /api/auth/login/.
 * @typedef {AuthLoginRequest} AuthLoginCreateRequest
 */

/**
 * 200 response of POST /api/auth/login/.
 * @typedef {AuthSession} AuthLoginCreateResponse
 */

/**
 * Request body of POST /api/auth/logout/.
 * @typedef {AuthLogoutRequest} AuthLogoutCreateRequest
 */

/**
 * 200 response of POST /api/auth/logout/.
 * @typedef {AuthLogoutResult} AuthLogoutCreateResponse
 */

/**
 * 200 response of GET /api/auth/me/.
 * @typedef {UsersFan} AuthMeRetrieveResponse
 */

/**
 * Request body of POST /api/auth/register/.
 * @typedef {AuthRegisterRequest} AuthRegisterCreateRequest
 */

/**
 * 201 response of POST /api/auth/register/.
 * @typedef {AuthSession} AuthRegisterCreateResponse
 */

/**
 * Request body of POST /api/auth/reset-password/.
 * @typedef {AuthResetPasswordRequest} AuthResetPasswordCreateRequest
 */

/**
 * 200 response of POST /api/auth/reset-password/.
 * @typedef {AuthMessage} AuthResetPasswordCreateResponse
 */

/**
 * Request body of POST /api/auth/token/refresh/.
 * @typedef {TokenRefreshRequest} AuthTokenRefreshCreateRequest
 */

/**
 * 200 response of POST /api/auth/token/refresh/.
 * @typedef {TokenRefresh} AuthTokenRefreshCreateResponse
 */

/**
 * 200 response of GET /api/content/active/.
 * @typedef {Array<ContentItem>} ContentActiveRetrieveResponse
 */

/**
 * 200 response of GET /api/content/by_type/.
 * @typedef {Array<ContentItem>} ContentByTypeRetrieveResponse
 */

/**
 * Request body of POST /api/content/.
 * @typedef {ContentItemCreateRequest} ContentCreateRequest
 */

/**
 * 201 response of POST /api/content/.
 * @typedef {ContentItemCreate} ContentCreateResponse
 */

/**
 * 200 response of GET /api/content/featured/.
 * @typedef {Array<ContentItem>} ContentFeaturedRetrieveResponse
 */

/**
 * Request body of POST /api/content/images/.
 * @typedef {ContentImageRequest} ContentImagesCreateRequest
 */

/**
 * Request body of PATCH /api/content/images/{id}/.
 * @typedef {PatchedContentImageRequest} ContentImagesPartialUpdateRequest
 */

/**
 * 200 response of PATCH /api/content/images/{id}/.
 * @typedef {ContentImage} ContentImagesPartialUpdateResponse
 */

/**
 * 200 response of GET /api/content/images/{id}/.
 * @typedef {ContentImage} ContentImagesRetrieveResponse
 */

/**
 * Request body of PUT /api/content/images/{id}/.
 * @typedef {ContentImageRequest} ContentImagesUpdateRequest
 */

/**
 * 200 response of PUT /api/content/images/{id}/.
 * @typedef {ContentImage} ContentImagesUpdateResponse
 */

/**
 * Request body of POST /api/content/{id}/increment_view_count/.
 * @typedef {Object<string, *>} ContentIncrementViewCountCreateRequest
 */

/**
 * 200 response of POST /api/content/{id}/increment_view_count/.
 * @typedef {Object} ContentIncrementViewCountCreateResponse
 * @property {boolean} success
 * @property {number} view_count
 */

/**
 * 200 response of GET /api/content/.
 * @typedef {Object} ContentListResponse
 * @property {number} count
 * @property {string|null} next
 * @property {string|null} previous
 * @property {Array<ContentItem|null>} results
 */

/**
 * Request body of POST /api/content/{pk}/edit/ (application/x-www-form-urlencoded).
 * @typedef {PlainContentForm} ContentPageEditRequest
 */

/**
 * 200 response of DELETE /api/content/image/{image_id}/delete/.
 * @typedef {Object} ContentPageImageDeleteResponse
 * @property {true} success
 */

/**
 * Request body of POST /api/content/{content_id}/upload-image/ (multipart/form-data).
 * @typedef {Object} ContentPageUploadImageRequest
 * @property {Array<Blob>} images
 * @property {string} [alt_text]
 * @property {string} [caption]
 * @property {string} [is_primary] `true` (any case) to mark them primary.
 */

/**
 * 200 response of POST /api/content/{content_id}/upload-image/.
 * @typedef {Object} ContentPageUploadImageResponse
 * @property {true} success
 * @property {Array<{id: string, image_path: string, order: number}>} uploaded_images
 * @property {number} successful_uploads
 * @property {number} failed_uploads
 * @property {number} total_files
 */

/**
 * Request body of POST /api/content/{content_id}/upload-video/ (multipart/form-data).
 * @typedef {Object} ContentPageUploadVideoRequest
 * @property {Blob} video
 * @property {string} [title]
 * @property {string} [is_primary] `true` (any case) to mark it primary.
 */

/**
 * 200 response of POST /api/content/{content_id}/upload-video/.
 * @typedef {Object} ContentPageUploadVideoResponse
 * @property {true} success
 * @property {string} video_id
 * @property {string} video_path
 * @property {number} order
 */

/**
 * 200 response of DELETE /api/content/video/{video_id}/delete/.
 * @typedef {Object} ContentPageVideoDeleteResponse
 * @property {true} success
 */

/**
 * Request body of PATCH /api/content/{id}/.
 * @typedef {PatchedContentItemRequest} ContentPartialUpdateRequest
 */

/**
 * 200 response of PATCH /api/content/{id}/.
 * @typedef {ContentItem} ContentPartialUpdateResponse
 */

/**
 * 200 response of GET /api/content/{id}/.
 * @typedef {ContentItem} ContentRetrieveResponse
 */

/**
 * Request body of PUT /api/content/{id}/.
 * @typedef {ContentItemRequest} ContentUpdateRequest
 */

/**
 * 200 response of PUT /api/content/{id}/.
 * @typedef {ContentItem} ContentUpdateResponse
 */

/**
 * Request body of POST /api/content/{id}/upload_image/ (multipart/form-data).
 * @typedef {Object} ContentUploadImageCreateRequest
 * @property {Blob} images
 * @property {string} [alt_text] Defaults to "Image for <title>".
 * @property {string} [caption]
 */

/**
 * 201 response of POST /api/content/{id}/upload_image/.
 * @typedef {ContentImage} ContentUploadImageCreateResponse
 */

/**
 * Request body of POST /api/content/{id}/upload_video/ (multipart/form-data).
 * @typedef {Object} ContentUploadVideoCreateRequest
 * @property {Blob} video
 * @property {string} [title]
 */

/**
 * 201 response of POST /api/content/{id}/upload_video/.
 * @typedef {ContentVideo} ContentUploadVideoCreateResponse
 */

/**
 * Request body of POST /api/content/videos/.
 * @typedef {ContentVideoRequest} ContentVideosCreateRequest
 */

/**
 * Request body of PATCH /api/content/videos/{id}/.
 * @typedef {PatchedContentVideoRequest} ContentVideosPartialUpdateRequest
 */

/**
 * 200 response of PATCH /api/content/videos/{id}/.
 * @typedef {ContentVideo} ContentVideosPartialUpdateResponse
 */

/**
 * 200 response of GET /api/content/videos/{id}/.
 * @typedef {ContentVideo} ContentVideosRetrieveResponse
 */

/**
 * Request body of PUT /api/content/videos/{id}/.
 * @typedef {ContentVideoRequest} ContentVideosUpdateRequest
 */

/**
 * 200 response of PUT /api/content/videos/{id}/.
 * @typedef {ContentVideo} ContentVideosUpdateResponse
 */

/**
 * 200 response of POST /api/embed/v1/rewards/dream/prizes/{prize_id}/enter/.
 * @typedef {DreamPrizeEnterResult} EmbedV1RewardsDreamPrizesEnterCreateResponse
 */

/**
 * 200 response of GET /api/embed/v1/rewards/dream/summary/.
 * @typedef {DreamSummary} EmbedV1RewardsDreamSummaryRetrieveResponse
 */

/**
 * Request body of POST /api/embed/v1/rewards/first-rewards/{reward_id}/redeem/.
 * @typedef {EmbedFirstRewardRedeemRequest} EmbedV1RewardsFirstRewardsRedeemCreateRequest
 */

/**
 * 200, 201 response of POST /api/embed/v1/rewards/first-rewards/{reward_id}/redeem/.
 * @typedef {EmbedFirstRewardRedemption} EmbedV1RewardsFirstRewardsRedeemCreateResponse
 */

/**
 * 200 response of GET /api/embed/v1/rewards/first-rewards/.
 * @typedef {EmbedFirstRewards} EmbedV1RewardsFirstRewardsRetrieveResponse
 */

/**
 * 200 response of GET /api/embed/v1/rewards/first-rewards/{reward_id}/.
 * @typedef {EmbedFirstRewardDetail} EmbedV1RewardsFirstRewardsRetrieve2Response
 */

/**
 * Request body of POST /api/merchant/featured-offers/.
 * @typedef {FeaturedOfferRequest} MerchantFeaturedOffersCreateRequest
 */

/**
 * 201 response of POST /api/merchant/featured-offers/.
 * @typedef {MerchantFeaturedOffer} MerchantFeaturedOffersCreateResponse
 */

/**
 * 200 response of GET /api/merchant/featured-offers/.
 * @typedef {Array<MerchantFeaturedOffer>} MerchantFeaturedOffersListResponse
 */

/**
 * Request body of PATCH /api/merchant/featured-offers/{id}/.
 * @typedef {PatchedFeaturedOfferRequest} MerchantFeaturedOffersPartialUpdateRequest
 */

/**
 * 200 response of PATCH /api/merchant/featured-offers/{id}/.
 * @typedef {MerchantFeaturedOffer} MerchantFeaturedOffersPartialUpdateResponse
 */

/**
 * 200 response of GET /api/merchant/featured-offers/{id}/.
 * @typedef {MerchantFeaturedOffer} MerchantFeaturedOffersRetrieveResponse
 */

/**
 * Request body of PUT /api/merchant/featured-offers/{id}/.
 * @typedef {FeaturedOfferRequest} MerchantFeaturedOffersUpdateRequest
 */

/**
 * 200 response of PUT /api/merchant/featured-offers/{id}/.
 * @typedef {MerchantFeaturedOffer} MerchantFeaturedOffersUpdateResponse
 */

/**
 * Request body of POST /api/merchant/merchants/.
 * @typedef {MerchantRequest} MerchantMerchantsCreateRequest
 */

/**
 * 201 response of POST /api/merchant/merchants/.
 * @typedef {Merchant} MerchantMerchantsCreateResponse
 */

/**
 * 200 response of GET /api/merchant/merchants/.
 * @typedef {PaginatedMerchantList} MerchantMerchantsListResponse
 */

/**
 * Request body of PATCH /api/merchant/merchants/{id}/.
 * @typedef {PatchedMerchantRequest} MerchantMerchantsPartialUpdateRequest
 */

/**
 * 200 response of PATCH /api/merchant/merchants/{id}/.
 * @typedef {Merchant} MerchantMerchantsPartialUpdateResponse
 */

/**
 * 200 response of GET /api/merchant/merchants/{id}/.
 * @typedef {Merchant} MerchantMerchantsRetrieveResponse
 */

/**
 * Request body of PUT /api/merchant/merchants/{id}/.
 * @typedef {MerchantRequest} MerchantMerchantsUpdateRequest
 */

/**
 * 200 response of PUT /api/merchant/merchants/{id}/.
 * @typedef {Merchant} MerchantMerchantsUpdateResponse
 */

/**
 * Request body of POST /api/merchant/upload-offer-images/ (multipart/form-data).
 * @typedef {Object} MerchantUploadOfferImagesCreateRequest
 * @property {Blob} [small_logo]
 * @property {Blob} [large_logo]
 */

/**
 * 200 response of POST /api/merchant/upload-offer-images/.
 * @typedef {Object} MerchantUploadOfferImagesCreateResponse
 * @property {string} [small_logo_url]
 * @property {string} [large_logo_url]
 */

/**
 * 200 response of GET /api/merchant/wildfire-offer-order/.
 * @typedef {Object} MerchantWildfireOfferOrderRetrieveResponse
 * @property {string} school_id
 * @property {number} count
 * @property {Array<{wildfire_merchant_id: number, name: string, logo_url: string|null, order_number: number|null, is_global: boolean}>} results
 */

/**
 * Request body of PUT /api/merchant/wildfire-offer-order/.
 * @typedef {Object} MerchantWildfireOfferOrderUpdateRequest
 * @property {string} school_id
 * @property {Array<{wildfire_merchant_id: number, order_number?: number|null, is_global?: boolean}>} entries
 */

/**
 * 200 response of PUT /api/merchant/wildfire-offer-order/.
 * @typedef {Object} MerchantWildfireOfferOrderUpdateResponse
 * @property {string} school_id
 * @property {number} created
 * @property {number} updated
 * @property {number} deleted
 */

/**
 * 200 (text/html) response of GET /merchants/{school_id}/.
 * @typedef {string} MerchantsPageRetrieveResponse
 */

/**
 * Request body of POST /api/notifications/events/.
 * @typedef {Object} NotificationsEventsCreateRequest
 * @property {string} notification_id
 * @property {'open'|'click'|'action'} event
 * @property {string} [platform]
 * @property {string} [target]
 */

/**
 * 201 response of POST /api/notifications/events/.
 * @typedef {Object} NotificationsEventsCreateResponse
 * @property {boolean} success
 */

/**
 * Request body of POST /api/notifications/fcm-token/.
 * @typedef {ContentDeviceRegistration} NotificationsFcmTokenCreateRequest
 */

/**
 * 200, 201 response of POST /api/notifications/fcm-token/.
 * @typedef {ContentDevice} NotificationsFcmTokenCreateResponse
 */

/**
 * Request body of PATCH /api/notifications/fcm-token/.
 * @typedef {Object} NotificationsFcmTokenPartialUpdateRequest
 * @property {string} token
 * @property {boolean} [notifications_enabled]
 */

/**
 * 200 response of PATCH /api/notifications/fcm-token/.
 * @typedef {ContentDevice} NotificationsFcmTokenPartialUpdateResponse
 */

/**
 * Request body of POST /api/notifications/history/{id}/resend/.
 * @typedef {Object<string, *>} NotificationsHistoryResendCreateRequest
 */

/**
 * 200 response of POST /api/notifications/history/{id}/resend/.
 * @typedef {ContentSendResult} NotificationsHistoryResendCreateResponse
 */

/**
 * 200 response of GET /api/notifications/history/.
 * @typedef {Object} NotificationsHistoryRetrieveResponse
 * @property {number} count
 * @property {number|null} next Next page number.
 * @property {number|null} previous
 * @property {Array<ContentNotificationHistory>} results
 */

/**
 * 200 response of GET /api/notifications/history/{id}/.
 * @typedef {ContentNotificationHistoryDetail} NotificationsHistoryRetrieve2Response
 */

/**
 * 200 response of GET /api/notifications/history/stats/.
 * @typedef {ContentNotificationStats} NotificationsHistoryStatsRetrieveResponse
 */

/**
 * Request body of POST /api/notifications/preview/.
 * @typedef {ContentAudience} NotificationsPreviewCreateRequest
 */

/**
 * 200 response of POST /api/notifications/preview/.
 * @typedef {Object} NotificationsPreviewCreateResponse
 * @property {number} count
 * @property {number|null} next Next page number.
 * @property {number|null} previous
 * @property {Array<ContentRecipient>} results
 */

/**
 * Request body of POST /api/notifications/send-mass/.
 * @typedef {ContentNotificationDraft} NotificationsSendMassCreateRequest
 */

/**
 * 200 response of POST /api/notifications/send-mass/.
 * @typedef {ContentSendResult} NotificationsSendMassCreateResponse
 */

/**
 * Request body of POST /api/olive/addCardDirect.
 * @typedef {Object} OliveAddCardDirectCreateRequest
 * @property {string} cardNumber
 * @property {number} expiryMonth
 * @property {number} expiryYear Two or four digits.
 * @property {string} cvv
 * @property {string} [cardholderName]
 * @property {string} [nickname]
 * @property {string} [billingZip] 5 digits or ZIP+4; also accepted as `billing_zip`.
 */

/**
 * 201 response of POST /api/olive/addCardDirect.
 * @typedef {TransactionsCardEnrolled} OliveAddCardDirectCreateResponse
 */

/**
 * Request body of POST /api/olive/addCard.
 * @typedef {Object} OliveAddCardCreateRequest
 * @property {string} token Card token from the Olive SDK.
 * @property {string} [memberId] Olive member id; looked up from the fan when omitted.
 * @property {string} [nickname]
 * @property {string} [cardholderName]
 * @property {string} [billingZip] 5 digits or ZIP+4; also accepted as `billing_zip`.
 */

/**
 * 200, 201 response of POST /api/olive/addCard.
 * @typedef {TransactionsCardEnrolled} OliveAddCardCreateResponse
 */

/**
 * 200 response of GET /api/olive/brands.
 * @typedef {Object} OliveBrandsRetrieveResponse
 * @property {boolean} success
 * @property {Array<MerchantOliveStore>} merchants
 * @property {Array<MerchantOliveStore>} brands
 * @property {number} allMerchants Stores left after filtering, before paging.
 * @property {number} totalRecords
 * @property {number} totalPages
 * @property {number} currentPage
 * @property {number} pageSize
 * @property {boolean} sortedByProximity
 */

/**
 * Request body of POST /api/olive/checkAndActivateCard.
 * @typedef {Object} OliveCheckAndActivateCardCreateRequest
 * @property {string} card_fingerprint
 */

/**
 * 200 response of POST /api/olive/checkAndActivateCard.
 * @typedef {TransactionsCardCheck} OliveCheckAndActivateCardCreateResponse
 */

/**
 * Request body of POST /api/olive/createMember.
 * @typedef {Object<string, *>} OliveCreateMemberCreateRequest
 */

/**
 * 200, 201 response of POST /api/olive/createMember.
 * @typedef {TransactionsMember} OliveCreateMemberCreateResponse
 */

/**
 * Request body of POST /api/olive/createTestTransaction.
 * @typedef {Object} OliveCreateTestTransactionCreateRequest
 * @property {number} amount
 * @property {string} merchantCategory Merchant category code.
 * @property {string} [cardId] Olive card id. Sending it makes the call fail with 500; leave it out to use the fan's first card.
 */

/**
 * 201 response of POST /api/olive/createTestTransaction.
 * @typedef {Object} OliveCreateTestTransactionCreateResponse
 * @property {boolean} success
 * @property {string} message
 * @property {{id?: string|null, amount?: number|null, currency?: string, card_id?: string|null, last4?: string|null, merchant_category?: string|null, created?: string|null, settled?: boolean, reward_amount?: number, round_up_amounts?: Array<number>}} transaction
 */

/**
 * Request body of POST /api/olive/deactivateCard.
 * @typedef {Object} OliveDeactivateCardCreateRequest
 * @property {string} cardId Olive card id.
 */

/**
 * 200 response of POST /api/olive/deactivateCard.
 * @typedef {Object} OliveDeactivateCardCreateResponse
 * @property {boolean} success
 * @property {string} message
 * @property {string} card_id
 */

/**
 * Request body of POST /api/olive/getTokenizationFields.
 * @typedef {Object<string, *>} OliveGetTokenizationFieldsCreateRequest
 */

/**
 * 200 response of POST /api/olive/getTokenizationFields.
 * @typedef {Object} OliveGetTokenizationFieldsCreateResponse
 * @property {boolean} success
 * @property {Object<string, *>} tokenization_fields Passed through from Olive (field names for number, cvv and environment key).
 * @property {string} user_id
 */

/**
 * 200 response of GET /api/olive/listCards.
 * @typedef {Object} OliveListCardsRetrieveResponse
 * @property {boolean} success
 * @property {Array<TransactionsOliveCard>} cards
 * @property {number} [total_records]
 * @property {number} [total_pages]
 * @property {string} [message] Only in TEST MODE.
 * @property {boolean} [test_mode] Only in TEST MODE.
 */

/**
 * 200 response of GET /api/olive/listTransactions.
 * @typedef {Object} OliveListTransactionsRetrieveResponse
 * @property {boolean} success
 * @property {Array<TransactionsActivityRow>} transactions
 * @property {number} total_records
 * @property {number} total_pages
 */

/**
 * 200 response of GET /api/olive/offers/.
 * @typedef {MerchantOliveOffers} OliveOffersRetrieveResponse
 */

/**
 * 200 response of GET /api/olive/offers/{offer_id}/.
 * @typedef {MerchantOliveOfferDetail} OliveOffersRetrieve2Response
 */

/**
 * 200 response of GET /api/olive/stores/snapshot/meta/.
 * @typedef {Object} OliveStoresSnapshotMetaRetrieveResponse
 * @property {boolean} success
 * @property {string} [error] Only when the cache is not usable.
 * @property {boolean} usable
 * @property {number} store_count
 * @property {string|null} synced_at
 * @property {string} payload_schema
 */

/**
 * 200 response of GET /api/olive/stores/snapshot/.
 * @typedef {Object} OliveStoresSnapshotRetrieveResponse
 * @property {boolean} success
 * @property {Array<{store_id: string, brand_id: string, offer_id: string, name: string, address: string, city: string, state: string, latitude: number, longitude: number, logoUrl: string}>} items
 * @property {{page: number, pageSize: number, totalCount: number, hasMore: boolean}} pagination
 * @property {string} [payload_schema]
 * @property {number} [store_count]
 * @property {string|null} [synced_at]
 * @property {boolean} [usable]
 */

/**
 * 200 response of GET /api/olive/testOlive.
 * @typedef {Object} OliveTestOliveRetrieveResponse
 * @property {string} message
 * @property {Array<{environment?: string, key_type?: string, key_preview?: string, status_code?: number, response?: string, success?: boolean, error?: string}>} test_results
 */

/**
 * 200 response of GET /api/olive/track-click/.
 * @typedef {MerchantTrackClick} OliveTrackClickRetrieveResponse
 */

/**
 * Request body of POST /api/payment-cards/.
 * @typedef {OliveCardRequest} PaymentCardsCreateRequest
 */

/**
 * 201 response of POST /api/payment-cards/.
 * @typedef {OliveCard} PaymentCardsCreateResponse
 */

/**
 * 200 response of GET /api/payment-cards/.
 * @typedef {PaginatedOliveCardList} PaymentCardsListResponse
 */

/**
 * Request body of PATCH /api/payment-cards/{id}/.
 * @typedef {Object} PaymentCardsPartialUpdateRequest
 * @property {string} nickname
 */

/**
 * 200 response of PATCH /api/payment-cards/{id}/.
 * @typedef {OliveCard} PaymentCardsPartialUpdateResponse
 */

/**
 * 200 response of GET /api/payment-cards/{id}/.
 * @typedef {OliveCard} PaymentCardsRetrieveResponse
 */

/**
 * Request body of POST /api/picks/games/{event_id}/pick/.
 * @typedef {Object} PicksGamesPickCreateRequest
 * @property {number} home_score The school's score.
 * @property {number} away_score The opponent's score.
 */

/**
 * 200, 201 response of POST /api/picks/games/{event_id}/pick/.
 * @typedef {PicksCard} PicksGamesPickCreateResponse
 */

/**
 * 200 response of GET /api/picks/games/{event_id}/.
 * @typedef {PicksCard} PicksGamesRetrieveResponse
 */

/**
 * 200 response of GET /api/picks/mine/.
 * @typedef {Object} PicksMineRetrieveResponse
 * @property {Array<{id: string, my_pick: {home_score: number, away_score: number}|null, checked_in: boolean}>} events
 */

/**
 * 200 response of GET /api/rewards/active/.
 * @typedef {RewardsRewardList} RewardsActiveRetrieveResponse
 */

/**
 * Request body of POST /api/rewards/auctions/{auction_id}/bid/.
 * @typedef {*} RewardsAuctionsBidCreateRequest
 */

/**
 * 201 response of POST /api/rewards/auctions/{auction_id}/bid/.
 * @typedef {Object} RewardsAuctionsBidCreateResponse
 * @property {{id: string, bid_amount: number, created_at: string}} bid
 * @property {{current_highest_bid: number, minimum_next_bid: number, total_bids: number, current_winner: {id: string, first_name: string, last_name: string}}} auction
 */

/**
 * 200 response of GET /api/rewards/auctions/{auction_id}/bids/.
 * @typedef {Object} RewardsAuctionsBidsRetrieveResponse
 * @property {string} auction_id
 * @property {number} total_bids
 * @property {Array<{id: string, user: RewardsPerson, bid_amount: number, is_winning: boolean, was_highest: boolean, created_at: string, outbid_at: string|null}>} bids
 */

/**
 * 200 response of POST /api/rewards/auctions/{auction_id}/end/.
 * @typedef {Object} RewardsAuctionsEndCreateResponse
 * @property {{id: string, status: string, ended_at: string, final_winner: RewardsPerson|null, final_bid_amount: number|null}} auction
 */

/**
 * 200 response of GET /api/rewards/auctions/{auction_id}/.
 * @typedef {RewardsAuction} RewardsAuctionsRetrieveResponse
 */

/**
 * 200 (image/svg+xml) response of GET /api/rewards/badge-art/{stem}.svg.
 * @typedef {string} RewardsBadgeArtRetrieveResponse
 */

/**
 * 200 response of GET /api/rewards/badges/.
 * @typedef {FanBadges} RewardsBadgesRetrieveResponse
 */

/**
 * Request body of POST /api/rewards/badges/shares/.
 * @typedef {Object} RewardsBadgesSharesCreateRequest
 * @property {'instagram'} platform
 */

/**
 * 201 response of POST /api/rewards/badges/shares/.
 * @typedef {Object} RewardsBadgesSharesCreateResponse
 * @property {'instagram'} platform
 * @property {number} count Shares so far.
 */

/**
 * 200 response of POST /api/rewards/card-draw/.
 * @typedef {RewardsCardDraw} RewardsCardDrawCreateResponse
 */

/**
 * 200 response of GET /api/rewards/card-draw/.
 * @typedef {RewardsCardDraw} RewardsCardDrawRetrieveResponse
 */

/**
 * 200 response of GET /api/rewards/challenges/active/.
 * @typedef {RewardsChallengeList} RewardsChallengesActiveRetrieveResponse
 */

/**
 * 200 response of POST /api/rewards/challenges/{challenge_id}/match/accept/.
 * @typedef {RewardsChallengeMatch} RewardsChallengesMatchAcceptCreateResponse
 */

/**
 * Request body of POST /api/rewards/challenges/{challenge_id}/match/.
 * @typedef {Object} RewardsChallengesMatchCreateRequest
 * @property {string} opponent_id
 */

/**
 * 201 response of POST /api/rewards/challenges/{challenge_id}/match/.
 * @typedef {RewardsChallengeMatch} RewardsChallengesMatchCreateResponse
 */

/**
 * 200 response of POST /api/rewards/challenges/{challenge_id}/match/decline/.
 * @typedef {RewardsChallengeMatch} RewardsChallengesMatchDeclineCreateResponse
 */

/**
 * 200 response of POST /api/rewards/challenges/{challenge_id}/match/nudge/.
 * @typedef {RewardsChallengeMatch} RewardsChallengesMatchNudgeCreateResponse
 */

/**
 * Request body of POST /api/rewards/challenges/{challenge_id}/match/remove/.
 * @typedef {Object} RewardsChallengesMatchRemoveCreateRequest
 * @property {string} [user_id] The invitee. `opponent_id` is accepted too.
 * @property {string} [opponent_id]
 */

/**
 * 200 response of POST /api/rewards/challenges/{challenge_id}/match/remove/.
 * @typedef {RewardsChallengeMatch} RewardsChallengesMatchRemoveCreateResponse
 */

/**
 * 200 response of GET /api/rewards/challenges/{challenge_id}/match/.
 * @typedef {RewardsChallengeMatch} RewardsChallengesMatchRetrieveResponse
 */

/**
 * 200 response of GET /api/rewards/challenges/.
 * @typedef {RewardsChallengeList} RewardsChallengesRetrieveResponse
 */

/**
 * 200 response of GET /api/rewards/challenges/{challenge_id}/.
 * @typedef {RewardsChallenge} RewardsChallengesRetrieve2Response
 */

/**
 * 200 response of GET /api/rewards/challenges/{challenge_id}/users/.
 * @typedef {Object} RewardsChallengesUsersRetrieveResponse
 * @property {Array<{id: string, first_name: string, last_name: string, display_name: string, handle: string, avatar_url: string|null}>} results
 * @property {number} count
 */

/**
 * 200 response of POST /api/rewards/daily-entry/claim/.
 * @typedef {RewardsDailyEntryClaim} RewardsDailyEntryClaimCreateResponse
 */

/**
 * 200 response of POST /api/rewards/daily-entry/decline/.
 * @typedef {RewardsDailyEntryDecline} RewardsDailyEntryDeclineCreateResponse
 */

/**
 * 200 response of POST /api/rewards/daily-login/.
 * @typedef {Object} RewardsDailyLoginCreateResponse
 * @property {boolean} success
 * @property {RewardsDailyBonus} daily_bonus
 * @property {string} timestamp
 */

/**
 * Request body of POST /api/rewards/dream-prizes/.
 * @typedef {DreamPrizeAdminRequest} RewardsDreamPrizesCreateRequest
 */

/**
 * 201 response of POST /api/rewards/dream-prizes/.
 * @typedef {DreamPrizeAdmin} RewardsDreamPrizesCreateResponse
 */

/**
 * 200 response of POST /api/rewards/dream-prizes/{prize_id}/draw/.
 * @typedef {DreamPrizeDrawResult} RewardsDreamPrizesDrawCreateResponse
 */

/**
 * 200 response of GET /api/rewards/dream-prizes/{prize_id}/leaderboard/.
 * @typedef {DreamPrizeLeaderboard} RewardsDreamPrizesLeaderboardRetrieveResponse
 */

/**
 * Request body of PATCH /api/rewards/dream-prizes/{prize_id}/.
 * @typedef {DreamPrizeAdminRequest} RewardsDreamPrizesPartialUpdateRequest
 */

/**
 * 200 response of PATCH /api/rewards/dream-prizes/{prize_id}/.
 * @typedef {DreamPrizeAdmin} RewardsDreamPrizesPartialUpdateResponse
 */

/**
 * 200 response of GET /api/rewards/dream-prizes/.
 * @typedef {DreamPrizeAdminList} RewardsDreamPrizesRetrieveResponse
 */

/**
 * 200 response of GET /api/rewards/dream-prizes/{prize_id}/.
 * @typedef {DreamPrizeAdmin} RewardsDreamPrizesRetrieve2Response
 */

/**
 * 200 response of GET /api/rewards/dream/rules/{school_id}/.
 * @typedef {DreamRules} RewardsDreamRulesRetrieveResponse
 */

/**
 * 200 response of GET /api/rewards/first-reward-redemptions/.
 * @typedef {Array<RewardsFirstRewardClaim>} RewardsFirstRewardRedemptionsRetrieveResponse
 */

/**
 * Request body of PATCH /api/rewards/first-reward-redemptions/{redemption_id}/status/.
 * @typedef {Object} RewardsFirstRewardRedemptionsStatusPartialUpdateRequest
 * @property {'pending'|'fulfilled'|'cancelled'} status
 */

/**
 * 200 response of PATCH /api/rewards/first-reward-redemptions/{redemption_id}/status/.
 * @typedef {Object} RewardsFirstRewardRedemptionsStatusPartialUpdateResponse
 * @property {string} id
 * @property {'pending'|'fulfilled'|'cancelled'} status
 */

/**
 * 200 response of GET /api/rewards/giveaways/active/.
 * @typedef {Object} RewardsGiveawaysActiveRetrieveResponse
 * @property {boolean} success
 * @property {Array<RewardsGiveaway>} giveaways
 * @property {number} count
 */

/**
 * 200 response of GET /api/rewards/giveaways/{giveaway_id}/.
 * @typedef {Object} RewardsGiveawaysRetrieveResponse
 * @property {boolean} success
 * @property {RewardsGiveaway} giveaway
 */

/**
 * Request body of POST /api/rewards/incentives/actions/.
 * @typedef {Object} RewardsIncentivesActionsCreateRequest
 * @property {string} [user_id] Defaults to the signed-in fan.
 * @property {string} action_type Campaign triggers match `signup`, `daily_login`, `profile_completion`, `referral_signup`, `verification_complete`, `first_transaction`, `social_connect`...
 * @property {Object<string, *>} [action_data] Context of the action, for example the sign-up method.
 */

/**
 * 201 response of POST /api/rewards/incentives/actions/.
 * @typedef {Object} RewardsIncentivesActionsCreateResponse
 * @property {boolean} success
 * @property {string} action_id
 * @property {Array<{campaign_name: string, incentive_type: string, incentive_value: number, grant_id: string}>} grants
 */

/**
 * 200 response of GET /api/rewards/incentives/analytics/{campaign_id}/.
 * @typedef {Object} RewardsIncentivesAnalyticsRetrieveResponse
 * @property {{id: string, name: string, incentive_type: string, incentive_value: number, is_active: boolean}} campaign
 * @property {{total_grants?: number, grants_remaining?: number|null, total_points_distributed?: number, total_raffle_entries?: number, total_dream_entries?: number, user_schools?: Object<string, number>, daily_grants?: Object<string, number>}} analytics
 */

/**
 * Request body of POST /api/rewards/incentives/campaigns/.
 * @typedef {RewardsIncentiveCampaignRequest} RewardsIncentivesCampaignsCreateRequest
 */

/**
 * 201 response of POST /api/rewards/incentives/campaigns/.
 * @typedef {RewardsIncentiveCampaign} RewardsIncentivesCampaignsCreateResponse
 */

/**
 * 200 response of GET /api/rewards/incentives/campaigns/.
 * @typedef {Object} RewardsIncentivesCampaignsRetrieveResponse
 * @property {Array<RewardsIncentiveCampaign>} results
 */

/**
 * 200 response of GET /api/rewards/incentives/campaigns/{campaign_id}/.
 * @typedef {RewardsIncentiveCampaign} RewardsIncentivesCampaignsRetrieve2Response
 */

/**
 * Request body of PUT /api/rewards/incentives/campaigns/{campaign_id}/.
 * @typedef {RewardsIncentiveCampaignRequest} RewardsIncentivesCampaignsUpdateRequest
 */

/**
 * 200 response of PUT /api/rewards/incentives/campaigns/{campaign_id}/.
 * @typedef {RewardsIncentiveCampaign} RewardsIncentivesCampaignsUpdateResponse
 */

/**
 * 200 response of GET /api/rewards/incentives/history/.
 * @typedef {Object} RewardsIncentivesHistoryRetrieveResponse
 * @property {{id: string, email: string, first_name: string, last_name: string}} user
 * @property {Array<{grant_id?: string, campaign_name: string, incentive_type?: string, incentive_value?: number, action_type?: string, granted_at?: string, metadata?: Object<string, *>}>} incentive_history
 * @property {number} total_incentives
 */

/**
 * Request body of POST /api/rewards/incentives/triggers/.
 * @typedef {RewardsIncentiveTriggerRequest} RewardsIncentivesTriggersCreateRequest
 */

/**
 * 201 response of POST /api/rewards/incentives/triggers/.
 * @typedef {RewardsIncentiveTrigger} RewardsIncentivesTriggersCreateResponse
 */

/**
 * 200 response of GET /api/rewards/incentives/triggers/.
 * @typedef {Object} RewardsIncentivesTriggersRetrieveResponse
 * @property {Array<RewardsIncentiveTrigger>} results
 */

/**
 * 200 response of GET /api/rewards/incentives/triggers/{trigger_id}/.
 * @typedef {RewardsIncentiveTrigger} RewardsIncentivesTriggersRetrieve2Response
 */

/**
 * Request body of PUT /api/rewards/incentives/triggers/{trigger_id}/.
 * @typedef {RewardsIncentiveTriggerRequest} RewardsIncentivesTriggersUpdateRequest
 */

/**
 * 200 response of PUT /api/rewards/incentives/triggers/{trigger_id}/.
 * @typedef {RewardsIncentiveTrigger} RewardsIncentivesTriggersUpdateResponse
 */

/**
 * Request body of POST /api/rewards/leaderboard-rewards/.
 * @typedef {LeaderboardRewardRequest} RewardsLeaderboardRewardsCreateRequest
 */

/**
 * 201 response of POST /api/rewards/leaderboard-rewards/.
 * @typedef {LeaderboardReward} RewardsLeaderboardRewardsCreateResponse
 */

/**
 * 200 response of GET /api/rewards/leaderboard-rewards/.
 * @typedef {Array<LeaderboardReward>} RewardsLeaderboardRewardsListResponse
 */

/**
 * Request body of PATCH /api/rewards/leaderboard-rewards/{id}/.
 * @typedef {PatchedLeaderboardRewardRequest} RewardsLeaderboardRewardsPartialUpdateRequest
 */

/**
 * 200 response of PATCH /api/rewards/leaderboard-rewards/{id}/.
 * @typedef {LeaderboardReward} RewardsLeaderboardRewardsPartialUpdateResponse
 */

/**
 * 200 response of GET /api/rewards/leaderboard-rewards/{id}/.
 * @typedef {LeaderboardReward} RewardsLeaderboardRewardsRetrieveResponse
 */

/**
 * Request body of PUT /api/rewards/leaderboard-rewards/{id}/.
 * @typedef {LeaderboardRewardRequest} RewardsLeaderboardRewardsUpdateRequest
 */

/**
 * 200 response of PUT /api/rewards/leaderboard-rewards/{id}/.
 * @typedef {LeaderboardReward} RewardsLeaderboardRewardsUpdateResponse
 */

/**
 * Request body of POST /api/rewards/overall-prizes/.
 * @typedef {DreamPrizeAdminRequest} RewardsOverallPrizesCreateRequest
 */

/**
 * 201 response of POST /api/rewards/overall-prizes/.
 * @typedef {DreamPrizeAdmin} RewardsOverallPrizesCreateResponse
 */

/**
 * 200 response of GET /api/rewards/overall-prizes/{prize_id}/leaderboard/.
 * @typedef {DreamPrizeLeaderboard} RewardsOverallPrizesLeaderboardRetrieveResponse
 */

/**
 * Request body of PATCH /api/rewards/overall-prizes/{prize_id}/.
 * @typedef {DreamPrizeAdminRequest} RewardsOverallPrizesPartialUpdateRequest
 */

/**
 * 200 response of PATCH /api/rewards/overall-prizes/{prize_id}/.
 * @typedef {DreamPrizeAdmin} RewardsOverallPrizesPartialUpdateResponse
 */

/**
 * 200 response of GET /api/rewards/overall-prizes/.
 * @typedef {DreamPrizeAdminList} RewardsOverallPrizesRetrieveResponse
 */

/**
 * 200 response of GET /api/rewards/overall-prizes/{prize_id}/.
 * @typedef {DreamPrizeAdmin} RewardsOverallPrizesRetrieve2Response
 */

/**
 * 200 response of GET /api/rewards/points/history/.
 * @typedef {Array<RewardsPointsHistoryEntry>} RewardsPointsHistoryRetrieveResponse
 */

/**
 * 200 response of GET /api/rewards/raffle-entries/summary/.
 * @typedef {Object} RewardsRaffleEntriesSummaryRetrieveResponse
 * @property {number} total
 * @property {number} active
 */

/**
 * 200 response of GET /api/rewards/raffle-tickets/.
 * @typedef {Object} RewardsRaffleTicketsListResponse
 * @property {number} count
 * @property {string|null} [next]
 * @property {string|null} [previous]
 * @property {Array<RewardsRaffleTicket>} results
 */

/**
 * 200 response of GET /api/rewards/raffle-tickets/{id}/.
 * @typedef {RewardsRaffleTicket} RewardsRaffleTicketsRetrieveResponse
 */

/**
 * 200 response of GET /api/rewards/raffle-tickets/summary/.
 * @typedef {Object} RewardsRaffleTicketsSummaryRetrieveResponse
 * @property {number} total
 * @property {number} available Unused and not expired.
 * @property {number} universal Available tickets valid for any raffle.
 * @property {number} used
 * @property {number} expired Unused and past their expiry.
 */

/**
 * 200 response of POST /api/rewards/raffles/{raffle_id}/claim-free-entry/.
 * @typedef {RewardsFreeEntryClaim} RewardsRafflesClaimFreeEntryCreateResponse
 */

/**
 * 200 response of POST /api/rewards/raffles/{raffle_id}/draw/.
 * @typedef {Object} RewardsRafflesDrawCreateResponse
 * @property {RewardsPerson} winner
 * @property {{id: string, status: string, drawn_at: string, drawn_by: string}} raffle
 * @property {{total_entries: number, pool_fingerprint: string, winning_index: number, winning_entry_id: string, rng_source: string}} draw_audit
 */

/**
 * 200 response of GET /api/rewards/raffles/{raffle_id}/entries/.
 * @typedef {Object} RewardsRafflesEntriesRetrieveResponse
 * @property {Array<{id: string, user: RewardsPerson, entry_count: number}>} results
 * @property {number} count Number of entrants.
 * @property {number} total_entries Number of entries.
 */

/**
 * 200 response of GET /api/rewards/raffles/.
 * @typedef {Object} RewardsRafflesRetrieveResponse
 * @property {Array<RewardsRaffleListItem>} results
 */

/**
 * 200 response of GET /api/rewards/raffles/{raffle_id}/.
 * @typedef {RewardsRaffle} RewardsRafflesRetrieve2Response
 */

/**
 * Request body of POST /api/rewards/redemptions/.
 * @typedef {RewardsRedemptionRequest} RewardsRedemptionsCreateRequest
 */

/**
 * 201 response of POST /api/rewards/redemptions/.
 * @typedef {RewardsRedemption} RewardsRedemptionsCreateResponse
 */

/**
 * 200 response of GET /api/rewards/redemptions/.
 * @typedef {Object} RewardsRedemptionsListResponse
 * @property {number} count
 * @property {string|null} [next]
 * @property {string|null} [previous]
 * @property {Array<RewardsRedemption>} results
 */

/**
 * Request body of PATCH /api/rewards/redemptions/{id}/.
 * @typedef {PatchedRedemptionRequest} RewardsRedemptionsPartialUpdateRequest
 */

/**
 * 200 response of PATCH /api/rewards/redemptions/{id}/.
 * @typedef {RewardsRedemption} RewardsRedemptionsPartialUpdateResponse
 */

/**
 * 200 response of GET /api/rewards/redemptions/{id}/.
 * @typedef {RewardsRedemption} RewardsRedemptionsRetrieveResponse
 */

/**
 * Request body of PUT /api/rewards/redemptions/{id}/.
 * @typedef {RedemptionRequest} RewardsRedemptionsUpdateRequest
 */

/**
 * 200 response of PUT /api/rewards/redemptions/{id}/.
 * @typedef {RewardsRedemption} RewardsRedemptionsUpdateResponse
 */

/**
 * Request body of POST /api/rewards/rewards/{reward_id}/add_images/ (multipart/form-data).
 * @typedef {Object} RewardsRewardsAddImagesCreateRequest
 * @property {Array<Blob>} images Image files.
 * @property {string} [image_crops] JSON with the crop frames of the new files.
 * @property {string} [image_order] JSON with the final order of all images.
 */

/**
 * 201 response of POST /api/rewards/rewards/{reward_id}/add_images/.
 * @typedef {Object} RewardsRewardsAddImagesCreateResponse
 * @property {RewardsStaffReward} reward
 * @property {{successful: number, failed: number, total: number}} upload_summary
 * @property {Array<{id: string, image_path: string, order: number}>} new_images
 */

/**
 * Request body of POST /api/rewards/rewards/.
 * @typedef {RewardRequest & RewardsRewardWriteExtras} RewardsRewardsCreateRequest
 */

/**
 * 201 response of POST /api/rewards/rewards/.
 * @typedef {RewardsReward} RewardsRewardsCreateResponse
 */

/**
 * 200 response of GET /api/rewards/rewards/.
 * @typedef {Array<RewardsReward>} RewardsRewardsListResponse
 */

/**
 * Request body of PATCH /api/rewards/rewards/{id}/.
 * @typedef {PatchedRewardRequest & RewardsRewardWriteExtras} RewardsRewardsPartialUpdateRequest
 */

/**
 * 200 response of PATCH /api/rewards/rewards/{id}/.
 * @typedef {RewardsReward} RewardsRewardsPartialUpdateResponse
 */

/**
 * Request body of DELETE /api/rewards/rewards/{reward_id}/remove_images/.
 * @typedef {Object} RewardsRewardsRemoveImagesDestroyRequest
 * @property {Array<string>} image_ids
 */

/**
 * 200 response of DELETE /api/rewards/rewards/{reward_id}/remove_images/.
 * @typedef {Object} RewardsRewardsRemoveImagesDestroyResponse
 * @property {RewardsStaffReward} reward
 * @property {{deleted: number, failed: number, total_requested: number, failed_ids: Array<string>}} deletion_summary
 */

/**
 * 200 response of GET /api/rewards/rewards/{id}/.
 * @typedef {RewardsReward} RewardsRewardsRetrieveResponse
 */

/**
 * Request body of PUT /api/rewards/rewards/{id}/.
 * @typedef {RewardRequest & RewardsRewardWriteExtras} RewardsRewardsUpdateRequest
 */

/**
 * 200 response of PUT /api/rewards/rewards/{id}/.
 * @typedef {RewardsReward} RewardsRewardsUpdateResponse
 */

/**
 * Request body of POST /api/rewards/setup-task-rewards/claim/.
 * @typedef {Object} RewardsSetupTaskRewardsClaimCreateRequest
 * @property {'profile'|'link_card'|'safari_extension'|'linkCard'|'safariExtension'} task
 */

/**
 * 200 response of POST /api/rewards/setup-task-rewards/claim/.
 * @typedef {RewardsSetupTaskResult} RewardsSetupTaskRewardsClaimCreateResponse
 */

/**
 * 200 response of GET /api/rewards/setup-task-rewards/.
 * @typedef {RewardsSetupTaskConfig} RewardsSetupTaskRewardsRetrieveResponse
 */

/**
 * 200 response of POST /api/rewards/setup-task-rewards/sync/.
 * @typedef {Object} RewardsSetupTaskRewardsSyncCreateResponse
 * @property {{profile: RewardsSetupTaskResult, link_card: RewardsSetupTaskResult, safari_extension: RewardsSetupTaskResult}} results
 * @property {Array<{task: string, points: number}>} awarded
 * @property {number} total_points_awarded
 * @property {RewardsSetupTaskConfig} rewards
 */

/**
 * Request body of POST /api/rewards/stripe/cancel-checkout/.
 * @typedef {Object} RewardsStripeCancelCheckoutCreateRequest
 * @property {string} session_id The `session_id` from the checkout answer (`cs_` session or `pi_` payment sheet).
 */

/**
 * 200 response of POST /api/rewards/stripe/cancel-checkout/.
 * @typedef {Object} RewardsStripeCancelCheckoutCreateResponse
 * @property {boolean} cancelled
 * @property {boolean} [paid] True when the payment already went through; nothing was cancelled.
 */

/**
 * Request body of POST /api/rewards/stripe/confirm-checkout/.
 * @typedef {Object} RewardsStripeConfirmCheckoutCreateRequest
 * @property {string} session_id The `session_id` from the checkout answer (`cs_` session or `pi_` payment sheet).
 */

/**
 * 200, 202 response of POST /api/rewards/stripe/confirm-checkout/.
 * @typedef {{redemption_id?: string, session_id: string, amount_paid_cents?: number|null, reward_type?: string, reward_title?: string, paid?: boolean, refunded?: boolean, detail?: string}|{session_id: string, paid: boolean, detail: string}} RewardsStripeConfirmCheckoutCreateResponse
 */

/**
 * Request body of POST /api/rewards/stripe/create-checkout-session/.
 * @typedef {Object} RewardsStripeCreateCheckoutSessionCreateRequest
 * @property {string} reward_id
 * @property {string} [success_url] Where Stripe sends the fan after paying. Send together with cancel_url. On this route the pair is used only when the server has allowed return-URL prefixes...
 * @property {string} [cancel_url] Where Stripe sends the fan after cancelling.
 * @property {string} [size_id] The size to buy, one of the reward's `sizes`; required when `sizes` is not empty. It goes into the session. Without Revamp v2 the paid webhook takes that...
 * @property {'email'|'sms'} contact_method
 * @property {string} contact_value Email address or phone number for the school to reach the fan.
 * @property {'payment_sheet'} [presentation] `payment_sheet` (the app's in-app sheet) starts a Stripe PaymentIntent (`pi_`) instead of an Embedded Checkout session (`cs_`).
 */

/**
 * 200 response of POST /api/rewards/stripe/create-checkout-session/.
 * @typedef {Object} RewardsStripeCreateCheckoutSessionCreateResponse
 * @property {string} client_secret Embedded Checkout client secret. The card form stays on our page.
 * @property {string} [publishable_key]
 * @property {number} charge_cents Amount charged to the card, with the Stripe fee included.
 * @property {string} session_id
 * @property {string} payment_attempt_id
 * @property {boolean} reused True when an open session was returned instead of a new one.
 */

/**
 * Request body of POST /api/rewards/stripe/email-receipt/.
 * @typedef {Object} RewardsStripeEmailReceiptCreateRequest
 * @property {string} redemption_id
 */

/**
 * 200 response of POST /api/rewards/stripe/email-receipt/.
 * @typedef {Object} RewardsStripeEmailReceiptCreateResponse
 * @property {boolean} sent
 * @property {string} email
 */

/**
 * 200 response of GET /api/rewards/user/activity/.
 * @typedef {Object} RewardsUserActivityRetrieveResponse
 * @property {Array<RewardsActivityEntry>} activity_log
 * @property {number} total_entries
 */

/**
 * Request body of POST /api/rewards/weekly-prizes/.
 * @typedef {RewardsWeeklyPrizeRequest} RewardsWeeklyPrizesCreateRequest
 */

/**
 * 201 response of POST /api/rewards/weekly-prizes/.
 * @typedef {RewardsWeeklyPrize} RewardsWeeklyPrizesCreateResponse
 */

/**
 * 200 response of GET /api/rewards/weekly-prizes/{prize_id}/leaderboard/.
 * @typedef {Object} RewardsWeeklyPrizesLeaderboardRetrieveResponse
 * @property {{id: string, title: string, is_active: boolean, type: 'weekly'}} prize
 * @property {{starts_at: string, ends_at: string}} period
 * @property {Array<RewardsLeaderboardRow>} leaderboard
 * @property {RewardsLeaderboardParticipant|null} participant Set only when `user_id` is passed.
 */

/**
 * Request body of PATCH /api/rewards/weekly-prizes/{prize_id}/.
 * @typedef {RewardsPatchedWeeklyPrizeRequest} RewardsWeeklyPrizesPartialUpdateRequest
 */

/**
 * 200 response of PATCH /api/rewards/weekly-prizes/{prize_id}/.
 * @typedef {RewardsWeeklyPrize} RewardsWeeklyPrizesPartialUpdateResponse
 */

/**
 * 200 response of GET /api/rewards/weekly-prizes/.
 * @typedef {Object} RewardsWeeklyPrizesRetrieveResponse
 * @property {Array<RewardsWeeklyPrize>} results
 * @property {number} count
 */

/**
 * 200 response of GET /api/rewards/weekly-prizes/{prize_id}/.
 * @typedef {RewardsWeeklyPrize} RewardsWeeklyPrizesRetrieve2Response
 */

/**
 * 200 response of GET /api/school/availability-emails/.
 * @typedef {Object} SchoolAvailabilityEmailsRetrieveResponse
 * @property {number} count
 * @property {Array<{id: string, name: string, is_active: boolean, pending_count: number, sent_count: number}>} results
 */

/**
 * Request body of POST /api/school/availability-emails/{school_id}/send/.
 * @typedef {Object<string, *>} SchoolAvailabilityEmailsSendCreateRequest
 */

/**
 * 200 response of POST /api/school/availability-emails/{school_id}/send/.
 * @typedef {Object} SchoolAvailabilityEmailsSendCreateResponse
 * @property {boolean} success
 * @property {string} school_id
 * @property {string} school_name
 * @property {number} sent_count
 * @property {number} [failed_count] Absent when nothing was pending.
 * @property {number} pending_count Addresses still pending after the send.
 * @property {string|null} [history_id] Absent when nothing was pending.
 * @property {string} message
 */

/**
 * Request body of POST /api/school/availability-notify/{school_id}/.
 * @typedef {Object} SchoolAvailabilityNotifyCreateRequest
 * @property {string} email
 */

/**
 * 200, 201 response of POST /api/school/availability-notify/{school_id}/.
 * @typedef {SchoolWaitlistEntry} SchoolAvailabilityNotifyCreateResponse
 */

/**
 * 200 response of GET /api/school/data-portal/{school_id}/.
 * @typedef {SchoolDataPortal} SchoolDataPortalRetrieveResponse
 */

/**
 * Request body of POST /api/school/data-portal/{school_id}/uploads/ (multipart/form-data).
 * @typedef {Object} SchoolDataPortalUploadsCreateRequest
 * @property {string} dataset_key
 * @property {Blob} file
 * @property {string} [notes]
 */

/**
 * 201 response of POST /api/school/data-portal/{school_id}/uploads/.
 * @typedef {Object} SchoolDataPortalUploadsCreateResponse
 * @property {boolean} success
 * @property {boolean} stored
 * @property {SchoolDataUpload} upload
 */

/**
 * 200 response of DELETE /api/school/data-portal/{school_id}/uploads/{upload_id}/.
 * @typedef {Object} SchoolDataPortalUploadsDestroyResponse
 * @property {boolean} success
 */

/**
 * Request body of POST /api/school/merchant-interest/{school_id}/.
 * @typedef {Object} SchoolMerchantInterestCreateRequest
 * @property {string} restaurant_name
 * @property {string} contact_name
 * @property {string} email
 * @property {string} [phone] Cut to 50 characters.
 * @property {string} [location] Cut to 300 characters.
 * @property {string} [website] Cut to 500 characters.
 * @property {string} [merchant_id] Cut to 100 characters.
 * @property {string} [notes]
 */

/**
 * 201 response of POST /api/school/merchant-interest/{school_id}/.
 * @typedef {SchoolCreatedId} SchoolMerchantInterestCreateResponse
 */

/**
 * 200 response of GET /api/school/merchants-page-config/{school_id}/.
 * @typedef {SchoolMerchantsPageConfig} SchoolMerchantsPageConfigRetrieveResponse
 */

/**
 * 200 response of GET /api/school/onboarding/{school_id}/.
 * @typedef {Object} SchoolOnboardingRetrieveResponse
 * @property {SchoolBrandStub} school
 * @property {SchoolOnboardingTimeline} timeline
 */

/**
 * 200 response of GET /api/school/public-schools/.
 * @typedef {Object} SchoolPublicSchoolsRetrieveResponse
 * @property {number} count
 * @property {Array<School>} results
 */

/**
 * 200 response of GET /api/school/reward-selections/{school_id}/.
 * @typedef {Object} SchoolRewardSelectionsRetrieveResponse
 * @property {SchoolBrandStub} school
 * @property {SchoolRewardSelections} reward_selections
 */

/**
 * Request body of POST /api/school/schedule-events/{id}/check-in/.
 * @typedef {Object} SchoolScheduleEventsCheckInCreateRequest
 * @property {number} latitude
 * @property {number} longitude
 */

/**
 * 201 response of POST /api/school/schedule-events/{id}/check-in/.
 * @typedef {Object} SchoolScheduleEventsCheckInCreateResponse
 * @property {boolean} success
 * @property {string} message
 * @property {number} points_awarded
 * @property {{id: string, event_id: string, distance_meters: number, points_awarded: number, created_at: string|null}} check_in
 */

/**
 * Request body of POST /api/school/schedule-events/.
 * @typedef {ScheduleEventRequest} SchoolScheduleEventsCreateRequest
 */

/**
 * 201 response of POST /api/school/schedule-events/.
 * @typedef {SchoolScheduleEvent} SchoolScheduleEventsCreateResponse
 */

/**
 * 200 response of GET /api/school/schedule-events/.
 * @typedef {Array<SchoolScheduleEvent>} SchoolScheduleEventsListResponse
 */

/**
 * Request body of PATCH /api/school/schedule-events/{id}/.
 * @typedef {PatchedScheduleEventRequest} SchoolScheduleEventsPartialUpdateRequest
 */

/**
 * 200 response of PATCH /api/school/schedule-events/{id}/.
 * @typedef {SchoolScheduleEvent} SchoolScheduleEventsPartialUpdateResponse
 */

/**
 * Request body of POST /api/school/schedule-events/{id}/photos/.
 * @typedef {SchoolGamePhotoUpload} SchoolScheduleEventsPhotosCreateRequest
 */

/**
 * 201 response of POST /api/school/schedule-events/{id}/photos/.
 * @typedef {SchoolGamePhoto} SchoolScheduleEventsPhotosCreateResponse
 */

/**
 * 200 response of GET /api/school/schedule-events/{id}/photos/.
 * @typedef {Object} SchoolScheduleEventsPhotosRetrieveResponse
 * @property {Array<SchoolGamePhoto & {user_id: string, email?: string}>} photos
 */

/**
 * Request body of POST /api/school/schedule-events/{id}/photos/{photo_id}/winner/.
 * @typedef {Object<string, *>} SchoolScheduleEventsPhotosWinnerCreateRequest
 */

/**
 * 200 response of POST /api/school/schedule-events/{id}/photos/{photo_id}/winner/.
 * @typedef {Object} SchoolScheduleEventsPhotosWinnerCreateResponse
 * @property {string} id
 * @property {boolean} is_winner
 */

/**
 * Request body of POST /api/school/schedule-events/{id}/predict/.
 * @typedef {Object} SchoolScheduleEventsPredictCreateRequest
 * @property {number} home_score
 * @property {number} away_score
 */

/**
 * 201 response of POST /api/school/schedule-events/{id}/predict/.
 * @typedef {Object} SchoolScheduleEventsPredictCreateResponse
 * @property {boolean} success
 * @property {string} message
 * @property {{id: string, event_id: string, home_score: number, away_score: number, created_at: string|null}} prediction
 */

/**
 * 200 response of GET /api/school/schedule-events/{id}/predictions/.
 * @typedef {Object} SchoolScheduleEventsPredictionsRetrieveResponse
 * @property {number} home_score Final home score.
 * @property {number} away_score Final away score.
 * @property {number} total
 * @property {number} offset
 * @property {number} limit
 * @property {boolean} has_more
 * @property {Array<{rank: number, user_id: string, name: string, display_name: string, avatar_url: string|null, home_score: number, away_score: number, error: number, is_you: boolean}>} results
 */

/**
 * 200 response of GET /api/school/schedule-events/{id}/.
 * @typedef {SchoolScheduleEvent} SchoolScheduleEventsRetrieveResponse
 */

/**
 * 200 response of GET /api/school/schedule-events/{id}/squad/.
 * @typedef {SchoolGameSquad} SchoolScheduleEventsSquadRetrieveResponse
 */

/**
 * Request body of POST /api/school/schedule-events/{id}/tap/.
 * @typedef {Object<string, *>} SchoolScheduleEventsTapCreateRequest
 */

/**
 * 200 response of POST /api/school/schedule-events/{id}/tap/.
 * @typedef {SchoolTapGame} SchoolScheduleEventsTapCreateResponse
 */

/**
 * Request body of POST /api/school/schedule-events/{id}/tap/enter/.
 * @typedef {Object} SchoolScheduleEventsTapEnterCreateRequest
 * @property {'0-10'|'11-18'|'19-29'|'30-39'|'41-59'|'60+'} age_range
 */

/**
 * 200 response of POST /api/school/schedule-events/{id}/tap/enter/.
 * @typedef {SchoolTapGame} SchoolScheduleEventsTapEnterCreateResponse
 */

/**
 * Request body of POST /api/school/schedule-events/{id}/tap/reset/.
 * @typedef {Object<string, *>} SchoolScheduleEventsTapResetCreateRequest
 */

/**
 * 200 response of POST /api/school/schedule-events/{id}/tap/reset/.
 * @typedef {SchoolTapGame} SchoolScheduleEventsTapResetCreateResponse
 */

/**
 * Request body of PUT /api/school/schedule-events/{id}/.
 * @typedef {ScheduleEventRequest} SchoolScheduleEventsUpdateRequest
 */

/**
 * 200 response of PUT /api/school/schedule-events/{id}/.
 * @typedef {SchoolScheduleEvent} SchoolScheduleEventsUpdateResponse
 */

/**
 * Request body of POST /api/school/school-pay/mark-sent/.
 * @typedef {Object} SchoolSchoolPayMarkSentCreateRequest
 * @property {string} school
 * @property {string} period
 * @property {number} [amount_cents]
 * @property {number} [transaction_count]
 * @property {Array<Object<string, *>>} [line_items]
 * @property {boolean} [resend]
 */

/**
 * 200 response of POST /api/school/school-pay/mark-sent/.
 * @typedef {SchoolPaymentStatement} SchoolSchoolPayMarkSentCreateResponse
 */

/**
 * 200 response of GET /api/school/school-pay/overview/.
 * @typedef {Object} SchoolSchoolPayOverviewRetrieveResponse
 * @property {Array<SchoolPaymentStatement>} statements
 */

/**
 * Request body of POST /api/school/school-pay/unmark-sent/.
 * @typedef {Object} SchoolSchoolPayUnmarkSentCreateRequest
 * @property {string} school
 * @property {string} period
 */

/**
 * 200 response of POST /api/school/school-pay/unmark-sent/.
 * @typedef {SchoolPaymentStatement} SchoolSchoolPayUnmarkSentCreateResponse
 */

/**
 * 200 response of GET /api/school/schools/{id}/achievement-badges/.
 * @typedef {SchoolBadgeCatalog} SchoolSchoolsAchievementBadgesRetrieveResponse
 */

/**
 * Request body of PUT /api/school/schools/{id}/achievement-badges/.
 * @typedef {Array<string>|{slugs: Array<string>}} SchoolSchoolsAchievementBadgesUpdateRequest
 */

/**
 * 200 response of PUT /api/school/schools/{id}/achievement-badges/.
 * @typedef {SchoolBadgeCatalog} SchoolSchoolsAchievementBadgesUpdateResponse
 */

/**
 * Request body of POST /api/school/schools/{id}/achievement-badges/upload-image/ (multipart/form-data).
 * @typedef {SchoolImageUpload} SchoolSchoolsAchievementBadgesUploadImageCreateRequest
 */

/**
 * 200 response of POST /api/school/schools/{id}/achievement-badges/upload-image/.
 * @typedef {SchoolImageUrl} SchoolSchoolsAchievementBadgesUploadImageCreateResponse
 */

/**
 * Request body of POST /api/school/schools/.
 * @typedef {SchoolRequest} SchoolSchoolsCreateRequest
 */

/**
 * 201 response of POST /api/school/schools/.
 * @typedef {School} SchoolSchoolsCreateResponse
 */

/**
 * Request body of POST /api/school/schools/{id}/embed-api-key/.
 * @typedef {Object<string, *>} SchoolSchoolsEmbedApiKeyCreateRequest
 */

/**
 * 201 response of POST /api/school/schools/{id}/embed-api-key/.
 * @typedef {SchoolEmbedApiKey} SchoolSchoolsEmbedApiKeyCreateResponse
 */

/**
 * 200 response of GET /api/school/schools/{id}/embed-api-key/.
 * @typedef {SchoolEmbedApiKey} SchoolSchoolsEmbedApiKeyRetrieveResponse
 */

/**
 * Request body of POST /api/school/schools/{id}/embed-api-key/rotate/.
 * @typedef {Object<string, *>} SchoolSchoolsEmbedApiKeyRotateCreateRequest
 */

/**
 * 200 response of POST /api/school/schools/{id}/embed-api-key/rotate/.
 * @typedef {SchoolEmbedApiKey} SchoolSchoolsEmbedApiKeyRotateCreateResponse
 */

/**
 * Request body of POST /api/school/schools/{id}/embed-appearance/email-selection-background/ (multipart/form-data).
 * @typedef {SchoolBackgroundUpload} SchoolSchoolsEmbedAppearanceEmailSelectionBackgroundCreateRequest
 */

/**
 * 200 response of POST /api/school/schools/{id}/embed-appearance/email-selection-background/.
 * @typedef {SchoolEmbedAppearance} SchoolSchoolsEmbedAppearanceEmailSelectionBackgroundCreateResponse
 */

/**
 * Request body of POST /api/school/schools/{id}/embed-appearance/header-logo/ (multipart/form-data).
 * @typedef {Object} SchoolSchoolsEmbedAppearanceHeaderLogoCreateRequest
 * @property {Blob} [logo]
 * @property {Blob} [header_logo] Alternative name for `logo`.
 */

/**
 * 200 response of POST /api/school/schools/{id}/embed-appearance/header-logo/.
 * @typedef {SchoolEmbedAppearance} SchoolSchoolsEmbedAppearanceHeaderLogoCreateResponse
 */

/**
 * Request body of POST /api/school/schools/{id}/embed-appearance/login-background/ (multipart/form-data).
 * @typedef {SchoolBackgroundUpload} SchoolSchoolsEmbedAppearanceLoginBackgroundCreateRequest
 */

/**
 * 200 response of POST /api/school/schools/{id}/embed-appearance/login-background/.
 * @typedef {SchoolEmbedAppearance} SchoolSchoolsEmbedAppearanceLoginBackgroundCreateResponse
 */

/**
 * Request body of PATCH /api/school/schools/{id}/embed-appearance/.
 * @typedef {SchoolEmbedAppearanceChange} SchoolSchoolsEmbedAppearancePartialUpdateRequest
 */

/**
 * 200 response of PATCH /api/school/schools/{id}/embed-appearance/.
 * @typedef {SchoolEmbedAppearance} SchoolSchoolsEmbedAppearancePartialUpdateResponse
 */

/**
 * 200 response of GET /api/school/schools/{id}/embed-appearance/.
 * @typedef {SchoolEmbedAppearance} SchoolSchoolsEmbedAppearanceRetrieveResponse
 */

/**
 * Request body of POST /api/school/schools/{id}/embed-appearance/welcome-screen-image/ (multipart/form-data).
 * @typedef {SchoolBackgroundUpload} SchoolSchoolsEmbedAppearanceWelcomeScreenImageCreateRequest
 */

/**
 * 200 response of POST /api/school/schools/{id}/embed-appearance/welcome-screen-image/.
 * @typedef {SchoolEmbedAppearance} SchoolSchoolsEmbedAppearanceWelcomeScreenImageCreateResponse
 */

/**
 * 200 response of GET /api/school/schools/{id}/first-rewards/.
 * @typedef {Array<SchoolFirstReward>} SchoolSchoolsFirstRewardsRetrieveResponse
 */

/**
 * Request body of PUT /api/school/schools/{id}/first-rewards/.
 * @typedef {Array<SchoolFirstRewardWrite>} SchoolSchoolsFirstRewardsUpdateRequest
 */

/**
 * 200 response of PUT /api/school/schools/{id}/first-rewards/.
 * @typedef {Array<SchoolFirstReward>} SchoolSchoolsFirstRewardsUpdateResponse
 */

/**
 * Request body of POST /api/school/schools/{id}/first-rewards/upload-image/ (multipart/form-data).
 * @typedef {SchoolImageUpload} SchoolSchoolsFirstRewardsUploadImageCreateRequest
 */

/**
 * 200 response of POST /api/school/schools/{id}/first-rewards/upload-image/.
 * @typedef {SchoolImageUrl} SchoolSchoolsFirstRewardsUploadImageCreateResponse
 */

/**
 * Request body of PATCH /api/school/schools/{id}/leaderboard-config/.
 * @typedef {SchoolLeaderboardConfigChange} SchoolSchoolsLeaderboardConfigPartialUpdateRequest
 */

/**
 * 200 response of PATCH /api/school/schools/{id}/leaderboard-config/.
 * @typedef {SchoolLeaderboardConfig} SchoolSchoolsLeaderboardConfigPartialUpdateResponse
 */

/**
 * 200 response of GET /api/school/schools/{id}/leaderboard-config/.
 * @typedef {SchoolLeaderboardConfig} SchoolSchoolsLeaderboardConfigRetrieveResponse
 */

/**
 * 200 response of GET /api/school/schools/{id}/leaderboard-last-winner/.
 * @typedef {Object} SchoolSchoolsLeaderboardLastWinnerRetrieveResponse
 * @property {boolean} leaderboard_active
 * @property {Object<string, *>|null} winner
 * @property {string|null} week_current_start Start of the current period, ISO 8601.
 * @property {number|null} scoring_period_days
 */

/**
 * 200 response of GET /api/school/schools/.
 * @typedef {PaginatedSchoolList} SchoolSchoolsListResponse
 */

/**
 * Request body of PATCH /api/school/schools/{id}/onboarding_checked/.
 * @typedef {Object} SchoolSchoolsOnboardingCheckedPartialUpdateRequest
 * @property {string} key
 * @property {boolean} [checked]
 */

/**
 * 200 response of PATCH /api/school/schools/{id}/onboarding_checked/.
 * @typedef {Object} SchoolSchoolsOnboardingCheckedPartialUpdateResponse
 * @property {string} key
 * @property {boolean} checked
 */

/**
 * Request body of PATCH /api/school/schools/{id}/onboarding/.
 * @typedef {SchoolOnboardingTimeline} SchoolSchoolsOnboardingPartialUpdateRequest
 */

/**
 * 200 response of PATCH /api/school/schools/{id}/onboarding/.
 * @typedef {SchoolOnboardingTimeline} SchoolSchoolsOnboardingPartialUpdateResponse
 */

/**
 * Request body of PATCH /api/school/schools/{id}/.
 * @typedef {PatchedSchoolRequest} SchoolSchoolsPartialUpdateRequest
 */

/**
 * 200 response of PATCH /api/school/schools/{id}/.
 * @typedef {School & SchoolConversionWarnings} SchoolSchoolsPartialUpdateResponse
 */

/**
 * 200 response of GET /api/school/schools/{id}/.
 * @typedef {School} SchoolSchoolsRetrieveResponse
 */

/**
 * Request body of PATCH /api/school/schools/{id}/reward_selections/.
 * @typedef {SchoolRewardSelections} SchoolSchoolsRewardSelectionsPartialUpdateRequest
 */

/**
 * 200 response of PATCH /api/school/schools/{id}/reward_selections/.
 * @typedef {SchoolRewardSelections} SchoolSchoolsRewardSelectionsPartialUpdateResponse
 */

/**
 * 200 response of GET /api/school/schools/{id}/season-tickets/.
 * @typedef {Object} SchoolSchoolsSeasonTicketsRetrieveResponse
 * @property {Array<SchoolSeasonTicketHold>} holds
 */

/**
 * Request body of PUT /api/school/schools/{id}/season-tickets/.
 * @typedef {Object} SchoolSchoolsSeasonTicketsUpdateRequest
 * @property {string} [user_id]
 * @property {string} [email]
 * @property {string} started_on
 */

/**
 * 200 response of PUT /api/school/schools/{id}/season-tickets/.
 * @typedef {SchoolSeasonTicketHold} SchoolSchoolsSeasonTicketsUpdateResponse
 */

/**
 * Request body of PUT /api/school/schools/{id}/.
 * @typedef {SchoolRequest} SchoolSchoolsUpdateRequest
 */

/**
 * 200 response of PUT /api/school/schools/{id}/.
 * @typedef {School & SchoolConversionWarnings} SchoolSchoolsUpdateResponse
 */

/**
 * Request body of POST /api/school/schools/{id}/upload_images/ (multipart/form-data).
 * @typedef {Object} SchoolSchoolsUploadImagesCreateRequest
 * @property {Blob} [logo]
 * @property {Blob} [banner]
 */

/**
 * 200 response of POST /api/school/schools/{id}/upload_images/.
 * @typedef {Object} SchoolSchoolsUploadImagesCreateResponse
 * @property {string} [logo_url]
 * @property {string} [banner_url]
 */

/**
 * Request body of POST /api/school/sport-schedules/.
 * @typedef {SportScheduleRequest} SchoolSportSchedulesCreateRequest
 */

/**
 * 201 response of POST /api/school/sport-schedules/.
 * @typedef {SportSchedule} SchoolSportSchedulesCreateResponse
 */

/**
 * 200 response of GET /api/school/sport-schedules/.
 * @typedef {Array<SportSchedule>} SchoolSportSchedulesListResponse
 */

/**
 * Request body of PATCH /api/school/sport-schedules/{id}/.
 * @typedef {PatchedSportScheduleRequest} SchoolSportSchedulesPartialUpdateRequest
 */

/**
 * 200 response of PATCH /api/school/sport-schedules/{id}/.
 * @typedef {SportSchedule} SchoolSportSchedulesPartialUpdateResponse
 */

/**
 * 200 response of GET /api/school/sport-schedules/{id}/.
 * @typedef {SportSchedule} SchoolSportSchedulesRetrieveResponse
 */

/**
 * Request body of PUT /api/school/sport-schedules/{id}/.
 * @typedef {SportScheduleRequest} SchoolSportSchedulesUpdateRequest
 */

/**
 * 200 response of PUT /api/school/sport-schedules/{id}/.
 * @typedef {SportSchedule} SchoolSportSchedulesUpdateResponse
 */

/**
 * 200 response of GET /api/school/upcoming-events/{school_id}/.
 * @typedef {Object} SchoolUpcomingEventsRetrieveResponse
 * @property {{id: string, name: string, abbreviation: string, mascot: string, image: string, primary_color: string, secondary_color: string}} school Empty strings where a value is not set.
 * @property {Array<SchoolPublicGame>} results
 * @property {number} count The number of games in `results`.
 */

/**
 * 200 response of GET /api/social/squads/{squad_id}/activity/.
 * @typedef {Object} SocialSquadsActivityRetrieveResponse
 * @property {Array<SocialSquadActivity>} activity
 */

/**
 * 200 response of GET /api/social/squads/admin/.
 * @typedef {Object} SocialSquadsAdminRetrieveResponse
 * @property {{squads: number, members: number, schools: number, games_attended: number, predictions_made: number}} summary
 * @property {Array<SocialSquadAdminRow>} squads
 */

/**
 * Request body of POST /api/social/squads/.
 * @typedef {SocialSquadWrite} SocialSquadsCreateRequest
 */

/**
 * 201 response of POST /api/social/squads/.
 * @typedef {SocialSquadDetail} SocialSquadsCreateResponse
 */

/**
 * 200 response of DELETE /api/social/squads/{squad_id}/.
 * @typedef {SocialOk} SocialSquadsDestroyResponse
 */

/**
 * 200 response of GET /api/social/squads/game-winners/.
 * @typedef {Object} SocialSquadsGameWinnersRetrieveResponse
 * @property {Array<SocialSquadGameWinners>} squads
 */

/**
 * Request body of POST /api/social/squads/join/.
 * @typedef {SocialSquadJoin} SocialSquadsJoinCreateRequest
 */

/**
 * 200 response of POST /api/social/squads/join/.
 * @typedef {SocialSquadDetail} SocialSquadsJoinCreateResponse
 */

/**
 * 200 response of POST /api/social/squads/{squad_id}/leave/.
 * @typedef {SocialOk} SocialSquadsLeaveCreateResponse
 */

/**
 * 200 response of DELETE /api/social/squads/{squad_id}/members/{user_id}/.
 * @typedef {SocialSquadDetail} SocialSquadsMembersDestroyResponse
 */

/**
 * Request body of PATCH /api/social/squads/{squad_id}/.
 * @typedef {SocialSquadWrite} SocialSquadsPartialUpdateRequest
 */

/**
 * 200 response of PATCH /api/social/squads/{squad_id}/.
 * @typedef {SocialSquadDetail} SocialSquadsPartialUpdateResponse
 */

/**
 * 200 response of GET /api/social/squads/.
 * @typedef {Object} SocialSquadsRetrieveResponse
 * @property {Array<SocialSquadCard>} squads
 */

/**
 * 200 response of GET /api/social/squads/{squad_id}/.
 * @typedef {SocialSquadDetail} SocialSquadsRetrieve2Response
 */

/**
 * 200 response of GET /api/social/squads/standings/.
 * @typedef {Object} SocialSquadsStandingsRetrieveResponse
 * @property {Array<SocialSquadStanding>} squads
 */

/**
 * 200 response of GET /api/social/twitter/feed/.
 * @typedef {SocialTwitterFeed} SocialTwitterFeedRetrieveResponse
 */

/**
 * Request body of POST /api/token/.
 * @typedef {CustomTokenObtainPairRequest & AuthPushDevice} TokenCreateRequest
 */

/**
 * 200 response of POST /api/token/.
 * @typedef {AuthTokens} TokenCreateResponse
 */

/**
 * Request body of POST /api/token/refresh/.
 * @typedef {TokenRefreshRequest} TokenRefreshCreateRequest
 */

/**
 * 200 response of POST /api/token/refresh/.
 * @typedef {TokenRefresh} TokenRefreshCreateResponse
 */

/**
 * Request body of POST /api/transactions/.
 * @typedef {TransactionRequest} TransactionsCreateRequest
 */

/**
 * 200 response of GET /api/transactions/.
 * @typedef {Array<TransactionsEntry|TransactionsStaffEntry>} TransactionsListResponse
 */

/**
 * Request body of PATCH /api/transactions/{id}/.
 * @typedef {PatchedTransactionRequest} TransactionsPartialUpdateRequest
 */

/**
 * 200 response of PATCH /api/transactions/{id}/.
 * @typedef {TransactionsEntry} TransactionsPartialUpdateResponse
 */

/**
 * 200 response of GET /api/transactions/{id}/.
 * @typedef {TransactionsEntry} TransactionsRetrieveResponse
 */

/**
 * Request body of PUT /api/transactions/{id}/.
 * @typedef {TransactionRequest} TransactionsUpdateRequest
 */

/**
 * 200 response of PUT /api/transactions/{id}/.
 * @typedef {TransactionsEntry} TransactionsUpdateResponse
 */

/**
 * 200 (text/html) response of GET /api/travel/embed/.
 * @typedef {string} TravelEmbedRetrieveResponse
 */

/**
 * 200 response of POST /api/travel/session/.
 * @typedef {TravelSession} TravelSessionCreateResponse
 */

/**
 * Request body of POST /api/users/check-in/.
 * @typedef {UsersCheckInRequest} UsersCheckInCreateRequest
 */

/**
 * 201 response of POST /api/users/check-in/.
 * @typedef {UsersCheckInResult} UsersCheckInCreateResponse
 */

/**
 * 200 response of GET /api/users/check-in/locations/.
 * @typedef {UsersCheckInLocations} UsersCheckInLocationsRetrieveResponse
 */

/**
 * Request body of POST /api/users/contact-support/.
 * @typedef {UsersContactSupportRequest} UsersContactSupportCreateRequest
 */

/**
 * 200 response of POST /api/users/contact-support/.
 * @typedef {UsersSuccessMessage} UsersContactSupportCreateResponse
 */

/**
 * 200 (text/html) response of POST /api/users/fan-emails/unsubscribe/{token}/.
 * @typedef {string} UsersFanEmailsUnsubscribeCreateResponse
 */

/**
 * 200 (text/html) response of GET /api/users/fan-emails/unsubscribe/{token}/.
 * @typedef {string} UsersFanEmailsUnsubscribeRetrieveResponse
 */

/**
 * 200 response of GET /api/users/leaderboard/.
 * @typedef {UsersWeeklyLeaderboard} UsersLeaderboardRetrieveResponse
 */

/**
 * 200 response of GET /api/users/managed-docs/embedding/.
 * @typedef {UsersManagedDocument} UsersManagedDocsEmbeddingRetrieveResponse
 */

/**
 * 200 response of GET /api/users/managed-links/.
 * @typedef {UsersManagedLinks} UsersManagedLinksRetrieveResponse
 */

/**
 * 200 response of GET /api/users/public-profile/{fan_id}/.
 * @typedef {UsersPublicProfile} UsersPublicProfileRetrieveResponse
 */

/**
 * 200 response of GET /api/users/referral-leaderboard/.
 * @typedef {UsersReferralLeaderboard} UsersReferralLeaderboardRetrieveResponse
 */

/**
 * Request body of POST /api/users/resend-verification-email/.
 * @typedef {UsersResendVerificationRequest} UsersResendVerificationEmailCreateRequest
 */

/**
 * 200 response of POST /api/users/resend-verification-email/.
 * @typedef {UsersSuccessMessage} UsersResendVerificationEmailCreateResponse
 */

/**
 * 200 response of POST /api/users/support-thread/read/.
 * @typedef {UsersSupportRead} UsersSupportThreadReadCreateResponse
 */

/**
 * Request body of POST /api/users/support-thread/reply/.
 * @typedef {UsersSupportReplyRequest} UsersSupportThreadReplyCreateRequest
 */

/**
 * 200 response of POST /api/users/support-thread/reply/.
 * @typedef {UsersSupportThread} UsersSupportThreadReplyCreateResponse
 */

/**
 * 200 response of GET /api/users/support-thread/.
 * @typedef {UsersSupportThread} UsersSupportThreadRetrieveResponse
 */

/**
 * Request body of POST /api/users/upload-receipt/ (multipart/form-data).
 * @typedef {UsersUploadReceiptRequest} UsersUploadReceiptCreateRequest
 */

/**
 * 200 response of POST /api/users/upload-receipt/.
 * @typedef {UsersReceiptUploaded} UsersUploadReceiptCreateResponse
 */

/**
 * Request body of POST /api/users/user-schools/.
 * @typedef {UserSchoolRequest} UsersUserSchoolsCreateRequest
 */

/**
 * 200 response of GET /api/users/user-schools/.
 * @typedef {UsersUserSchoolPage} UsersUserSchoolsListResponse
 */

/**
 * Request body of PATCH /api/users/user-schools/{id}/.
 * @typedef {PatchedUserSchoolRequest} UsersUserSchoolsPartialUpdateRequest
 */

/**
 * 200 response of PATCH /api/users/user-schools/{id}/.
 * @typedef {UsersUserSchool} UsersUserSchoolsPartialUpdateResponse
 */

/**
 * 200 response of GET /api/users/user-schools/{id}/.
 * @typedef {UsersUserSchool} UsersUserSchoolsRetrieveResponse
 */

/**
 * Request body of PUT /api/users/user-schools/{id}/.
 * @typedef {UserSchoolRequest} UsersUserSchoolsUpdateRequest
 */

/**
 * 200 response of PUT /api/users/user-schools/{id}/.
 * @typedef {UsersUserSchool} UsersUserSchoolsUpdateResponse
 */

/**
 * Request body of POST /api/users/users/assign-school/.
 * @typedef {UsersAssignSchoolRequest} UsersUsersAssignSchoolCreateRequest
 */

/**
 * 200 response of POST /api/users/users/assign-school/.
 * @typedef {UsersAssignSchoolUserResult} UsersUsersAssignSchoolCreateResponse
 */

/**
 * Request body of POST /api/users/users/.
 * @typedef {ScopedUserRequest} UsersUsersCreateRequest
 */

/**
 * 201 response of POST /api/users/users/.
 * @typedef {UsersFan} UsersUsersCreateResponse
 */

/**
 * Request body of POST /api/users/users/invite-friend/.
 * @typedef {UsersInviteFriendRequest} UsersUsersInviteFriendCreateRequest
 */

/**
 * 200 response of POST /api/users/users/invite-friend/.
 * @typedef {UsersInviteSent} UsersUsersInviteFriendCreateResponse
 */

/**
 * 200 response of GET /api/users/users/.
 * @typedef {UsersFanPage} UsersUsersListResponse
 */

/**
 * Request body of PATCH /api/users/users/{id}/.
 * @typedef {PatchedScopedUserRequest} UsersUsersPartialUpdateRequest
 */

/**
 * 200 response of PATCH /api/users/users/{id}/.
 * @typedef {UsersFan} UsersUsersPartialUpdateResponse
 */

/**
 * 200 response of GET /api/users/users/{id}/points_summary/.
 * @typedef {UsersPointsSummary} UsersUsersPointsSummaryRetrieveResponse
 */

/**
 * Request body of PATCH /api/users/users/profile/.
 * @typedef {UsersProfileUpdateRequest} UsersUsersProfilePartialUpdateRequest
 */

/**
 * 200 response of PATCH /api/users/users/profile/.
 * @typedef {UsersProfile} UsersUsersProfilePartialUpdateResponse
 */

/**
 * 200 response of GET /api/users/users/profile/.
 * @typedef {UsersFan} UsersUsersProfileRetrieveResponse
 */

/**
 * 200 response of GET /api/users/users/referral-campaign/.
 * @typedef {UsersReferralCampaignResult} UsersUsersReferralCampaignRetrieveResponse
 */

/**
 * 200 response of GET /api/users/users/referral-summary/.
 * @typedef {UsersReferralSummary} UsersUsersReferralSummaryRetrieveResponse
 */

/**
 * 200 response of GET /api/users/users/{id}/.
 * @typedef {UsersFan} UsersUsersRetrieveResponse
 */

/**
 * Request body of PUT /api/users/users/{id}/.
 * @typedef {ScopedUserRequest} UsersUsersUpdateRequest
 */

/**
 * 200 response of PUT /api/users/users/{id}/.
 * @typedef {UsersFan} UsersUsersUpdateResponse
 */

/**
 * Request body of POST /api/users/verify-email/.
 * @typedef {UsersVerifyEmailRequest} UsersVerifyEmailCreateRequest
 */

/**
 * 200 response of POST /api/users/verify-email/.
 * @typedef {UsersSuccessMessage} UsersVerifyEmailCreateResponse
 */

/**
 * 200 response of GET /api/wildfire/merchant/.
 * @typedef {Object} WildfireMerchantRetrieveResponse
 * @property {boolean} success
 * @property {MerchantWildfireMerchant & {rates?: Array<{id?: *, name?: string, kind?: *, amount?: *, currency?: *}>, exclusions?: *}} merchant
 */

/**
 * 200 response of GET /api/wildfire/offers/.
 * @typedef {Object} WildfireOffersRetrieveResponse
 * @property {boolean} success
 * @property {Array<*>} cardlinked Always empty.
 * @property {Array<MerchantWildfireMerchant>} click
 * @property {{currentPage?: number, pageSize?: number, totalClickAvailable?: number, totalCardlinkedAvailable?: number, hasMoreClick?: boolean, hasMoreCardlinked?: boolean}} pagination
 * @property {{resolved_app_id?: number|string, source?: 'embed-param'|'settings'}} [debug]
 */

/**
 * 200 response of GET /api/wildfire/track-click/.
 * @typedef {Object} WildfireTrackClickRetrieveResponse
 * @property {boolean} success
 * @property {string} [tracking_url]
 * @property {string} [website]
 * @property {string} [error] Only when `success` is false.
 * @property {Object<string, *>} [timing_ms]
 */

/**
 * 200 response of GET /api/wildfire/warm-device/.
 * @typedef {MerchantWarmDevice} WildfireWarmDeviceRetrieveResponse
 */
